!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("mobx"), require("ramda"), require("uuid"), require("@miriamtech/if2-core"), require("js-quantities"), require("moment"), require("sanitize-filename")) : "function" == typeof define && define.amd ? define(["mobx", "ramda", "uuid", "@miriamtech/if2-core", "js-quantities", "moment", "sanitize-filename"], e) : "object" == typeof exports ? exports.jsModel = e(require("mobx"), require("ramda"), require("uuid"), require("@miriamtech/if2-core"), require("js-quantities"), require("moment"), require("sanitize-filename")) : t.jsModel = e(t.mobx, t.ramda, t.uuid, t["@miriamtech/if2-core"], t["js-quantities"], t.moment, t["sanitize-filename"]);
}("undefined" != typeof self ? self : this, (t, e, r, n, o, i, c) => (() => {
  var u = {
      286: (t, e, r) => {
        var n = {
          "./crop-label.json": 897,
          "./crop-label/v0.json": 768,
          "./crop-label/v1.json": 355,
          "./field.json": 824,
          "./field/geo-json.json": 67,
          "./field/v0.json": 115,
          "./field/v1.json": 776,
          "./mode-of-action.json": 228,
          "./mode-of-action/v0.json": 607,
          "./mode-of-action/v1.json": 564,
          "./organic-listing.json": 296,
          "./organic-listing/v0.json": 803,
          "./organic-listing/v1.json": 56,
          "./product.json": 731,
          "./product/active-ingredient.json": 782,
          "./product/active-ingredient/v0.json": 597,
          "./product/active-ingredient/v1.json": 866,
          "./product/attachment.json": 845,
          "./product/attachment/v0.json": 372,
          "./product/attachment/v1.json": 95,
          "./product/nutrient-analysis.json": 828,
          "./product/v0.json": 366,
          "./product/v1.json": 721,
          "./recommendation/product-application.json": 852,
          "./recommendation/product-application/v0.json": 847,
          "./recommendation/product-application/v1.json": 308
        };
        function o(t) {
          var e = i(t);
          return r(e);
        }
        function i(t) {
          if (!r.o(n, t)) {
            var e = new Error("Cannot find module '" + t + "'");
            throw e.code = "MODULE_NOT_FOUND", e;
          }
          return n[t];
        }
        o.keys = function () {
          return Object.keys(n);
        }, o.resolve = i, t.exports = o, o.id = 286;
      },
      683: t => {
        "use strict";

        t.exports = n;
      },
      211: t => {
        "use strict";

        t.exports = o;
      },
      314: e => {
        "use strict";

        e.exports = t;
      },
      416: t => {
        "use strict";

        t.exports = i;
      },
      871: t => {
        "use strict";

        t.exports = e;
      },
      619: t => {
        "use strict";

        t.exports = c;
      },
      315: t => {
        "use strict";

        t.exports = r;
      },
      897: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/crop_label","oneOf":[{"$ref":"./crop_label/v0"},{"$ref":"./crop_label/v1"}]}');
      },
      768: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/crop_label/v0","type":"object","properties":{"type":{"enum":["IF2::Product::CropLabel","IF2::ProductCropLabel"]},"id":{"type":"string"},"serial":{"type":"integer"},"application_methods":{"type":"array","items":{"type":"string"}},"crop":{"type":["null","string"]},"crop_id":{"type":["null","string"]},"max_applications_per_year":{"type":["null","integer"]},"max_per_application":{"type":["null","string"]},"max_per_year":{"type":["null","string"]},"max_spray_rate":{"type":["null","string"]},"min_spray_rate":{"type":["null","string"]},"min_treatment_interval":{"type":["null","string"]},"product_id":{"type":["null","integer"]},"phi":{"type":["null","string"]},"rei":{"type":"string"},"old_crop_snapshot":{"type":["null","object"]},"special_conditions":{"oneOf":[{"type":"object","additionalProperties":{"type":"string"}},{"type":"null"}]},"updated_at":{"type":"string"},"created_at":{"type":"string"},"updatedAt":{"type":"string"},"createdAt":{"type":"string"}},"required":["type","id","serial","application_methods","crop","phi","rei","updated_at","created_at"],"additionalProperties":false}');
      },
      355: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/crop_label/v1","type":"object","properties":{"schema":{"const":"if2/product/crop_label/v1"},"type":{"const":"IF2::Product::CropLabel"},"id":{"type":"string"},"serial":{"type":"integer"},"application_methods":{"type":"array","items":{"type":"string"}},"crop":{"type":"string"},"max_applications_per_year":{"type":["null","integer"]},"max_per_application":{"type":["null","string"]},"max_per_year":{"type":["null","string"]},"max_spray_rate":{"type":["null","string"]},"min_spray_rate":{"type":["null","string"]},"min_treatment_interval":{"type":["null","string"]},"product_id":{"type":"integer"},"phi":{"type":["null","string"]},"rei":{"type":"string"},"special_conditions":{"oneOf":[{"type":"object","additionalProperties":{"type":"string"}},{"type":"null"}]},"updated_at":{"type":"string"},"created_at":{"type":"string"}},"required":["schema","type","id","serial","product_id","phi","rei","min_spray_rate","max_per_application","max_per_year","special_conditions","application_methods","max_applications_per_year","min_treatment_interval","max_spray_rate","crop","updated_at","created_at"],"additionalProperties":false}');
      },
      824: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/field","oneOf":[{"$ref":"./field/v0"},{"$ref":"./field/v1"}]}');
      },
      67: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/field/geo_json","anyOf":[{"type":"null"},{"type":"object","properties":{"type":{"type":"string"}},"required":["type"]}]}');
      },
      115: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/field/v0","type":"object","properties":{"type":{"const":"IF2::Field"},"id":{"type":"string"},"serial":{"type":"integer"},"created_at":{"type":"string"},"createdAt":{"type":"string"},"updated_at":{"type":"string"},"updatedAt":{"type":"string"},"name":{"type":"string"},"area":{"type":"string"},"acres":{"type":"null"},"row_spacing":{"type":["string","null"]},"rowSpacing":{"type":["string","null"]},"plant_spacing":{"type":["string","null"]},"plantSpacing":{"type":["string","null"]},"tree_density":{"type":["string","null"]},"treeDensity":{"type":["string","null"]},"irrigation_rate":{"type":["string","null"]},"irrigationRate":{"type":["string","null"]},"elevation":{"type":["string","null"]},"county":{"type":["string","null"]},"notes":{"type":["string","null"]},"accounting_reference":{"type":["string","null"]},"accountingReference":{"type":["string","null"]},"nearest_region":{"type":["string","null"]},"nearestRegion":{"type":["string","null"]},"harvest_lot":{"type":["string","null"]},"harvestLot":{"type":["string","null"]},"previous_crop":{"type":["string","null"]},"previousCrop":{"type":["string","null"]},"year_planted":{"type":["integer","string","null"]},"yearPlanted":{"type":["integer","string","null"]},"latitude":{"type":["string","null"]},"longitude":{"type":["string","null"]},"geo_json":{"oneOf":[{"$ref":"./geo_json"},{"type":"string"}]},"geoJson":{"oneOf":[{"$ref":"./geo_json"},{"type":"string"}]},"inactive":{"type":"boolean"},"non_bearing":{"type":"boolean"},"nonBearing":{"type":"boolean"},"acid_water_treatment":{"type":"boolean"},"acidWaterTreatment":{"type":"boolean"},"organic":{"type":"boolean"},"transitional":{"type":"boolean"},"organic_date":{"type":["string","null"]},"organicDate":{"type":["string","null"]},"transitional_date":{"type":["string","null"]},"transitionalDate":{"type":["string","null"]},"account":{"$ref":"#/$defs/account_reference"},"crop":{"$ref":"#/$defs/crop_reference"},"varieties":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"root_stocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"rootStocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"cultivars":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}},"use_types":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}},"useTypes":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}}},"required":["type","id","serial","created_at","updated_at","name","area","row_spacing","county","notes","year_planted","latitude","longitude","geo_json","organic","organic_date","account","crop"],"additionalProperties":false,"$defs":{"account_reference":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":["null","string"]},"fullName":{"type":"string"},"client_path":{"type":"array","items":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":["null","string"]}},"required":["id","serial","name"],"additionalProperties":false}},"clientPath":{"type":"array","items":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"fullName":{"type":["null","string"]}},"required":["id","serial","name"],"additionalProperties":false}}},"required":["id","serial","name","client_path"],"additionalProperties":false},"crop_reference":{"type":"object","properties":{"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"varieties":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"root_stocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"rootStocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"cultivars":{"type":"array","items":{"$ref":"#/$defs/cultivar_reference"}},"use_types":{"type":"array","items":{"oneOf":[{"$ref":"#/$defs/presentation_reference"},{"type":"string"}]}},"useTypes":{"type":"array","items":{"oneOf":[{"$ref":"#/$defs/presentation_reference"},{"type":"string"}]}}},"required":["id","name"],"additionalProperties":false},"presentation_percentage_reference":{"type":"object","properties":{"name":{"type":"string"},"percentage":{"type":["string","null"]},"percent":{"type":["string","null"]}},"required":["name"],"additionalProperties":false},"presentation_reference":{"type":"object","properties":{"name":{"type":"string"}},"required":["name"],"additionalProperties":false},"cultivar_reference":{"type":"object","properties":{"name":{"type":"string"},"variety":{"type":["null","string"]}},"required":["name"],"additionalProperties":false}}}');
      },
      776: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/field/v1","type":"object","properties":{"schema":{"const":"if2/field/v1"},"type":{"const":"IF2::Field"},"id":{"type":"string"},"serial":{"type":"integer"},"created_at":{"type":"string"},"createdAt":{"type":"string"},"updated_at":{"type":"string"},"updatedAt":{"type":"string"},"name":{"type":"string"},"area":{"type":"string"},"row_spacing":{"type":["string","null"]},"rowSpacing":{"type":["string","null"]},"plant_spacing":{"type":["string","null"]},"plantSpacing":{"type":["string","null"]},"tree_density":{"type":["string","null"]},"treeDensity":{"type":["string","null"]},"irrigation_rate":{"type":["string","null"]},"irrigationRate":{"type":["string","null"]},"elevation":{"type":["string","null"]},"county":{"type":["string","null"]},"notes":{"type":["string","null"]},"accounting_reference":{"type":["string","null"]},"accountingReference":{"type":["string","null"]},"nearest_region":{"type":["string","null"]},"nearestRegion":{"type":["string","null"]},"harvest_lot":{"type":["string","null"]},"harvestLot":{"type":["string","null"]},"previous_crop":{"type":["string","null"]},"previousCrop":{"type":["string","null"]},"year_planted":{"type":["integer","null"]},"yearPlanted":{"type":["integer","null"]},"latitude":{"type":["string","null"]},"longitude":{"type":["string","null"]},"geo_json":{"$ref":"./geo_json"},"geoJson":{"$ref":"./geo_json"},"inactive":{"type":"boolean"},"non_bearing":{"type":"boolean"},"nonBearing":{"type":"boolean"},"acid_water_treatment":{"type":"boolean"},"acidWaterTreatment":{"type":"boolean"},"organic":{"type":"boolean"},"transitional":{"type":"boolean"},"organic_date":{"type":["string","null"]},"organicDate":{"type":["string","null"]},"transitional_date":{"type":["string","null"]},"transitionalDate":{"type":["string","null"]},"account":{"$ref":"#/$defs/account_reference"},"crop":{"$ref":"#/$defs/crop_reference"},"varieties":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"root_stocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"rootStocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"cultivars":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}},"use_types":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}},"useTypes":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}}},"required":["schema","type","id","serial","created_at","updated_at","name","area","row_spacing","plant_spacing","tree_density","irrigation_rate","elevation","county","notes","accounting_reference","nearest_region","harvest_lot","previous_crop","year_planted","latitude","longitude","geo_json","inactive","non_bearing","acid_water_treatment","organic","transitional","organic_date","transitional_date","account","crop"],"additionalProperties":false,"$defs":{"account_reference":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":"string"},"fullName":{"type":"string"},"client_path":{"type":"array","items":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":"string"}},"required":["type","id","serial","name","full_name"],"additionalProperties":false}},"clientPath":{"type":"array","items":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"fullName":{"type":"string"}},"required":["type","id","serial","name","fullName"],"additionalProperties":false}}},"required":["type","id","serial","name","full_name","client_path"],"additionalProperties":false},"crop_reference":{"type":"object","properties":{"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"varieties":{"type":"array","items":{"$ref":"#/$defs/crop_presentation_percentage_reference"}},"root_stocks":{"type":"array","items":{"$ref":"#/$defs/crop_presentation_percentage_reference"}},"rootStocks":{"type":"array","items":{"$ref":"#/$defs/crop_presentation_percentage_reference"}},"cultivars":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}},"use_types":{"type":"array","items":{"type":"string"}},"useTypes":{"type":"array","items":{"type":"string"}}},"required":["id","name"],"additionalProperties":false},"presentation_percentage_reference":{"type":"object","properties":{"name":{"type":"string"},"percentage":{"oneOf":[{"type":"number","minimum":0,"maximum":1},{"type":"null"}]}},"required":["name","percentage"],"additionalProperties":false},"crop_presentation_percentage_reference":{"type":"object","properties":{"name":{"type":"string"},"percentage":{"type":["string","null"]},"percent":{"type":["string","null"]}},"required":["name","percent"],"additionalProperties":false},"presentation_reference":{"type":"object","properties":{"name":{"type":"string"}},"required":["name"],"additionalProperties":false}}}');
      },
      228: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/mode_of_action","oneOf":[{"$ref":"./mode_of_action/v0"},{"$ref":"./mode_of_action/v1"}]}');
      },
      607: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/mode_of_action/v0","type":"object","properties":{"type":{"const":"IF2::ModeOfAction"},"id":{"type":"string"},"action":{"type":"string"},"group_number":{"type":"string"},"description":{"type":"string"},"parent":{"oneOf":[{"type":"null"},{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"group_number":{"type":"string"},"description":{"type":"string"}},"required":["type","id","group_number","description"],"additionalProperties":false}]}},"required":["type","id","action","group_number","description"],"additionalProperties":false}');
      },
      564: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/mode_of_action/v1","type":"object","properties":{"schema":{"const":"if2/mode_of_action/v1"},"type":{"const":"IF2::ModeOfAction"},"id":{"type":"string"},"action":{"type":"string"},"group_number":{"type":"string"},"description":{"type":"string"},"parent":{"oneOf":[{"type":"null"},{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"group_number":{"type":"string"},"description":{"type":"string"}},"required":["type","id","group_number","description"],"additionalProperties":false}]}},"required":["schema","type","id","action","group_number","description","parent"],"additionalProperties":false}');
      },
      296: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/organic_listing","oneOf":[{"$ref":"https://schemas.miriamtech.com/if2/product/organic_listing/v0"},{"$ref":"https://schemas.miriamtech.com/if2/product/organic_listing/v1"}]}');
      },
      803: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/organic_listing/v0","type":"object","properties":{"type":{"enum":["IF2::Product::OrganicListing","IF2::ProductOrganicListing"]},"id":{"type":["null","string"]},"serial":{"type":"integer"},"reference":{"type":"string"},"agency":{"type":"string"},"number":{"type":"string"},"expires":{"type":["null","string"]},"certificate_url":{"type":["null","string"]},"product_id":{"type":["null","integer","string"]},"updated_at":{"type":["null","string"]},"created_at":{"type":["null","string"]},"updatedAt":{"type":["null","string"]},"createdAt":{"type":["null","string"]}},"required":["type","serial","reference","agency","number","expires"],"additionalProperties":false}');
      },
      56: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/organic_listing/v1","type":"object","properties":{"schema":{"const":"if2/product/organic_listing/v1"},"type":{"const":"IF2::Product::OrganicListing"},"serial":{"type":"integer"},"reference":{"type":"string"},"agency":{"type":"string"},"number":{"type":"string"},"expires":{"type":["null","string"]},"updated_at":{"type":"string"},"created_at":{"type":"string"}},"required":["schema","type","serial","reference","agency","number","expires","updated_at","created_at"],"additionalProperties":false}');
      },
      731: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product","oneOf":[{"$ref":"./product/v0"},{"$ref":"./product/v1"}]}');
      },
      782: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/active_ingredient","anyOf":[{"$ref":"./active_ingredient/v0"},{"$ref":"./active_ingredient/v1"}]}');
      },
      597: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/active_ingredient/v0","type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"name":{"type":"string"},"short_name":{"type":["null","string"]},"alternate_names":{"type":"array","items":{"type":"string"}},"percent":{"type":["null","string","number"]},"cas":{"type":["null","string"]},"pc_code":{"type":["null","string"]},"toxicity_category":{"type":["null","string"]},"toxicity_class":{"type":["null","string"]},"limited_by_espp":{"type":["null","boolean"]},"liquid_concentration":{"type":["null","string"]},"modes_of_action":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/mode_of_action"}},"mode_of_action":{"const":""}},"required":["id","name","cas"],"additionalProperties":false}');
      },
      866: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/active_ingredient/v1","type":"object","properties":{"id":{"type":"string"},"name":{"type":"string"},"short_name":{"type":["null","string"]},"alternate_names":{"type":"array","items":{"type":"string"}},"percent":{"type":["null","number"]},"cas":{"type":["null","string"]},"pc_code":{"type":["null","string"]},"toxicity_category":{"type":["null","string"]},"toxicity_class":{"type":["null","string"]},"limited_by_espp":{"type":"boolean"},"liquid_concentration":{"type":["null","string"]},"modes_of_action":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/mode_of_action"}}},"required":["id","name","short_name","alternate_names","cas","pc_code","limited_by_espp","modes_of_action","toxicity_category","toxicity_class"],"additionalProperties":false}');
      },
      845: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/attachment","oneOf":[{"$ref":"./attachment/v0"},{"$ref":"./attachment/v1"}]}');
      },
      372: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/attachment/v0","allOf":[{"type":"object","properties":{"type":{"const":"IF2::Product::Attachment"},"id":{"type":"null"},"serial":{"type":"integer"},"product_id":{"type":"integer"},"title":{"type":"string"},"filename":{"type":["null","string"]},"url":{"type":"string"},"updated_at":{"type":"string"},"created_at":{"type":"string"},"updatedAt":{"type":"string"},"createdAt":{"type":"string"}},"required":["serial","product_id","title","filename","url"],"additionalProperties":false},{"oneOf":[{"required":["updated_at","created_at"]},{"required":["updatedAt","createdAt"]}]}]}');
      },
      95: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/attachment/v1","type":"object","properties":{"schema":{"const":"if2/product/attachment/v1"},"type":{"const":"IF2::Product::Attachment"},"serial":{"type":"integer"},"product_id":{"type":"integer"},"title":{"type":"string"},"filename":{"type":["null","string"]},"url":{"type":"string"},"updated_at":{"type":"string"},"created_at":{"type":"string"}},"required":["schema","type","serial","product_id","title","filename","url","updated_at","created_at"],"additionalProperties":false}');
      },
      828: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/nutrient_analysis","type":"object","properties":{"al":{"type":["null","string"]},"b":{"type":["null","string"]},"ca":{"type":["null","string"]},"cu":{"type":["null","string"]},"fe":{"type":["null","string"]},"humicAcid":{"type":["null","string"]},"k":{"type":["null","string"]},"mg":{"type":["null","string"]},"mn":{"type":["null","string"]},"mo":{"type":["null","string"]},"n":{"type":["null","string"]},"p":{"type":["null","string"]},"s":{"type":["null","string"]},"si":{"type":["null","string"]},"zn":{"type":["null","string"]}},"required":["al","b","ca","cu","fe","humicAcid","k","mg","mn","mo","n","p","s","si","zn"],"additionalProperties":false}');
      },
      366: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/v0","allOf":[{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"account":{"oneOf":[{"$ref":"#/$defs/account_reference"},{"type":"null"}]},"account_id":{"type":"null"},"ache_inhibitor":{"type":"boolean"},"alternate_names":{"type":"array","items":{"type":"string"}},"alternateNames":{"type":"array","items":{"type":"string"}},"bee_hazard":{"type":["null","string"]},"epa_number":{"type":["null","string"]},"epaNumber":{"type":["null","string"]},"registration_number":{"type":["null","string"]},"state_registration":{"oneOf":[{"type":"object","additionalProperties":{"type":"string"}},{"type":"null"}]},"attachments":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/attachment"}},"organic_listings":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/organic_listing"}},"crop_labels":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/crop_label"}},"formulation":{"oneOf":[{"type":"object","properties":{"type":{"type":["null","string"]},"base_unit":{"type":["null","string"]},"description":{"type":["null","string"]}},"required":["type","base_unit","description"],"additionalProperties":false},{"type":"null"}]},"nutrient_analysis":{"oneOf":[{"$ref":"https://schemas.miriamtech.com/if2/product/nutrient_analysis"},{"type":"null"}]},"nutrientAnalysis":{"oneOf":[{"$ref":"https://schemas.miriamtech.com/if2/product/nutrient_analysis"},{"type":"null"}]},"inactive":{"type":"boolean"},"organic":{"type":"boolean"},"target_rates_required":{"type":"boolean"},"label_source":{"type":"string"},"attached_label_filename":{"type":"string"},"label_url":{"type":["null","string"]},"sds_source":{"type":"string"},"attached_sds_filename":{"type":"string"},"sds_url":{"type":["null","string"]},"manufacturer":{"type":["null","string"]},"mass_per_volume":{"type":["null","string"]},"notes":{"type":["null","string"]},"product_type":{"type":["null","string"]},"productType":{"type":["null","string"]},"signal_word":{"type":["null","string"]},"signalWord":{"type":["null","string"]},"use":{"type":["null","string"]},"deprecated_active_ingredients":{"type":"array","items":{"type":"object"}},"active_ingredients":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/active_ingredient"}},"activeIngredients":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/active_ingredient"}},"legacy":{"type":"object"},"reviewed_by":{"type":["null","object"]},"reviewed_at":{"type":["null","string"]},"reviewedAt":{"type":["null","string"]},"created_at":{"type":"string"},"createdAt":{"type":"string"},"updated_at":{"type":"string"},"updatedAt":{"type":"string"}},"required":["type","id","serial","name","bee_hazard","state_registration","inactive","label_url","sds_url","manufacturer","notes","use"],"additionalProperties":false},{"oneOf":[{"required":["alternate_names","epa_number","product_type","reviewed_at","signal_word","created_at","updated_at"]},{"required":["alternateNames","epaNumber","productType","reviewedAt","signalWord","createdAt","updatedAt"]}]}],"$defs":{"account_reference":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":"string"},"client_path":{"type":"array","items":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":"string"}},"required":["type","id","serial","name","full_name"],"additionalProperties":false}}},"required":["type","id","serial","name","full_name","client_path"],"additionalProperties":false}}}');
      },
      721: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/product/v1","type":"object","properties":{"schema":{"const":"if2/product/v1"},"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"account":{"oneOf":[{"$ref":"#/$defs/account_reference"},{"type":"null"}]},"ache_inhibitor":{"type":"boolean"},"alternate_names":{"type":"array","items":{"type":"string"}},"bee_hazard":{"type":["null","string"]},"epa_number":{"type":["null","string"]},"registration_number":{"type":["null","string"]},"state_registration":{"oneOf":[{"type":"object","additionalProperties":{"type":"string"}},{"type":"null"}]},"attachments":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/attachment"}},"organic_listings":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/organic_listing"}},"crop_labels":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/crop_label"}},"formulation":{"oneOf":[{"type":"object","properties":{"type":{"type":["null","string"]},"base_unit":{"type":["null","string"]},"description":{"type":["null","string"]}},"required":["type","base_unit","description"],"additionalProperties":false},{"type":"null"}]},"nutrient_analysis":{"oneOf":[{"$ref":"https://schemas.miriamtech.com/if2/product/nutrient_analysis"},{"type":"null"}]},"inactive":{"type":"boolean"},"organic":{"type":"boolean"},"target_rates_required":{"type":"boolean"},"label_url":{"type":["null","string"]},"sds_url":{"type":["null","string"]},"manufacturer":{"type":["null","string"]},"mass_per_volume":{"type":["null","string"]},"notes":{"type":["null","string"]},"product_type":{"type":["null","string"]},"signal_word":{"type":["null","string"]},"use":{"type":["null","string"]},"active_ingredients":{"type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/product/active_ingredient"}},"reviewed_at":{"type":["null","string"]},"created_at":{"type":"string"},"updated_at":{"type":"string"}},"required":["schema","type","id","serial","name","account","ache_inhibitor","target_rates_required","alternate_names","bee_hazard","epa_number","state_registration","registration_number","inactive","label_url","sds_url","manufacturer","mass_per_volume","notes","organic","product_type","signal_word","use","active_ingredients","attachments","organic_listings","reviewed_at","created_at","updated_at"],"additionalProperties":false,"$defs":{"account_reference":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":"string"},"client_path":{"type":"array","items":{"type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"full_name":{"type":"string"}},"required":["type","id","serial","name","full_name"],"additionalProperties":false}}},"required":["type","id","serial","name","full_name","client_path"],"additionalProperties":false}}}');
      },
      852: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/product_application","oneOf":[{"$ref":"./product_application/v0"},{"$ref":"./product_application/v1"}]}');
      },
      847: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/product_application/v0","type":"object","properties":{"type":{"const":"IF2::Recommendation::ProductApplication"},"id":{"type":["null","string"]},"serial":{"type":["null","string","integer"]},"created_at":{"type":["null","string"]},"updated_at":{"type":["null","string"]},"application_method":{"type":["null","string"]},"crop_names":{"type":"array","items":{"type":"string"}},"notes":{"type":["null","string"]},"position":{"type":["null","integer"]},"rate":{"type":["null","string"]},"target":{"type":["null","string"]},"rei":{"const":""},"phi":{"const":""},"product":{"$ref":"https://schemas.miriamtech.com/if2/product"}},"required":["rate","target","product"],"additionalProperties":false}');
      },
      308: t => {
        "use strict";

        t.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/recommendation/product_application/v1","type":"object","properties":{"schema":{"const":"if2/recommendation/product_application/v1"},"type":{"const":"IF2::Recommendation::ProductApplication"},"id":{"type":"string"},"serial":{"type":["null","integer"]},"created_at":{"type":["null","string"]},"updated_at":{"type":["null","string"]},"application_method":{"type":["null","string"]},"crop_names":{"type":"array","items":{"type":"string"}},"notes":{"type":["null","string"]},"position":{"type":["null","integer"]},"rate":{"type":["null","string"]},"target":{"type":["null","string"]},"product":{"$ref":"https://schemas.miriamtech.com/if2/product"}},"required":["schema","type","id","serial","created_at","updated_at","application_method","crop_names","notes","position","rate","target","product"],"additionalProperties":false}');
      }
    },
    a = {};
  function l(t) {
    var e = a[t];
    if (void 0 !== e) return e.exports;
    var r = a[t] = {
      exports: {}
    };
    return u[t](r, r.exports, l), r.exports;
  }
  l.n = t => {
    var e = t && t.__esModule ? () => t.default : () => t;
    return l.d(e, {
      a: e
    }), e;
  }, l.d = (t, e) => {
    for (var r in e) l.o(e, r) && !l.o(t, r) && Object.defineProperty(t, r, {
      enumerable: !0,
      get: e[r]
    });
  }, l.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), l.r = t => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  };
  var p = {};
  return (() => {
    "use strict";

    function t(e) {
      return t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, t(e);
    }
    function e(t) {
      var n = "function" == typeof Map ? new Map() : void 0;
      return e = function (t) {
        if (null === t || (e = t, -1 === Function.toString.call(e).indexOf("[native code]"))) return t;
        var e;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== n) {
          if (n.has(t)) return n.get(t);
          n.set(t, c);
        }
        function c() {
          return r(t, arguments, i(this).constructor);
        }
        return c.prototype = Object.create(t.prototype, {
          constructor: {
            value: c,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), o(c, t);
      }, e(t);
    }
    function r(t, e, i) {
      return r = n() ? Reflect.construct : function (t, e, r) {
        var n = [null];
        n.push.apply(n, e);
        var i = new (Function.bind.apply(t, n))();
        return r && o(i, r.prototype), i;
      }, r.apply(null, arguments);
    }
    function n() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function o(t, e) {
      return o = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, o(t, e);
    }
    function i(t) {
      return i = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, i(t);
    }
    l.r(p), l.d(p, {
      AbstractValidation: () => uo,
      AccountReference: () => ai,
      AccountWithPath: () => Pi,
      ActiveIngredient: () => Ui,
      ApplicatorBase: () => _u,
      Contact: () => bu,
      ContactAddress: () => lc,
      ContactEmail: () => gc,
      ContactInfoItem: () => tc,
      ContactPhone: () => Rc,
      Cultivar: () => Au,
      Failure: () => oo,
      Feature: () => Aa,
      FeatureBuilder: () => $a,
      FeatureCollection: () => Fa,
      FeatureGeometry: () => ga,
      FeatureGeometryBase: () => Yu,
      Field: () => Op,
      FieldCompletion: () => Dp,
      FieldCropCultivar: () => dl,
      FieldCropReference: () => Bl,
      FieldCropRootStock: () => _l,
      FieldCropVariety: () => cl,
      FieldReference: () => Np,
      FieldVariety: () => $l,
      Formulation: () => Jp,
      GeoJSON: () => Wa,
      GeoJSONBase: () => Bu,
      GeoJsonError: () => s,
      IF2JSModelSchemaValidator: () => En,
      IF2JsModelError: () => c,
      IncompatibleBaseUnitError: () => J,
      InvalidFeatureError: () => m,
      InvalidGeoJsonError: () => v,
      InvalidSchemaMigrationError: () => x,
      MassPerVolumeRequiredForLiquidProductsError: () => X,
      MissingBaseUnitError: () => I,
      Mix: () => Sr,
      MixInto: () => _r,
      ModeOfAction: () => zi,
      ModelReference: () => Zo,
      MultiPolygonGeometry: () => oa,
      NutrientAnalysis: () => af,
      OrganicListing: () => vf,
      OrganicProductValidation: () => Df,
      PointGeometry: () => sa,
      PolygonGeometry: () => Ku,
      Presence: () => To,
      Product: () => us,
      ProductApplicationBase: () => xs,
      ProductApplicationCalculation: () => ny,
      ProductAttachment: () => Kf,
      ProductCropLabel: () => Ff,
      ProductLabelValidation: () => ay,
      ProductRecommendationNote: () => zy,
      ProductReference: () => Os,
      Quantity: () => Do,
      QuantityComparison: () => Fo,
      QuantityPresence: () => qo,
      Recommendation: () => hd,
      RecommendationProductApplication: () => Js,
      RecommendationReference: () => Wy,
      Reject: () => mb,
      RootStock: () => Xl,
      Spec: () => Te,
      SprayRecord: () => gm,
      SprayRecordApplication: () => Vd,
      SprayRecordApplicator: () => Ad,
      SprayRecordProductApplication: () => Qd,
      SprayRecordRecommendationReference: () => um,
      Sprayer: () => Mc,
      Spreader: () => Uc,
      TargetRateRequiredForPerVolumeProductsError: () => ct,
      Team: () => Mm,
      TeamApplicator: () => Rm,
      Tractor: () => nu,
      UnparsableUnitsError: () => _,
      UnsupportedGeometryTypeError: () => D,
      UpdatableBase: () => Go,
      UseType: () => cp,
      UserReference: () => hy,
      UserReferenceWithLicenses: () => ky,
      activatableMixin: () => Qn,
      applicationMethodAttributeMixin: () => hn,
      bulletListString: () => xr,
      caseInsensitiveSort: () => Ar,
      checkableCollectionMixin: () => oe,
      checkableMixin: () => Kt,
      decimalToPercentString: () => Br,
      editableMixin: () => fe,
      expandableCollectionMixin: () => Oe,
      find: () => hr,
      findMany: () => gr,
      genericSort: () => kr,
      hideableMixin: () => ro,
      highlightableMixin: () => Yn,
      humanize: () => zr,
      idAttributeMixin: () => dt,
      includesAll: () => sr,
      includesAny: () => yr,
      isString: () => Er,
      listString: () => Tr,
      loadingStatusCollectionMixin: () => an,
      loggableMixin: () => Re,
      nameAttributeMixin: () => _t,
      naturalSort: () => Rr,
      percentStringToDecimal: () => Cr,
      push: () => Or,
      remove: () => vr,
      reportableMixin: () => Je,
      schemaAttributeMixin: () => Dn,
      schemaMixin: () => zn,
      selectableMixin: () => Xe,
      serialAttributeMixin: () => Tt,
      sortByName: () => Dr,
      timestampAttributesMixin: () => ar,
      toJS: () => Nr,
      truncateZeros: () => Fr,
      typeAttributeMixin: () => Yt,
      uniq: () => pr,
      uniqBy: () => fr,
      updatableMixin: () => Ur,
      validatableMixin: () => Wr
    });
    var c = function (e) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && o(t, e);
      }(a, e);
      var r,
        c,
        u = (r = a, c = n(), function () {
          var e,
            n = i(r);
          if (c) {
            var o = i(this).constructor;
            e = Reflect.construct(n, arguments, o);
          } else e = n.apply(this, arguments);
          return function (e, r) {
            return !r || "object" !== t(r) && "function" != typeof r ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(e) : r;
          }(this, e);
        });
      function a(t) {
        var e;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, a), (e = u.call(this, t)).name = e.constructor.name, e;
      }
      return a;
    }(e(Error));
    function u(t) {
      return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, u(t);
    }
    function a(t, e) {
      return a = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, a(t, e);
    }
    function f(t) {
      return f = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, f(t);
    }
    var s = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && a(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            n = f(e);
          if (r) {
            var o = f(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== u(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), n.apply(this, arguments);
      }
      return o;
    }(c);
    function y(t) {
      return y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, y(t);
    }
    function b(t, e) {
      return b = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, b(t, e);
    }
    function d(t) {
      return d = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, d(t);
    }
    var m = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && b(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            n = d(e);
          if (r) {
            var o = d(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== y(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), n.call(this, "Invalid GeoJSON feature");
      }
      return o;
    }(s);
    function h(t) {
      return h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, h(t);
    }
    function g(t, e) {
      return g = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, g(t, e);
    }
    function O(t) {
      return O = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, O(t);
    }
    var v = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && g(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            n = O(e);
          if (r) {
            var o = O(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== h(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), n.call(this, "Invalid GeoJSON");
      }
      return o;
    }(s);
    function j(t) {
      return j = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, j(t);
    }
    function w(t, e) {
      return w = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, w(t, e);
    }
    function P(t) {
      return P = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, P(t);
    }
    var _ = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && w(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            n = P(e);
          if (r) {
            var o = P(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== j(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o(t) {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), n.call(this, "Unable to parse units: '".concat(t, "'"));
      }
      return o;
    }(c);
    function S(t) {
      return S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, S(t);
    }
    function k(t, e) {
      return k = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, k(t, e);
    }
    function R(t) {
      return R = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, R(t);
    }
    var D = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && k(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            n = R(e);
          if (r) {
            var o = R(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== S(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o(t) {
        var e;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), (e = n.call(this, "Unsupported GeoJSON geometry type: '".concat(t, "'"))).type = t, e;
      }
      return o;
    }(s);
    function A(t) {
      return A = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, A(t);
    }
    function E(t, e) {
      return E = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, E(t, e);
    }
    function C(t) {
      return C = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, C(t);
    }
    var x = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && E(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            n = C(e);
          if (r) {
            var o = C(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== A(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o(t) {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), n.call(this, "Schema migration for schema '".concat(t, "' did not change the schema"));
      }
      return o;
    }(c);
    function T(t) {
      return T = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, T(t);
    }
    function B(t) {
      var e = "function" == typeof Map ? new Map() : void 0;
      return B = function (t) {
        if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
        var r;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== e) {
          if (e.has(t)) return e.get(t);
          e.set(t, n);
        }
        function n() {
          return z(t, arguments, F(this).constructor);
        }
        return n.prototype = Object.create(t.prototype, {
          constructor: {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), N(n, t);
      }, B(t);
    }
    function z(t, e, r) {
      return z = M() ? Reflect.construct : function (t, e, r) {
        var n = [null];
        n.push.apply(n, e);
        var o = new (Function.bind.apply(t, n))();
        return r && N(o, r.prototype), o;
      }, z.apply(null, arguments);
    }
    function M() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function N(t, e) {
      return N = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, N(t, e);
    }
    function F(t) {
      return F = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, F(t);
    }
    var I = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && N(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = M(), function () {
          var t,
            n = F(e);
          if (r) {
            var o = F(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== T(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o(t) {
        var e;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), (e = n.call(this, "Missing base unit for ".concat(null == t ? void 0 : t.name))).product = t, e;
      }
      return o;
    }(B(Error));
    function V(t) {
      return V = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, V(t);
    }
    function L(t) {
      var e = "function" == typeof Map ? new Map() : void 0;
      return L = function (t) {
        if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
        var r;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== e) {
          if (e.has(t)) return e.get(t);
          e.set(t, n);
        }
        function n() {
          return Y(t, arguments, U(this).constructor);
        }
        return n.prototype = Object.create(t.prototype, {
          constructor: {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), $(n, t);
      }, L(t);
    }
    function Y(t, e, r) {
      return Y = q() ? Reflect.construct : function (t, e, r) {
        var n = [null];
        n.push.apply(n, e);
        var o = new (Function.bind.apply(t, n))();
        return r && $(o, r.prototype), o;
      }, Y.apply(null, arguments);
    }
    function q() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function $(t, e) {
      return $ = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, $(t, e);
    }
    function U(t) {
      return U = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, U(t);
    }
    var J = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && $(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = q(), function () {
          var t,
            n = U(e);
          if (r) {
            var o = U(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== V(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o(t, e) {
        var r, i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), (i = n.call(this, "Incompatible base unit ".concat((null == t || null === (r = t.formulation) || void 0 === r ? void 0 : r.baseUnit) || "", " with ").concat(e))).product = t, i;
      }
      return o;
    }(L(Error));
    function G(t) {
      return G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, G(t);
    }
    function H(t) {
      var e = "function" == typeof Map ? new Map() : void 0;
      return H = function (t) {
        if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
        var r;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== e) {
          if (e.has(t)) return e.get(t);
          e.set(t, n);
        }
        function n() {
          return Q(t, arguments, Z(this).constructor);
        }
        return n.prototype = Object.create(t.prototype, {
          constructor: {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), W(n, t);
      }, H(t);
    }
    function Q(t, e, r) {
      return Q = K() ? Reflect.construct : function (t, e, r) {
        var n = [null];
        n.push.apply(n, e);
        var o = new (Function.bind.apply(t, n))();
        return r && W(o, r.prototype), o;
      }, Q.apply(null, arguments);
    }
    function K() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function W(t, e) {
      return W = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, W(t, e);
    }
    function Z(t) {
      return Z = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Z(t);
    }
    var X = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && W(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = K(), function () {
          var t,
            n = Z(e);
          if (r) {
            var o = Z(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== G(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o(t, e) {
        var r;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), (r = n.call(this, "Mass per Volume is required on liquid products when calculating poundsPerAcre. ".concat(null == t ? void 0 : t.name, " does not have a massPerVolume"))).product = t, r.rate = e, r;
      }
      return o;
    }(H(Error));
    function tt(t) {
      return tt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, tt(t);
    }
    function et(t) {
      var e = "function" == typeof Map ? new Map() : void 0;
      return et = function (t) {
        if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
        var r;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== e) {
          if (e.has(t)) return e.get(t);
          e.set(t, n);
        }
        function n() {
          return rt(t, arguments, it(this).constructor);
        }
        return n.prototype = Object.create(t.prototype, {
          constructor: {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), ot(n, t);
      }, et(t);
    }
    function rt(t, e, r) {
      return rt = nt() ? Reflect.construct : function (t, e, r) {
        var n = [null];
        n.push.apply(n, e);
        var o = new (Function.bind.apply(t, n))();
        return r && ot(o, r.prototype), o;
      }, rt.apply(null, arguments);
    }
    function nt() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function ot(t, e) {
      return ot = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ot(t, e);
    }
    function it(t) {
      return it = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, it(t);
    }
    var ct = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ot(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = nt(), function () {
          var t,
            n = it(e);
          if (r) {
            var o = it(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== tt(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o(t, e) {
        var r;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), (r = n.call(this, 'Target Rate required for productPerAcre calculation for "per volume" products.')).product = t, r.rate = e, r;
      }
      return o;
    }(et(Error));
    function ut(t) {
      return ut = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ut(t);
    }
    function at(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function lt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? at(Object(r), !0).forEach(function (e) {
          pt(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : at(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function pt(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function ft(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function st(t, e, r) {
      return st = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = bt(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, st(t, e, r || t);
    }
    function yt(t, e) {
      return yt = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, yt(t, e);
    }
    function bt(t) {
      return bt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, bt(t);
    }
    var dt = function (t) {
      return function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && yt(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = bt(n);
            if (o) {
              var r = bt(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== ut(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, r = [{
          key: "getAttributeDefinition",
          value: function () {
            return lt(lt({}, st(bt(c), "getAttributeDefinition", this).call(this)), {}, {
              id: {
                name: "ID",
                key: "id",
                type: "string"
              }
            });
          }
        }], null && ft(e.prototype, null), r && ft(e, r), c;
      }(t);
    };
    function mt(t) {
      return mt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, mt(t);
    }
    function ht(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function gt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ht(Object(r), !0).forEach(function (e) {
          Ot(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ht(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Ot(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function vt(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function jt(t, e, r) {
      return jt = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Pt(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, jt(t, e, r || t);
    }
    function wt(t, e) {
      return wt = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, wt(t, e);
    }
    function Pt(t) {
      return Pt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Pt(t);
    }
    var _t = function (t) {
      return function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && wt(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = Pt(n);
            if (o) {
              var r = Pt(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== mt(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, r = [{
          key: "getAttributeDefinition",
          value: function () {
            return gt(gt({}, jt(Pt(c), "getAttributeDefinition", this).call(this)), {}, {
              name: {
                name: "Name",
                key: "name",
                type: "string"
              }
            });
          }
        }], null && vt(e.prototype, null), r && vt(e, r), c;
      }(t);
    };
    function St(t) {
      return St = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, St(t);
    }
    function kt(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Rt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? kt(Object(r), !0).forEach(function (e) {
          Dt(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : kt(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Dt(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function At(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Et(t, e, r) {
      return Et = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = xt(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Et(t, e, r || t);
    }
    function Ct(t, e) {
      return Ct = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Ct(t, e);
    }
    function xt(t) {
      return xt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, xt(t);
    }
    var Tt = function (t) {
      return function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Ct(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = xt(n);
            if (o) {
              var r = xt(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== St(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, r = [{
          key: "getAttributeDefinition",
          value: function () {
            return Rt(Rt({}, Et(xt(c), "getAttributeDefinition", this).call(this)), {}, {
              serial: {
                name: "Serial",
                key: "serial",
                type: "number"
              }
            });
          }
        }], null && At(e.prototype, null), r && At(e, r), c;
      }(t);
    };
    function Bt(t) {
      return Bt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Bt(t);
    }
    function zt(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Mt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? zt(Object(r), !0).forEach(function (e) {
          Nt(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : zt(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Nt(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Ft(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function It(t, e, r) {
      return It = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Lt(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, It(t, e, r || t);
    }
    function Vt(t, e) {
      return Vt = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Vt(t, e);
    }
    function Lt(t) {
      return Lt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Lt(t);
    }
    var Yt = function (t) {
        return function (t) {
          !function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                writable: !0,
                configurable: !0
              }
            }), e && Vt(t, e);
          }(c, t);
          var e,
            r,
            n,
            o,
            i = (n = c, o = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (t) {
                return !1;
              }
            }(), function () {
              var t,
                e = Lt(n);
              if (o) {
                var r = Lt(this).constructor;
                t = Reflect.construct(e, arguments, r);
              } else t = e.apply(this, arguments);
              return function (t, e) {
                return !e || "object" !== Bt(e) && "function" != typeof e ? function (t) {
                  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return t;
                }(t) : e;
              }(this, t);
            });
          function c() {
            return function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, c), i.apply(this, arguments);
          }
          return e = c, r = [{
            key: "getAttributeDefinition",
            value: function () {
              return Mt(Mt({}, It(Lt(c), "getAttributeDefinition", this).call(this)), {}, {
                type: {
                  name: "Type",
                  key: "type",
                  type: "string"
                }
              });
            }
          }], null && Ft(e.prototype, null), r && Ft(e, r), c;
        }(t);
      },
      qt = l(314);
    function $t(t) {
      return $t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, $t(t);
    }
    function Ut(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Jt(t, e) {
      return Jt = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Jt(t, e);
    }
    function Gt(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function Ht(t) {
      return Ht = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Ht(t);
    }
    function Qt(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var Kt = function (t) {
      var e, r;
      return e = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Jt(t, e);
        }(u, t);
        var e,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = Ht(o);
            if (i) {
              var r = Ht(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== $t(e) && "function" != typeof e ? Gt(t) : e;
            }(this, t);
          });
        function u() {
          var t, e, n, o;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u);
          for (var i = arguments.length, a = new Array(i), l = 0; l < i; l++) a[l] = arguments[l];
          return e = Gt(t = c.call.apply(c, [this].concat(a))), n = r, o = Gt(t), n && Object.defineProperty(e, "isChecked", {
            enumerable: n.enumerable,
            configurable: n.configurable,
            writable: n.writable,
            value: n.initializer ? n.initializer.call(o) : void 0
          }), t;
        }
        return e = u, (n = [{
          key: "check",
          value: function () {
            this.isChecked = !0;
          }
        }, {
          key: "unCheck",
          value: function () {
            this.isChecked = !1;
          }
        }, {
          key: "toggleChecked",
          value: function () {
            this.isChecked = !this.isChecked;
          }
        }]) && Ut(e.prototype, n), u;
      }(t), r = Qt(e.prototype, "isChecked", [qt.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), Qt(e.prototype, "check", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "check"), e.prototype), Qt(e.prototype, "unCheck", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "unCheck"), e.prototype), Qt(e.prototype, "toggleChecked", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "toggleChecked"), e.prototype), e;
    };
    function Wt(t) {
      return Wt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Wt(t);
    }
    function Zt(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    function Xt(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function te(t, e) {
      return te = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, te(t, e);
    }
    function ee(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function re(t) {
      return re = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, re(t);
    }
    function ne(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var oe = function (t) {
      var e, r;
      return e = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && te(t, e);
        }(u, t);
        var e,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = re(o);
            if (i) {
              var r = re(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Wt(e) && "function" != typeof e ? ee(t) : e;
            }(this, t);
          });
        function u() {
          var t, e, n, o;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u);
          for (var i = arguments.length, a = new Array(i), l = 0; l < i; l++) a[l] = arguments[l];
          return e = ee(t = c.call.apply(c, [this].concat(a))), n = r, o = ee(t), n && Object.defineProperty(e, "_checked", {
            enumerable: n.enumerable,
            configurable: n.configurable,
            writable: n.writable,
            value: n.initializer ? n.initializer.call(o) : void 0
          }), t;
        }
        return e = u, (n = [{
          key: "checked",
          get: function () {
            return function (t) {
              if (Array.isArray(t)) return Zt(t);
            }(t = this._checked.keys()) || function (t) {
              if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return Zt(t, e);
                var r = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Zt(t, e) : void 0;
              }
            }(t) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
            var t;
          }
        }, {
          key: "numChecked",
          get: function () {
            return this._checked.size;
          }
        }, {
          key: "isChecked",
          value: function (t) {
            return this._checked.has(t);
          }
        }, {
          key: "toggleChecked",
          value: function (t) {
            this.isChecked(t) ? this.unCheck(t) : this.check(t);
          }
        }, {
          key: "checkMany",
          value: function (t) {
            var e = this;
            t.forEach(function (t) {
              e.check(t);
            });
          }
        }, {
          key: "unCheckMany",
          value: function (t) {
            var e = this;
            t.forEach(function (t) {
              e.unCheck(t);
            });
          }
        }, {
          key: "check",
          value: function (t) {
            this._checked.set(t, !0);
          }
        }, {
          key: "unCheck",
          value: function (t) {
            this._checked.delete(t);
          }
        }, {
          key: "setCheck",
          value: function (t, e) {
            e ? this.check(t) : this.unCheck(t);
          }
        }, {
          key: "unCheckAll",
          value: function () {
            this._checked.clear();
          }
        }]) && Xt(e.prototype, n), u;
      }(t), r = ne(e.prototype, "_checked", [qt.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return new Map();
        }
      }), ne(e.prototype, "checked", [qt.computed], Object.getOwnPropertyDescriptor(e.prototype, "checked"), e.prototype), ne(e.prototype, "numChecked", [qt.computed], Object.getOwnPropertyDescriptor(e.prototype, "numChecked"), e.prototype), ne(e.prototype, "toggleChecked", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "toggleChecked"), e.prototype), ne(e.prototype, "checkMany", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "checkMany"), e.prototype), ne(e.prototype, "unCheckMany", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "unCheckMany"), e.prototype), ne(e.prototype, "check", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "check"), e.prototype), ne(e.prototype, "unCheck", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "unCheck"), e.prototype), ne(e.prototype, "setCheck", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "setCheck"), e.prototype), ne(e.prototype, "unCheckAll", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "unCheckAll"), e.prototype), e;
    };
    function ie(t) {
      return ie = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ie(t);
    }
    function ce(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function ue(t, e) {
      return ue = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ue(t, e);
    }
    function ae(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function le(t) {
      return le = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, le(t);
    }
    function pe(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var fe = function (t) {
      var e, r;
      return e = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && ue(t, e);
        }(u, t);
        var e,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = le(o);
            if (i) {
              var r = le(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== ie(e) && "function" != typeof e ? ae(t) : e;
            }(this, t);
          });
        function u() {
          var t, e, n, o;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u);
          for (var i = arguments.length, a = new Array(i), l = 0; l < i; l++) a[l] = arguments[l];
          return e = ae(t = c.call.apply(c, [this].concat(a))), n = r, o = ae(t), n && Object.defineProperty(e, "isBeingEdited", {
            enumerable: n.enumerable,
            configurable: n.configurable,
            writable: n.writable,
            value: n.initializer ? n.initializer.call(o) : void 0
          }), t;
        }
        return e = u, (n = [{
          key: "openEdit",
          value: function () {
            this.isBeingEdited = !0;
          }
        }, {
          key: "closeEdit",
          value: function () {
            this.isBeingEdited = !1;
          }
        }, {
          key: "toggleEdit",
          value: function () {
            this.isBeingEdited = !this.isBeingEdited;
          }
        }]) && ce(e.prototype, n), u;
      }(t), r = pe(e.prototype, "isBeingEdited", [qt.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), pe(e.prototype, "openEdit", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "openEdit"), e.prototype), pe(e.prototype, "closeEdit", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "closeEdit"), e.prototype), pe(e.prototype, "toggleEdit", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "toggleEdit"), e.prototype), e;
    };
    function se(t) {
      return se = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, se(t);
    }
    function ye(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    function be(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function de(t, e) {
      return de = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, de(t, e);
    }
    function me(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function he(t) {
      return he = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, he(t);
    }
    function ge(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var Oe = function (t) {
      var e, r;
      return e = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && de(t, e);
        }(u, t);
        var e,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = he(o);
            if (i) {
              var r = he(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== se(e) && "function" != typeof e ? me(t) : e;
            }(this, t);
          });
        function u() {
          var t, e, n, o;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u);
          for (var i = arguments.length, a = new Array(i), l = 0; l < i; l++) a[l] = arguments[l];
          return e = me(t = c.call.apply(c, [this].concat(a))), n = r, o = me(t), n && Object.defineProperty(e, "_expanded", {
            enumerable: n.enumerable,
            configurable: n.configurable,
            writable: n.writable,
            value: n.initializer ? n.initializer.call(o) : void 0
          }), t;
        }
        return e = u, (n = [{
          key: "expanded",
          get: function () {
            return function (t) {
              if (Array.isArray(t)) return ye(t);
            }(t = this._expanded.keys()) || function (t) {
              if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return ye(t, e);
                var r = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ye(t, e) : void 0;
              }
            }(t) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
            var t;
          }
        }, {
          key: "toggleExpanded",
          value: function (t) {
            this.isCollapsed(t) ? this.expand(t) : this.collapse(t);
          }
        }, {
          key: "expandMany",
          value: function (t) {
            var e = this;
            t.forEach(function (t) {
              e.expand(t);
            });
          }
        }, {
          key: "collapseMany",
          value: function (t) {
            var e = this;
            t.forEach(function (t) {
              e.collapse(t);
            });
          }
        }, {
          key: "expand",
          value: function (t) {
            this._expanded.set(t, !0);
          }
        }, {
          key: "collapse",
          value: function (t) {
            this._expanded.delete(t);
          }
        }, {
          key: "isExpanded",
          value: function (t) {
            return this._expanded.has(t);
          }
        }, {
          key: "isCollapsed",
          value: function (t) {
            return !this._expanded.has(t);
          }
        }, {
          key: "setExpand",
          value: function (t, e) {
            e ? this.expand(t) : this.collapse(t);
          }
        }, {
          key: "collapseAll",
          value: function () {
            this._expanded.clear();
          }
        }]) && be(e.prototype, n), u;
      }(t), r = ge(e.prototype, "_expanded", [qt.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return new Map();
        }
      }), ge(e.prototype, "expanded", [qt.computed], Object.getOwnPropertyDescriptor(e.prototype, "expanded"), e.prototype), ge(e.prototype, "toggleExpanded", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "toggleExpanded"), e.prototype), ge(e.prototype, "expandMany", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "expandMany"), e.prototype), ge(e.prototype, "collapseMany", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "collapseMany"), e.prototype), ge(e.prototype, "expand", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "expand"), e.prototype), ge(e.prototype, "collapse", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "collapse"), e.prototype), ge(e.prototype, "setExpand", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "setExpand"), e.prototype), ge(e.prototype, "collapseAll", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "collapseAll"), e.prototype), e;
    };
    function ve(t) {
      return ve = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ve(t);
    }
    function je(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function we(t, e) {
      return we = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, we(t, e);
    }
    function Pe(t) {
      return Pe = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Pe(t);
    }
    var _e,
      Se,
      ke,
      Re = function (t) {
        var e, r, n, o, i;
        return r = e = function (t) {
          !function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                writable: !0,
                configurable: !0
              }
            }), e && we(t, e);
          }(u, t);
          var e,
            r,
            n,
            o,
            i,
            c = (o = u, i = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (t) {
                return !1;
              }
            }(), function () {
              var t,
                e = Pe(o);
              if (i) {
                var r = Pe(this).constructor;
                t = Reflect.construct(e, arguments, r);
              } else t = e.apply(this, arguments);
              return function (t, e) {
                return !e || "object" !== ve(e) && "function" != typeof e ? function (t) {
                  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return t;
                }(t) : e;
              }(this, t);
            });
          function u() {
            return function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, u), c.apply(this, arguments);
          }
          return e = u, n = [{
            key: "setLogger",
            value: function (t) {
              this.logger = t;
            }
          }, {
            key: "resetLogger",
            value: function () {
              this.logger = console;
            }
          }], (r = [{
            key: "logger",
            get: function () {
              return this.constructor.logger;
            }
          }]) && je(e.prototype, r), n && je(e, n), u;
        }(t), n = e, o = "logger", i = console, o in n ? Object.defineProperty(n, o, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : n[o] = i, r;
      },
      De = l(871),
      Ae = l(315);
    function Ee(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Ce(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function xe(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var Te = (ke = Se = function () {
      function t(e) {
        var r = this;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Ce(this, "accessorsForKey", function (t) {
          return r.constructor.accessorsForAttribute(r.findAttribute(t));
        }), this.attributeDefinition = (null == e ? void 0 : e.attributeDefinition) || {}, this.defaultKey = (null == e ? void 0 : e.defaultKey) || "name";
      }
      var e, r;
      return e = t, (r = [{
        key: "findAttribute",
        value: function (t) {
          return Array.isArray(this.attributes) && this.attributes.find(function (e) {
            return [e.key, e.jsKey].includes(t);
          }) || void 0;
        }
      }, {
        key: "accessors",
        get: function () {
          return (0, De.flatten)((0, De.map)(this.constructor.accessorsForAttribute, this.attributes));
        }
      }, {
        key: "attributes",
        get: function () {
          return Object.values(this.attributeDefinition || {});
        }
      }, {
        key: "defaultAccessor",
        get: function () {
          var t = (0, De.head)((0, De.flatten)([this.accessorsForKey(this.defaultKey)]));
          if (null != t && t.attribute) return ["model", "modelCollection"].includes(t.attribute.type) ? this.constructor.descendantAccessor(t.attribute.modelClass.spec.defaultAccessor, t.attribute.key) : t;
        }
      }]) && Ee(e.prototype, r), t;
    }(), Ce(Se, "accessorsForAttribute", function (t) {
      return t ? ["model", "modelCollection"].includes(t.type) ? Se.expandDescendantAccessors(t) : {
        path: [t.key],
        attribute: t
      } : {
        path: [],
        attribute: t
      };
    }), Ce(Se, "descendantAccessor", function (t, e) {
      return {
        path: [e].concat(t.path),
        attribute: t.attribute
      };
    }), Ce(Se, "expandDescendantAccessors", function (t) {
      return [{
        path: [t.key],
        attribute: t
      }, t.modelClass.spec.accessors.map(function (e) {
        return Se.descendantAccessor(e, t.key);
      })];
    }), xe((_e = ke).prototype, "accessors", [qt.computed], Object.getOwnPropertyDescriptor(_e.prototype, "accessors"), _e.prototype), xe(_e.prototype, "attributes", [qt.computed], Object.getOwnPropertyDescriptor(_e.prototype, "attributes"), _e.prototype), xe(_e.prototype, "defaultAccessor", [qt.computed], Object.getOwnPropertyDescriptor(_e.prototype, "defaultAccessor"), _e.prototype), _e);
    function Be(t) {
      return Be = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Be(t);
    }
    function ze(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Me(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ze(Object(r), !0).forEach(function (e) {
          Le(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ze(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Ne(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Fe(t, e) {
      return Fe = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Fe(t, e);
    }
    function Ie(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function Ve(t) {
      return Ve = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Ve(t);
    }
    function Le(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var Ye = (0, De.path)(["attribute", "key"]),
      qe = function (t) {
        return (0, De.compose)(function (e) {
          return (0, De.merge)(e, {
            path: [t].concat(e.path)
          });
        }, function (t) {
          return t.attribute.modelClass.spec.defaultAccessor;
        }, (0, De.find)(function (e) {
          return e.attribute.key === t;
        }));
      },
      $e = function (t) {
        return function (e) {
          return (0, De.compose)(De.uniq, (0, De.map)(function (t) {
            return (0, De.merge)(t, {
              path: (0, De.tail)(t.path)
            });
          }), (0, De.concat)([qe(t)(e)]), function (t) {
            return (0, De.filter)(function (e) {
              return e.path.length > 1 && e.path[0] === t;
            });
          }(t))(e);
        };
      },
      Ue = (0, De.curry)(function (t, e) {
        return (0, De.map)(function (t) {
          return (0, De.objOf)(e, t);
        }, t);
      }),
      Je = function (t) {
        return function (t) {
          !function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                writable: !0,
                configurable: !0
              }
            }), e && Fe(t, e);
          }(u, t);
          var e,
            r,
            n,
            o,
            i,
            c = (o = u, i = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (t) {
                return !1;
              }
            }(), function () {
              var t,
                e = Ve(o);
              if (i) {
                var r = Ve(this).constructor;
                t = Reflect.construct(e, arguments, r);
              } else t = e.apply(this, arguments);
              return function (t, e) {
                return !e || "object" !== Be(e) && "function" != typeof e ? Ie(t) : e;
              }(this, t);
            });
          function u() {
            var t;
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, u);
            for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
            return Le(Ie(t = c.call.apply(c, [this].concat(r))), "isReportable", !0), Le(Ie(t), "mergeReportRows", (0, De.curry)(function (t, e) {
              return (0, De.flatten)(t).length < 1 ? e : t.reduce(function (t, e) {
                return (0, De.flatten)(t.length < 1 ? e : t.map(function (t) {
                  return e.length < 1 ? t : e.map(function (e) {
                    return (0, De.mergeDeepRight)(t, e);
                  });
                }));
              }, e);
            })), t;
          }
          return e = u, n = [{
            key: "spec",
            get: function () {
              return new Te({
                attributeDefinition: this.reportableAttributes,
                defaultKey: this.defaultKey
              });
            }
          }], (r = [{
            key: "accessorGroupsToReport",
            value: function (t) {
              var e = this,
                r = function (t) {
                  var e = t.filter(function (t) {
                    return 1 === t.path.length;
                  });
                  return (0, De.merge)({
                    all: t
                  }, (0, De.groupBy)(function (t) {
                    return (0, De.pathEq)(["attribute", "type"], "modelCollection", t) ? "collections" : (0, De.pathEq)(["attribute", "type"], "model", t) ? "models" : "literals";
                  })(e));
                }(t),
                n = function (t, e) {
                  return (0, De.compose)((0, De.difference)(De.__, (0, De.map)(function (t) {
                    return t.path[0];
                  }, e.collections || [])), (0, De.map)(function (t) {
                    return t.path[0];
                  }), (0, De.filter)(function (t) {
                    return t.path.length > 1;
                  }))(t);
                }(t, r);
              return n.forEach(function (t) {
                var n = e.rootAccessorForKey(t);
                r.all.push(n), (0, De.propEq)("type", "modelCollection", n.attribute) && (r.collections = (0, De.compose)((0, De.filter)(Boolean), De.flatten, (0, De.concat)(r.collections || []))([n])), (0, De.propEq)("type", "model", n.attribute) && (r.models = (0, De.compose)((0, De.filter)(Boolean), De.flatten, (0, De.concat)(r.models || []))([n]));
              }), r;
            }
          }, {
            key: "reportLiterals",
            value: function (t) {
              return t ? [(0, De.pickAll)((0, De.map)(Ye, (0, De.prop)("literals", t) || []).concat("id"), this)] : [];
            }
          }, {
            key: "reportCollections",
            value: function (t) {
              var e = this;
              return (0, De.map)((0, De.compose)(function (r) {
                return Ue((0, De.flatten)((0, De.map)(function (e) {
                  return e.report($e(r)(t.all));
                }, e[r])))(r);
              }, Ye), (0, De.prop)("collections", t) || []);
            }
          }, {
            key: "reportModels",
            value: function (t) {
              var e = this;
              return (0, De.compose)((0, De.map)((0, De.compose)(function (r) {
                return Ue((0, De.flatten)(e[r].report($e(r)(t.all))))(r);
              }, Ye)), (0, De.reject)(function (t) {
                return !e[Ye(t)];
              }))((0, De.prop)("models", t) || []);
            }
          }, {
            key: "rootAccessorForKey",
            value: function (t) {
              var e = this.constructor.spec.accessorsForKey(t);
              return Array.isArray(e) ? e[0] : e;
            }
          }, {
            key: "report",
            value: function (t) {
              var e = this,
                r = this.accessorGroupsToReport([].concat(t)),
                n = this.reportLiterals(r),
                o = this.reportCollections(r),
                i = this.reportModels(r);
              return (0, De.compose)((0, De.map)(function (t) {
                return Me(Me({}, t), {}, {
                  _rowId: (0, Ae.v4)(),
                  model: e
                });
              }), this.mergeReportRows(i), this.mergeReportRows(o))(n);
            }
          }]) && Ne(e.prototype, r), n && Ne(e, n), u;
        }(t);
      };
    function Ge(t) {
      return Ge = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ge(t);
    }
    function He(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Qe(t, e) {
      return Qe = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Qe(t, e);
    }
    function Ke(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function We(t) {
      return We = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, We(t);
    }
    function Ze(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var Xe = function (t) {
      var e, r;
      return e = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Qe(t, e);
        }(u, t);
        var e,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = We(o);
            if (i) {
              var r = We(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Ge(e) && "function" != typeof e ? Ke(t) : e;
            }(this, t);
          });
        function u() {
          var t, e, n, o;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u);
          for (var i = arguments.length, a = new Array(i), l = 0; l < i; l++) a[l] = arguments[l];
          return e = Ke(t = c.call.apply(c, [this].concat(a))), n = r, o = Ke(t), n && Object.defineProperty(e, "isSelected", {
            enumerable: n.enumerable,
            configurable: n.configurable,
            writable: n.writable,
            value: n.initializer ? n.initializer.call(o) : void 0
          }), t;
        }
        return e = u, (n = [{
          key: "select",
          value: function () {
            this.isSelected = !0;
          }
        }, {
          key: "deselect",
          value: function () {
            this.isSelected = !1;
          }
        }, {
          key: "toggleSelected",
          value: function () {
            this.isSelected = !this.isSelected;
          }
        }]) && He(e.prototype, n), u;
      }(t), r = Ze(e.prototype, "isSelected", [qt.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), Ze(e.prototype, "select", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "select"), e.prototype), Ze(e.prototype, "deselect", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "deselect"), e.prototype), Ze(e.prototype, "toggleSelected", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "toggleSelected"), e.prototype), e;
    };
    function tr(t) {
      return tr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, tr(t);
    }
    function er(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function rr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? er(Object(r), !0).forEach(function (e) {
          nr(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : er(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function nr(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function or(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function ir(t, e, r) {
      return ir = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = ur(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, ir(t, e, r || t);
    }
    function cr(t, e) {
      return cr = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, cr(t, e);
    }
    function ur(t) {
      return ur = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, ur(t);
    }
    var ar = function (t) {
      return function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && cr(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = ur(n);
            if (o) {
              var r = ur(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== tr(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, r = [{
          key: "getAttributeDefinition",
          value: function () {
            return rr(rr({}, ir(ur(c), "getAttributeDefinition", this).call(this)), {}, {
              createdAt: {
                name: "Created At",
                key: "createdAt",
                type: "string"
              },
              updatedAt: {
                name: "Updated At",
                key: "updatedAt",
                type: "string"
              }
            });
          }
        }], null && or(e.prototype, null), r && or(e, r), c;
      }(t);
    };
    function lr(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    var pr = function (t) {
        return function (t) {
          if (Array.isArray(t)) return lr(t);
        }(e = new Set(t)) || function (t) {
          if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(e) || function (t, e) {
          if (t) {
            if ("string" == typeof t) return lr(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? lr(t, e) : void 0;
          }
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
        var e;
      },
      fr = function (t, e) {
        return Array.from(new Map(e.map(function (e) {
          return [e[t], e];
        })).values());
      },
      sr = (0, De.curry)(function (t, e) {
        return t.every(function (t) {
          return e.includes(t);
        });
      }),
      yr = (0, De.curry)(function (t, e) {
        return (0, De.pipe)((0, De.intersection)(t), De.isEmpty, De.not)(e);
      });
    function br(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function dr(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? br(Object(r), !0).forEach(function (e) {
          mr(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : br(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function mr(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var hr = function (t, e, r) {
        var n = (r || {}).searchKey || "id";
        return t.find(function (t) {
          return t[n] === e;
        });
      },
      gr = function (t, e) {
        var r = t.reduce(function (t, e) {
          return t.set(e.id, e), t;
        }, new Map());
        return e.reduce(function (t, e) {
          var n = r.get(e);
          return n && t.push(n), t;
        }, []);
      },
      Or = function (t, e, r, n) {
        return (0, qt.runInAction)(function () {
          var o = n || {},
            i = o.searchKey || "id",
            c = dr(dr({}, r), {}, {
              id: r.id || r._id
            }),
            u = hr(t, c[i], {
              searchKey: i
            });
          return u ? u.update(c) : (u = e(c), Object.keys(o.initProps || {}).forEach(function (t) {
            u[t] = o.initProps[t];
          }), (0, qt.runInAction)(function () {
            return t.push(u);
          })), u;
        });
      },
      vr = function (t, e, r) {
        return (0, qt.runInAction)(function () {
          var n = (r || {}).searchKey || "id",
            o = t.findIndex(function (t) {
              return t[n] === e;
            });
          if (o >= 0) return t.splice(o, 1)[0];
        });
      };
    function jr(t) {
      return jr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, jr(t);
    }
    function wr(t, e) {
      return wr = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, wr(t, e);
    }
    function Pr(t) {
      return Pr = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Pr(t);
    }
    var _r = (0, De.curry)((0, De.uncurryN)(2, function (t) {
        return function () {
          return function (t) {
            !function (t, e) {
              if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
              t.prototype = Object.create(e && e.prototype, {
                constructor: {
                  value: t,
                  writable: !0,
                  configurable: !0
                }
              }), e && wr(t, e);
            }(o, t);
            var e,
              r,
              n = (e = o, r = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                  return !1;
                }
              }(), function () {
                var t,
                  n = Pr(e);
                if (r) {
                  var o = Pr(this).constructor;
                  t = Reflect.construct(n, arguments, o);
                } else t = n.apply(this, arguments);
                return function (t, e) {
                  return !e || "object" !== jr(e) && "function" != typeof e ? function (t) {
                    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return t;
                  }(t) : e;
                }(this, t);
              });
            function o() {
              return function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, o), n.apply(this, arguments);
            }
            return o;
          }(De.pipe.apply(void 0, arguments)(t));
        };
      })),
      Sr = _r(function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
      }),
      kr = function (t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
      },
      Rr = function (t, e) {
        return String(t).localeCompare(String(e), navigator.languages[0] || navigator.language, {
          numeric: !0,
          ignorePunctuation: !0
        });
      },
      Dr = function (t, e) {
        return t.name && e.name ? Rr(String(t.name).toLowerCase(), String(e.name).toLowerCase()) : 0;
      },
      Ar = function (t, e) {
        return kr(t.toLowerCase(), e.toLowerCase());
      },
      Er = function (t) {
        return "string" == typeof t || t instanceof String;
      },
      Cr = function (t) {
        return Er(t) ? (e = "%" !== t.slice(-1) ? t : t.slice(0, -1), e = Number(e), Number.isNaN(e) ? null : e / 100) : null;
        var e;
      },
      xr = function (t) {
        return t.map(function (t) {
          return "\t• ".concat(t);
        }).join("\n");
      },
      Tr = function (t) {
        if (t.length < 2) return t[0] || "";
        var e = [].concat(t.slice(0, -2).join(", ") || []),
          r = t.slice(-2),
          n = e.length ? r.join(", and ") : r.join(" and ");
        return e.concat(n).join(", ");
      },
      Br = function (t) {
        if (null == t || "" === t) return null;
        var e = Number(t);
        if (Number.isNaN(e)) return null;
        var r,
          n = 100 * e;
        return r = n >= 100 ? n.toFixed(0) : n.toFixed(2).replace(/\.?0*$/, ""), "".concat(r, "%");
      },
      zr = function (t) {
        return t.replace(/([A-Z])/g, " $1").trim().split(" ").map(function (t) {
          return "".concat(t.slice(0, 1).toUpperCase()).concat(t.slice(1));
        }).join(" ");
      };
    function Mr(t) {
      return Mr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Mr(t);
    }
    var Nr = function t(e) {
        return e ? "function" == typeof e.slice && Array.isArray(e.slice()) ? e.slice().map(t) : "function" == typeof e.toJS ? e.toJS() : "object" === Mr(e) && Object.getPrototypeOf(e) === Object.prototype ? Object.keys(e).reduce(function (r, n) {
          return r[n] = t(e[n]), r;
        }, {}) : (0, qt.toJS)(e) : (0, qt.toJS)(e);
      },
      Fr = function (t) {
        if (!Number.isNaN(Number(t))) return "".concat(t).replace(/\.0*$/, "").replace(/(\d*\.\d*[1-9])0+$/, "$1");
      };
    function Ir(t) {
      return Ir = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ir(t);
    }
    function Vr(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Lr(t, e) {
      return Lr = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Lr(t, e);
    }
    function Yr(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function qr(t) {
      return qr = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, qr(t);
    }
    function $r(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var Ur = function (t) {
      var e, r, n, o, i, c, u;
      return o = n = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Lr(t, e);
        }(u, t);
        var e,
          r,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = qr(o);
            if (i) {
              var r = qr(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Ir(e) && "function" != typeof e ? Yr(t) : e;
            }(this, t);
          });
        function u() {
          var t;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u);
          for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
          var o = (t = c.call.apply(c, [this].concat(r))).allAttributes.reduce(function (e, r) {
            var n,
              o,
              i = e;
            return i[r.key] = null !== (n = null !== (o = t[r.key]) && void 0 !== o ? o : r.defaultValue) && void 0 !== n ? n : t.constructor.defaultValueFor(r.type), i;
          }, {});
          return (0, qt.extendObservable)(Yr(t), o), t;
        }
        return e = u, n = [{
          key: "defaultValueFor",
          value: function (t) {
            return {
              string: "",
              number: "",
              boolean: !1,
              array: [],
              modelCollection: []
            }[t];
          }
        }, {
          key: "toCamelCase",
          value: function (t) {
            return t.replace(/(_[a-z])/g, function (t) {
              return t[1].toUpperCase();
            });
          }
        }, {
          key: "toSnakeCase",
          value: function (t) {
            return t.replace(/([A-Z])/g, function (t) {
              return "_".concat(t.toLowerCase());
            });
          }
        }, {
          key: "getAttributeDefinition",
          value: function () {
            return this._attributeDefinition;
          }
        }, {
          key: "attributeDefinition",
          get: function () {
            return this.getAttributeDefinition();
          }
        }, {
          key: "_allAttributes",
          get: function () {
            return Object.values(this.attributeDefinition);
          }
        }], (r = [{
          key: "allAttributes",
          get: function () {
            return this.constructor._allAttributes;
          }
        }, {
          key: "attributeDefinition",
          get: function () {
            return this.constructor.attributeDefinition;
          }
        }, {
          key: "_attributeMap",
          get: function () {
            var t = this;
            return this.allAttributes.reduce(function (e, r) {
              return e[r.key] = r, e[r.jsKey] = r, e[t.constructor.toSnakeCase(r.key)] = r, e;
            }, {});
          }
        }, {
          key: "attributes",
          get: function () {
            var t = this;
            return this.allAttributes.map(function (e) {
              return {
                key: e.key,
                value: t[e.key]
              };
            });
          }
        }, {
          key: "duplicate",
          value: function () {
            return new this.constructor(this.toJS());
          }
        }, {
          key: "findAttribute",
          value: function (t) {
            return this.attributeDefinition[t] || this._attributeMap[t];
          }
        }, {
          key: "serialize",
          value: function () {
            return console.warn("".concat(this.constructor.name, ".serialize() is deprecated! please use toJS() instead")), console.trace(), this.toJS();
          }
        }, {
          key: "toJS",
          value: function () {
            var t = this;
            return this.allAttributes.reduce(function (e, r) {
              if ("rev" === r.key) return e;
              var n = r.jsKey || t.constructor.toSnakeCase(r.key);
              return "string" === r.type ? (e[n] = t[r.key] || null, e) : "number" === r.type ? (e[n] = 0 === t[r.key] ? 0 : t[r.key] || null, e) : "model" === r.type && t[r.key] && "function" == typeof t[r.key].toJS ? (e[n] = t[r.key].toJS(), e) : "modelCollection" === r.type ? (e[n] = t[r.key].map(function (t) {
                return t && "function" == typeof t.toJS && t.toJS();
              }).filter(Boolean), e) : "array" === r.type ? (e[n] = Nr(t[r.key] || []), e) : "object" === r.type ? (e[n] = Nr(t[r.key]), e) : (e[n] = t[r.key], e);
            }, {});
          }
        }, {
          key: "toJSON",
          value: function () {
            return this.toJS();
          }
        }, {
          key: "defaultValueOf",
          value: function (t) {
            var e;
            return null === (e = this.findAttribute(t)) || void 0 === e ? void 0 : e.defaultValue;
          }
        }, {
          key: "_maybeMigratedProps",
          value: function (t) {
            var e = t || {};
            return "function" == typeof this.constructor.migratedSchema ? this.constructor.migratedSchema(e) : e;
          }
        }, {
          key: "update",
          value: function (t) {
            var e = this,
              r = this._maybeMigratedProps(t),
              n = [],
              o = [],
              i = [];
            return Object.keys(r).forEach(function (t) {
              var c = e.findAttribute(t);
              c && ("string" !== c.type ? "boolean" !== c.type ? "number" !== c.type ? "array" !== c.type ? "object" !== c.type ? "model" !== c.type ? "modelCollection" === c.type && i.push({
                key: c.key,
                value: r[t],
                modelClass: c.modelClass,
                searchKey: c.searchKey || "id"
              }) : o.push({
                key: c.key,
                value: r[t],
                modelClass: c.modelClass
              }) : n.push({
                key: c.key,
                value: r[t]
              }) : n.push({
                key: c.key,
                value: r[t] || []
              }) : n.push({
                key: c.key,
                value: 0 === r[t] ? 0 : r[t] || ""
              }) : n.push({
                key: c.key,
                value: r[t] || !1
              }) : n.push({
                key: c.key,
                value: r[t] || ""
              }));
            }), this.updateSimpleAttributes(n), o.forEach(function (t) {
              return e.updateModelAttribute(t);
            }), this.updateModelCollectionAttributes(i), this;
          }
        }, {
          key: "updateSimpleAttributes",
          value: function (t) {
            var e = this;
            t.forEach(function (t) {
              e[t.key] = t.value;
            });
          }
        }, {
          key: "updateModelAttribute",
          value: function (t) {
            if (null != t.value) {
              if (this[t.key]) this[t.key].update(t.value);else {
                var e = t.modelClass;
                this[t.key] = new e(t.value);
              }
            } else this[t.key] = t.value;
          }
        }, {
          key: "updateCollectionAttributeElement",
          value: function (t, e) {
            var r = this[t.key].find(function (r) {
              return r[t.searchKey] === e[t.searchKey];
            });
            return r ? (r.update(e), r) : new (0, t.modelClass)(e);
          }
        }, {
          key: "updateModelCollectionAttribute",
          value: function (t) {
            var e = this;
            return (t.value || []).map(function (r) {
              return e.updateCollectionAttributeElement(t, r);
            });
          }
        }, {
          key: "updateModelCollectionAttributes",
          value: function (t) {
            var e = this;
            t.forEach(function (t) {
              e[t.key] = e.updateModelCollectionAttribute(t);
            });
          }
        }]) && Vr(e.prototype, r), n && Vr(e, n), u;
      }(t), u = {}, (c = "_attributeDefinition") in (i = n) ? Object.defineProperty(i, c, {
        value: u,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : i[c] = u, $r(e = o, "_attributeDefinition", [qt.observable], (r = (r = Object.getOwnPropertyDescriptor(e, "_attributeDefinition")) ? r.value : void 0, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        initializer: function () {
          return r;
        }
      }), e), $r(e.prototype, "allAttributes", [qt.computed], Object.getOwnPropertyDescriptor(e.prototype, "allAttributes"), e.prototype), $r(e.prototype, "attributeDefinition", [qt.computed], Object.getOwnPropertyDescriptor(e.prototype, "attributeDefinition"), e.prototype), $r(e.prototype, "_attributeMap", [qt.computed], Object.getOwnPropertyDescriptor(e.prototype, "_attributeMap"), e.prototype), $r(e.prototype, "attributes", [qt.computed], Object.getOwnPropertyDescriptor(e.prototype, "attributes"), e.prototype), $r(e.prototype, "update", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "update"), e.prototype), $r(e.prototype, "updateSimpleAttributes", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "updateSimpleAttributes"), e.prototype), $r(e.prototype, "updateModelAttribute", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "updateModelAttribute"), e.prototype), $r(e.prototype, "updateCollectionAttributeElement", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "updateCollectionAttributeElement"), e.prototype), $r(e.prototype, "updateModelCollectionAttribute", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "updateModelCollectionAttribute"), e.prototype), $r(e.prototype, "updateModelCollectionAttributes", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "updateModelCollectionAttributes"), e.prototype), e;
    };
    function Jr(t) {
      return Jr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Jr(t);
    }
    function Gr(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Hr(t, e) {
      return Hr = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Hr(t, e);
    }
    function Qr(t) {
      return Qr = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Qr(t);
    }
    function Kr(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var Wr = function (t) {
      var e, r, n, o, i, c;
      return n = r = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Hr(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = Qr(n);
            if (o) {
              var r = Qr(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Jr(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, (r = [{
          key: "allValidators",
          value: function () {
            return Object.values(this.validatorDefinition);
          }
        }, {
          key: "selectValidators",
          value: function (t) {
            var e = this;
            return null != t && t.length ? t.reduce(function (t, r) {
              var n = e.validatorDefinition[r];
              return n && t.push(n), t;
            }, []) : this.allValidators();
          }
        }, {
          key: "isValid",
          get: function () {
            return 0 === this.validate().length;
          }
        }, {
          key: "failures",
          value: function () {
            var t = this;
            return this.validations.map(function (e) {
              return e.failures(t);
            }).flat();
          }
        }, {
          key: "validate",
          value: function (t) {
            var e = this;
            return this.selectValidators(t).map(function (t) {
              if (t) {
                if ("function" == typeof t.validate) return t.validate();
                var r = e[t.key];
                if (!r) return {
                  key: t.key,
                  value: r,
                  msg: t.msg || e.constructor.blankErrorMsg
                };
                if ("model" === t.type && "validate" in r) {
                  var n = r.validate();
                  return null != n && n.length ? {
                    key: t.key,
                    type: "model",
                    value: n,
                    msg: t.msg || "model has invalid properties"
                  } : null;
                }
                if ("modelCollection" === t.type) {
                  if (null == r || !r.length) return {
                    key: t.key,
                    type: "modelCollection",
                    value: r,
                    msg: t.msg || e.constructor.blankErrorMsg
                  };
                  var o = r.map(function (t) {
                    if ("validate" in t) {
                      var e = t.validate();
                      if (!Array.isArray(e) || e.length) return e;
                    }
                  }).filter(Boolean);
                  return null != o && o.length ? {
                    key: t.key,
                    type: "modelCollection",
                    value: o,
                    msg: t.msg || "modelCollection has invalid models"
                  } : null;
                }
                return null;
              }
            }).filter(Boolean);
          }
        }]) && Gr(e.prototype, r), c;
      }(t), c = "should not be blank", (i = "blankErrorMsg") in (o = r) ? Object.defineProperty(o, i, {
        value: c,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : o[i] = c, Kr((e = n).prototype, "failures", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "failures"), e.prototype), Kr(e.prototype, "validate", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "validate"), e.prototype), e;
    };
    function Zr(t) {
      return Zr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Zr(t);
    }
    function Xr(t) {
      return function (t) {
        if (Array.isArray(t)) return tn(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }(t) || function (t, e) {
        if (t) {
          if ("string" == typeof t) return tn(t, e);
          var r = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? tn(t, e) : void 0;
        }
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function tn(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    function en(t, e, r, n) {
      r && Object.defineProperty(t, e, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function rn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function nn(t, e) {
      return nn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, nn(t, e);
    }
    function on(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function cn(t) {
      return cn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, cn(t);
    }
    function un(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var an = function (t) {
      var e, r, n;
      return e = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && nn(t, e);
        }(a, t);
        var e,
          o,
          i,
          c,
          u = (i = a, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = cn(i);
            if (c) {
              var r = cn(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Zr(e) && "function" != typeof e ? on(t) : e;
            }(this, t);
          });
        function a() {
          var t;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, a);
          for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++) o[i] = arguments[i];
          return en(on(t = u.call.apply(u, [this].concat(o))), "_pending", r, on(t)), en(on(t), "_loaded", n, on(t)), t;
        }
        return e = a, (o = [{
          key: "pending",
          get: function () {
            return Xr(this._pending.keys());
          }
        }, {
          key: "loaded",
          get: function () {
            return Xr(this._loaded.keys());
          }
        }, {
          key: "isPending",
          value: function (t) {
            return this._pending.has(t);
          }
        }, {
          key: "isLoaded",
          value: function (t) {
            return this._loaded.has(t);
          }
        }, {
          key: "setPending",
          value: function (t, e) {
            e ? this._pending.set(t, !0) : this._pending.delete(t);
          }
        }, {
          key: "setLoaded",
          value: function (t, e) {
            e ? this._loaded.set(t, !0) : this._loaded.delete(t);
          }
        }, {
          key: "finishPending",
          value: function (t) {
            this.setPending(t, !1), this.setLoaded(t, !0);
          }
        }]) && rn(e.prototype, o), a;
      }(t), r = un(e.prototype, "_pending", [qt.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return new Map();
        }
      }), n = un(e.prototype, "_loaded", [qt.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return new Map();
        }
      }), un(e.prototype, "pending", [qt.computed], Object.getOwnPropertyDescriptor(e.prototype, "pending"), e.prototype), un(e.prototype, "loaded", [qt.computed], Object.getOwnPropertyDescriptor(e.prototype, "loaded"), e.prototype), un(e.prototype, "setPending", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "setPending"), e.prototype), un(e.prototype, "setLoaded", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "setLoaded"), e.prototype), e;
    };
    function ln(t) {
      return ln = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ln(t);
    }
    function pn(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function fn(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? pn(Object(r), !0).forEach(function (e) {
          mn(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : pn(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function sn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function yn(t, e, r) {
      return yn = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = dn(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, yn(t, e, r || t);
    }
    function bn(t, e) {
      return bn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, bn(t, e);
    }
    function dn(t) {
      return dn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, dn(t);
    }
    function mn(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var hn = function (t) {
      var e, r;
      return r = e = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && bn(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = dn(n);
            if (o) {
              var r = dn(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== ln(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, r = [{
          key: "getAttributeDefinition",
          value: function () {
            return fn(fn({}, yn(dn(c), "getAttributeDefinition", this).call(this)), {}, {
              applicationMethod: {
                name: "Application Method",
                key: "applicationMethod",
                type: "string"
              }
            });
          }
        }, {
          key: "requiresTankSize",
          value: function (t) {
            var e = (0, De.find)((0, De.propEq)("text", t))(this.applicationMethods);
            return Boolean(null == e ? void 0 : e.tankSize);
          }
        }, {
          key: "requiresRate",
          value: function (t) {
            var e = (0, De.find)((0, De.propEq)("text", t))(this.applicationMethods);
            return Boolean(null == e ? void 0 : e.requiresRate);
          }
        }, {
          key: "requiresSpreader",
          value: function (t) {
            return Boolean(t.match(/spread/i));
          }
        }, {
          key: "requiresSprayer",
          value: function (t) {
            return this.requiresRate(t);
          }
        }, {
          key: "requiresTractor",
          value: function (t) {
            var e = (0, De.find)((0, De.propEq)("text", t))(this.applicationMethods);
            return Boolean(null == e ? void 0 : e.requiresTractor);
          }
        }], null && sn(e.prototype, null), r && sn(e, r), c;
      }(t), mn(e, "applicationMethods", [{
        text: "Aerial",
        coverage: !1,
        tankSize: !0,
        requiresRate: !0
      }, {
        text: "Airblast",
        coverage: !0,
        tankSize: !0,
        requiresRate: !0,
        requiresTractor: !0
      }, {
        text: "Broadcast Spray",
        coverage: !1,
        tankSize: !0,
        requiresRate: !0,
        requiresTractor: !0
      }, {
        text: "Broadcast Spread",
        coverage: !0,
        tankSize: !1,
        requiresTractor: !0
      }, {
        text: "Aerial Spread",
        coverage: !0,
        tankSize: !1
      }, {
        text: "Hand Applied",
        coverage: !0,
        tankSize: !1
      }, {
        text: "Injection",
        coverage: !1,
        tankSize: !1
      }, {
        text: "Banded Spray",
        coverage: !0,
        tankSize: !0,
        requiresRate: !0,
        requiresTractor: !0
      }, {
        text: "Subsurface Shank",
        coverage: !1,
        tankSize: !1,
        requiresTractor: !0
      }, {
        text: "Spot Spray",
        coverage: !0,
        tankSize: !0,
        requiresRate: !0,
        requiresTractor: !0
      }]), r;
    };
    function gn(t) {
      return gn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, gn(t);
    }
    function On(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function vn(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? On(Object(r), !0).forEach(function (e) {
          Sn(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : On(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function jn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function wn(t, e, r) {
      return wn = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = _n(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, wn(t, e, r || t);
    }
    function Pn(t, e) {
      return Pn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Pn(t, e);
    }
    function _n(t) {
      return _n = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, _n(t);
    }
    function Sn(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var kn,
      Rn,
      Dn = function (t) {
        var e, r, n, o, i, c, u, a, l, p;
        return o = n = function (t) {
          !function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                writable: !0,
                configurable: !0
              }
            }), e && Pn(t, e);
          }(c, t);
          var e,
            r,
            n,
            o,
            i = (n = c, o = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (t) {
                return !1;
              }
            }(), function () {
              var t,
                e = _n(n);
              if (o) {
                var r = _n(this).constructor;
                t = Reflect.construct(e, arguments, r);
              } else t = e.apply(this, arguments);
              return function (t, e) {
                return !e || "object" !== gn(e) && "function" != typeof e ? function (t) {
                  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return t;
                }(t) : e;
              }(this, t);
            });
          function c() {
            return function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, c), i.apply(this, arguments);
          }
          return e = c, r = [{
            key: "getSchemaMigrations",
            value: function () {
              return this._schemaMigrations;
            }
          }, {
            key: "getAttributeDefinition",
            value: function () {
              return vn(vn({}, wn(_n(c), "getAttributeDefinition", this).call(this)), {}, {
                schema: {
                  name: "Schema",
                  key: "schema",
                  type: "string"
                }
              });
            }
          }, {
            key: "migratedSchema",
            value: function (t) {
              if (!t || !t.schema) return t;
              for (var e = this.getSchemaMigrations(), r = vn({}, t); Object.prototype.hasOwnProperty.call(e, r.schema);) {
                var n = r.schema;
                if ((r = e[r.schema](r)).schema === n) throw new x(n);
              }
              return r;
            }
          }], null && jn(e.prototype, null), r && jn(e, r), c;
        }(t), Sn(n, "_schemaMigrations", {}), i = e = o, c = "_schemaMigrations", u = [qt.observable], r = (r = Object.getOwnPropertyDescriptor(e, "_schemaMigrations")) ? r.value : void 0, a = {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          initializer: function () {
            return r;
          }
        }, l = e, p = {}, Object.keys(a).forEach(function (t) {
          p[t] = a[t];
        }), p.enumerable = !!p.enumerable, p.configurable = !!p.configurable, ("value" in p || p.initializer) && (p.writable = !0), p = u.slice().reverse().reduce(function (t, e) {
          return e(i, c, t) || t;
        }, p), l && void 0 !== p.initializer && (p.value = p.initializer ? p.initializer.call(l) : void 0, p.initializer = void 0), void 0 === p.initializer && (Object.defineProperty(i, c, p), p = null), e;
      },
      An = l(683),
      En = (kn = new An.SchemaValidator(), (Rn = l(286)).keys().forEach(function (t) {
        kn.addSchema(Rn(t));
      }), kn);
    function Cn(t) {
      return Cn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Cn(t);
    }
    function xn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Tn(t, e) {
      return Tn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Tn(t, e);
    }
    function Bn(t) {
      return Bn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Bn(t);
    }
    var zn = function (t) {
      return function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Tn(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = Bn(n);
            if (o) {
              var r = Bn(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Cn(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, r = [{
          key: "getSchemaId",
          value: function () {
            throw new Error("getSchemaId should be defined by base class");
          }
        }, {
          key: "validateSchema",
          value: function (t) {
            En.validate(this.getSchemaId(), t);
          }
        }], null && xn(e.prototype, null), r && xn(e, r), c;
      }(t);
    };
    function Mn(t) {
      return Mn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Mn(t);
    }
    function Nn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Fn(t, e) {
      return Fn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Fn(t, e);
    }
    function In(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function Vn(t) {
      return Vn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Vn(t);
    }
    function Ln(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var Yn = function (t) {
      var e, r;
      return e = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Fn(t, e);
        }(u, t);
        var e,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = Vn(o);
            if (i) {
              var r = Vn(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Mn(e) && "function" != typeof e ? In(t) : e;
            }(this, t);
          });
        function u() {
          var t, e, n, o;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u);
          for (var i = arguments.length, a = new Array(i), l = 0; l < i; l++) a[l] = arguments[l];
          return e = In(t = c.call.apply(c, [this].concat(a))), n = r, o = In(t), n && Object.defineProperty(e, "isHighlighted", {
            enumerable: n.enumerable,
            configurable: n.configurable,
            writable: n.writable,
            value: n.initializer ? n.initializer.call(o) : void 0
          }), t;
        }
        return e = u, (n = [{
          key: "highlight",
          value: function () {
            this.isHighlighted = !0;
          }
        }, {
          key: "unHighlight",
          value: function () {
            this.isHighlighted = !1;
          }
        }, {
          key: "toggleHighlighted",
          value: function () {
            this.isHighlighted = !this.isHighlighted;
          }
        }]) && Nn(e.prototype, n), u;
      }(t), r = Ln(e.prototype, "isHighlighted", [qt.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), Ln(e.prototype, "highlight", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "highlight"), e.prototype), Ln(e.prototype, "unHighlight", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "unHighlight"), e.prototype), Ln(e.prototype, "toggleHighlighted", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "toggleHighlighted"), e.prototype), e;
    };
    function qn(t) {
      return qn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, qn(t);
    }
    function $n(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Un(t, e) {
      return Un = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Un(t, e);
    }
    function Jn(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function Gn(t) {
      return Gn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Gn(t);
    }
    function Hn(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var Qn = function (t) {
      var e, r;
      return e = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Un(t, e);
        }(u, t);
        var e,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = Gn(o);
            if (i) {
              var r = Gn(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== qn(e) && "function" != typeof e ? Jn(t) : e;
            }(this, t);
          });
        function u() {
          var t, e, n, o;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u);
          for (var i = arguments.length, a = new Array(i), l = 0; l < i; l++) a[l] = arguments[l];
          return e = Jn(t = c.call.apply(c, [this].concat(a))), n = r, o = Jn(t), n && Object.defineProperty(e, "isActive", {
            enumerable: n.enumerable,
            configurable: n.configurable,
            writable: n.writable,
            value: n.initializer ? n.initializer.call(o) : void 0
          }), t;
        }
        return e = u, (n = [{
          key: "activate",
          value: function () {
            this.isActive = !0;
          }
        }, {
          key: "deactivate",
          value: function () {
            this.isActive = !1;
          }
        }, {
          key: "setActive",
          value: function (t) {
            this.isActive = t;
          }
        }, {
          key: "toggleActive",
          value: function () {
            this.isActive = !this.isActive;
          }
        }]) && $n(e.prototype, n), u;
      }(t), r = Hn(e.prototype, "isActive", [qt.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), Hn(e.prototype, "activate", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "activate"), e.prototype), Hn(e.prototype, "deactivate", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "deactivate"), e.prototype), Hn(e.prototype, "setActive", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "setActive"), e.prototype), Hn(e.prototype, "toggleActive", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "toggleActive"), e.prototype), e;
    };
    function Kn(t) {
      return Kn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Kn(t);
    }
    function Wn(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Zn(t, e) {
      return Zn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Zn(t, e);
    }
    function Xn(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function to(t) {
      return to = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, to(t);
    }
    function eo(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var ro = function (t) {
      var e, r;
      return e = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Zn(t, e);
        }(u, t);
        var e,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = to(o);
            if (i) {
              var r = to(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Kn(e) && "function" != typeof e ? Xn(t) : e;
            }(this, t);
          });
        function u() {
          var t, e, n, o;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u);
          for (var i = arguments.length, a = new Array(i), l = 0; l < i; l++) a[l] = arguments[l];
          return e = Xn(t = c.call.apply(c, [this].concat(a))), n = r, o = Xn(t), n && Object.defineProperty(e, "isHidden", {
            enumerable: n.enumerable,
            configurable: n.configurable,
            writable: n.writable,
            value: n.initializer ? n.initializer.call(o) : void 0
          }), t;
        }
        return e = u, (n = [{
          key: "hide",
          value: function () {
            this.isHidden = !0;
          }
        }, {
          key: "show",
          value: function () {
            this.isHidden = !1;
          }
        }, {
          key: "setHidden",
          value: function (t) {
            this.isHidden = t;
          }
        }, {
          key: "toggleHidden",
          value: function () {
            this.isHidden = !this.isHidden;
          }
        }]) && Wn(e.prototype, n), u;
      }(t), r = eo(e.prototype, "isHidden", [qt.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), eo(e.prototype, "hide", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "hide"), e.prototype), eo(e.prototype, "show", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "show"), e.prototype), eo(e.prototype, "setHidden", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "setHidden"), e.prototype), eo(e.prototype, "toggleHidden", [qt.action], Object.getOwnPropertyDescriptor(e.prototype, "toggleHidden"), e.prototype), e;
    };
    function no(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    var oo = function () {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.key = e.key, this.value = e.value, this.fullMessage = e.fullMessage, this.attributeLabel = e.attributeLabel, this.description = e.description, this.subFailure = e.subFailure;
      }
      var e, r, n;
      return e = t, n = [{
        key: "newFrom",
        value: function (e, r) {
          var n = new t({
            key: e.attribute,
            attributeLabel: e.attributeLabel,
            value: e.value(r)
          });
          return e.options.fullMessage ? n.fullMessage = e.options.fullMessage : (n.attributeLabel = e.attributeLabel, n.description = e.description), n;
        }
      }], (r = [{
        key: "msg",
        get: function () {
          return this.message;
        }
      }, {
        key: "message",
        get: function () {
          if (this.fullMessage) return this.fullMessage;
          var t = this.attributeLabel,
            e = this.description;
          return this.subFailure && (e = this.subFailure.message || this.subFailure.description, this.subFailure.message || (t += " ".concat(this.subFailure.attributeLabel))), "".concat(t, " ").concat(e);
        }
      }]) && no(e.prototype, r), n && no(e, n), t;
    }();
    function io(t) {
      return io = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, io(t);
    }
    function co(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    var uo = function () {
        function t(e) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.attribute = e, this.options = r;
        }
        var e, r, n;
        return e = t, n = [{
          key: "isValidatable",
          value: function (t) {
            return "object" === io(t) && "failures" in t && "validations" in t;
          }
        }], (r = [{
          key: "attributeLabel",
          get: function () {
            return this.options.attributeLabel ? this.options.attributeLabel : this.attribute.replace(/^\w/, function (t) {
              return t.toUpperCase();
            });
          }
        }, {
          key: "description",
          get: function () {
            return this.options.description || this.defaultDescription;
          }
        }, {
          key: "value",
          value: function (t) {
            return t[this.attribute];
          }
        }, {
          key: "failures",
          value: function (t) {
            var e = this,
              r = this.value(t),
              n = [],
              o = this.failure(t);
            return o && n.push(o), r && this.constructor.isValidatable(r) && (n = n.concat(r.failures().map(function (t) {
              return e.adopt(t);
            }))), n;
          }
        }, {
          key: "adopt",
          value: function (t) {
            return new oo({
              key: this.attribute,
              attributeLabel: this.attributeLabel,
              subFailure: t
            });
          }
        }]) && co(e.prototype, r), n && co(e, n), t;
      }(),
      ao = l(211),
      lo = l.n(ao);
    function po(t) {
      return po = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, po(t);
    }
    function fo(t, e) {
      return fo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, fo(t, e);
    }
    function so(t) {
      return so = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, so(t);
    }
    var yo = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && fo(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            n = so(e);
          if (r) {
            var o = so(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== po(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o(t, e) {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), n.call(this, "Units '".concat(t, "' and '").concat(e, "' are not compatible"));
      }
      return o;
    }(c);
    function bo(t) {
      return bo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, bo(t);
    }
    function mo(t, e) {
      return mo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, mo(t, e);
    }
    function ho(t) {
      return ho = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, ho(t);
    }
    var go,
      Oo = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && mo(t, e);
        }(o, t);
        var e,
          r,
          n = (e = o, r = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              n = ho(e);
            if (r) {
              var o = ho(this).constructor;
              t = Reflect.construct(n, arguments, o);
            } else t = n.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== bo(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function o() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, o), n.call(this, "Missing required quantity");
        }
        return o;
      }(c);
    function vo(t) {
      return vo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, vo(t);
    }
    function jo(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function wo(t, e) {
      return wo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, wo(t, e);
    }
    function Po(t) {
      return Po = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Po(t);
    }
    function _o(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var So = new Map();
    So.set("<1>", "1");
    var ko = new Map([["<googol>", "googol"], ["<kibi>", "Ki"], ["<mebi>", "Mi"], ["<gibi>", "Gi"], ["<tebi>", "Ti"], ["<pebi>", "Pi"], ["<exi>", "Ei"], ["<zebi>", "Zi"], ["<yebi>", "Yi"], ["<yotta>", "Y"], ["<zetta>", "Z"], ["<exa>", "E"], ["<peta>", "P"], ["<tera>", "T"], ["<giga>", "G"], ["<mega>", "M"], ["<kilo>", "k"], ["<hecto>", "h"], ["<deca>", "da"], ["<deci>", "d"], ["<centi>", "c"], ["<milli>", "m"], ["<micro>", "u"], ["<nano>", "n"], ["<pico>", "p"], ["<femto>", "f"], ["<atto>", "a"], ["<zepto>", "z"], ["<yocto>", "y"]]),
      Ro = new Map(lo().getUnits().map(function (t) {
        return ["<".concat(t, ">"), "liter" === t ? "L" : "short-ton" === t ? "ton" : lo().getAliases(t)[0]];
      })),
      Do = (go = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && wo(t, e);
        }(u, t);
        var e,
          r,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = Po(o);
            if (i) {
              var r = Po(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== vo(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function u(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u), (e = c.call(this, t)).update(t), e;
        }
        return e = u, n = [{
          key: "getAttributeDefinition",
          value: function () {
            return {
              scalar: {
                name: "Scalar",
                key: "scalar",
                type: "string"
              },
              units: {
                name: "Units",
                key: "units",
                type: "string"
              }
            };
          }
        }, {
          key: "displayValue",
          value: function (t) {
            return this.isQuantity(t) ? t.displayValue : "";
          }
        }, {
          key: "isCompatible",
          value: function (t, e) {
            var r;
            return this.isQuantity(t) ? t.isCompatible(e) : null === (r = new this(t)) || void 0 === r ? void 0 : r.isCompatible(e);
          }
        }, {
          key: "isQuantity",
          value: function (t) {
            return t instanceof u;
          }
        }, {
          key: "isQuantityTruthy",
          value: function (t) {
            return this.isQuantity(t) && !t.isBlank && !this.isZero(t);
          }
        }, {
          key: "isZero",
          value: function (t) {
            return 0 === t || "0" === t || (u.isQuantity(t) ? t.isZero() : new u(t).isZero());
          }
        }, {
          key: "format",
          value: function (t, e, r) {
            if (1 === t && "Dry" === e) return "Dry";
            var n = t;
            return 0 !== n && (n = this.formatScalar(t, r)), [].concat(0 === n ? n : n || []).concat((null != r && r.formatUnits ? this.formatUnits(e) : e) || []).join(" ");
          }
        }, {
          key: "formatScalar",
          value: function (t, e) {
            var r = (e || {}).digits,
              n = e || {},
              o = n.fixed,
              i = n.precise;
            if (Number.isFinite(t)) {
              if (i) return Number(t);
              r = 0 === r ? 0 : r || 2;
              var c = t.toFixed(r);
              return o ? c : Number(c);
            }
            return t || "";
          }
        }, {
          key: "formatUnits",
          value: function (t) {
            var e = lo().parse(t || "");
            if (!e) throw new _(t);
            var r = this.stringifyUnitArray(e.numerator),
              n = this.stringifyUnitArray(e.denominator),
              o = "1" === r,
              i = "1" === n;
            if (o && i) return "";
            var c = [].concat(o ? [] : r || []).concat(i ? [] : "/".concat(n)).join("");
            return (c = c.replace(/1\/acre/, "/acre")).replace(/\/hgal/, "/100 gal");
          }
        }, {
          key: "stringifyUnitArray",
          value: function (t) {
            if (!t) return "";
            var e = t.toString(),
              r = So.get(e);
            return r || (r = this.simplifyUnitNames(this.getUnitNames(t)).join("*"), So.set(e, r), r);
          }
        }, {
          key: "getUnitNames",
          value: function (t) {
            for (var e, r, n = [], o = 0; o < t.length; o += 1) {
              e = t[o], r = t[o + 1];
              var i = ko.get(e);
              i ? (n.push("".concat(i).concat(Ro.get(r))), o += 1) : n.push(Ro.get(e));
            }
            return n;
          }
        }, {
          key: "simplifyUnitNames",
          value: function (t) {
            var e = {};
            return t.reduce(function (t, r) {
              var n = e[r];
              return n || (n = [r, 0], e[r] = n, t.push(n)), n[1] += 1, t;
            }, []).map(function (t) {
              return t[0] + (t[1] > 1 ? t[1] : "");
            });
          }
        }, {
          key: "toQty",
          value: function (t) {
            return lo()(t);
          }
        }, {
          key: "max",
          value: function () {
            for (var t = this, e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
            var o = [].concat(r).filter(function (e) {
              return e && t.isQuantity(e) && e.toJS();
            });
            return o.length ? o.reduce(function (t, e) {
              return e.gte(t) ? e : t;
            }) : new this("");
          }
        }], (r = [{
          key: "displayValue",
          get: function () {
            return this.constructor.format(this.scalar, this.units, {
              formatUnits: !0
            });
          }
        }, {
          key: "isBlank",
          get: function () {
            return "" === this.displayValue;
          }
        }, {
          key: "numeratorUnits",
          get: function () {
            return new (lo())({
              scalar: 1,
              numerator: this.toQty().numerator
            }).units();
          }
        }, {
          key: "update",
          value: function (t) {
            var e = t;
            if (!e && 0 !== e) return this.scalar = "", this.units = "", this;
            if ("function" == typeof e.toJS && (e = t.toJS()), "function" == typeof e.toLowerCase && e.toLowerCase().includes("dry")) return this.scalar = 1, this.units = "Dry", this;
            "function" == typeof e.replace && (e = e.replace(/\/100 gal/, "/hgal"));
            try {
              if (0 !== e && "0" !== e && !e) return this.scalar = "", this.units = "", this;
              if (e && "function" == typeof e.match) {
                var r = e.match(/^([0-9]+)\/([0-9]+)/);
                if (r) {
                  var n = r[1] / r[2];
                  e = e.replace(r[0], n.toString());
                }
              }
              var o = lo()(e);
              this.scalar = o.scalar, this.units = o.units();
            } catch (e) {
              if (!(e instanceof lo().Error)) throw e;
              this.logger.info("Ignoring bad/unknown quantity: ".concat(t));
            }
            return this;
          }
        }, {
          key: "updateScalar",
          value: function (t) {
            this.scalar = t || 0 === t ? Number(t) : "";
          }
        }, {
          key: "format",
          value: function (t) {
            return this.constructor.format(this.scalar, this.units, t);
          }
        }, {
          key: "compareTo",
          value: function (t) {
            if (!this.constructor.isQuantity(t)) return this.compareTo(new u(t));
            if (t.isBlank) throw new Oo();
            var e = this.toQty(),
              r = t.toQty();
            if (!e.isCompatible(r)) throw new yo(e.units(), r.units());
            return Math.abs(e.baseScalar - r.baseScalar) <= 1e-10 ? 0 : e.baseScalar < r.baseScalar ? -1 : e.baseScalar > r.baseScalar ? 1 : void 0;
          }
        }, {
          key: "eq",
          value: function (t) {
            try {
              return 0 === this.compareTo(t);
            } catch (e) {
              if (e instanceof Oo) return null != t && !!this.isBlank;
              if (e instanceof yo) return !1;
              throw e;
            }
          }
        }, {
          key: "gt",
          value: function (t) {
            return 1 === this.compareTo(t);
          }
        }, {
          key: "gte",
          value: function (t) {
            return this.compareTo(t) >= 0;
          }
        }, {
          key: "lt",
          value: function (t) {
            return -1 === this.compareTo(t);
          }
        }, {
          key: "lte",
          value: function (t) {
            return this.compareTo(t) <= 0;
          }
        }, {
          key: "mul",
          value: function (t) {
            var e = t instanceof u;
            return "" === this.scalar || e && "" === t.scalar || "" === t || !t ? new this.constructor("") : new this.constructor(this.toQty().mul(this.constructor.isQuantity(t) ? t.toQty() : t).toString());
          }
        }, {
          key: "add",
          value: function (t) {
            var e = this.constructor.isQuantity(t),
              r = lo()(Number(this.scalar), this.units).add(e ? lo()(Number(t.scalar), t.units) : t);
            return new this.constructor(r.toString());
          }
        }, {
          key: "div",
          value: function (t) {
            var e = t instanceof u;
            if ("" === this.scalar || e && "" === t.scalar || "" === t || !t) return new this.constructor("");
            var r = lo()(Number(this.scalar), this.units).div(e ? lo()(Number(t.scalar), t.units) : t);
            return new this.constructor(r.toString());
          }
        }, {
          key: "isCompatible",
          value: function (t) {
            return this.toQty().isCompatible(this.constructor.isQuantity(t) ? t.toQty() : t);
          }
        }, {
          key: "isZero",
          value: function () {
            return 0 === this.scalar || "0" === this.scalar;
          }
        }, {
          key: "kind",
          value: function (t) {
            var e = t instanceof Object;
            return lo()(this.scalar, this.units).kind(e ? lo()(t.scalar, t.units) : t);
          }
        }, {
          key: "sub",
          value: function (t) {
            var e = this.constructor.isQuantity(t),
              r = lo()(Number(this.scalar), this.units).sub(e ? lo()(Number(t.scalar), t.units) : t);
            return new this.constructor(r.toString());
          }
        }, {
          key: "to",
          value: function (t) {
            return new this.constructor(lo()(this.toJS()).to(t));
          }
        }, {
          key: "toJS",
          value: function () {
            return this.format({
              precise: !0
            });
          }
        }, {
          key: "toQty",
          value: function () {
            return "Dry" === this.units ? lo()(30, "min") : this.scalar || 0 === this.scalar ? lo()(Number(this.scalar), this.units) : lo()(this.units);
          }
        }]) && jo(e.prototype, r), n && jo(e, n), u;
      }(Sr(Ur, Re)), _o(go.prototype, "displayValue", [qt.computed], Object.getOwnPropertyDescriptor(go.prototype, "displayValue"), go.prototype), _o(go.prototype, "isBlank", [qt.computed], Object.getOwnPropertyDescriptor(go.prototype, "isBlank"), go.prototype), _o(go.prototype, "update", [qt.action], Object.getOwnPropertyDescriptor(go.prototype, "update"), go.prototype), _o(go.prototype, "updateScalar", [qt.action], Object.getOwnPropertyDescriptor(go.prototype, "updateScalar"), go.prototype), go);
    function Ao(t) {
      return Ao = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ao(t);
    }
    function Eo(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Co(t, e) {
      return Co = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Co(t, e);
    }
    function xo(t) {
      return xo = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, xo(t);
    }
    var To = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Co(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = xo(n);
          if (o) {
            var r = xo(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Ao(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        var t;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c);
        for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
        return (t = i.call.apply(i, [this].concat(r))).defaultDescription = "must not be blank", t;
      }
      return e = c, (r = [{
        key: "failure",
        value: function (t) {
          var e = this.value(t);
          if ((!this.options.onlyIf || this.options.onlyIf()) && (Do.isQuantity(e) ? !Do.isQuantityTruthy(e) : null == e || 0 === e.length)) return oo.newFrom(this, t);
        }
      }]) && Eo(e.prototype, r), c;
    }(uo);
    function Bo(t) {
      return Bo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Bo(t);
    }
    function zo(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Mo(t, e) {
      return Mo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Mo(t, e);
    }
    function No(t) {
      return No = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, No(t);
    }
    var Fo = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Mo(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = No(n);
          if (o) {
            var r = No(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Bo(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, (r = [{
        key: "failureDescription",
        value: function (t) {
          var e = this.value(t);
          return this.options.optional && !e ? null : this.fails("gt", e) ? "must be greater than ".concat(this.optionDisplayValue("gt")) : this.fails("gte", e) ? "must be greater than or equal to ".concat(this.optionDisplayValue("gte")) : this.fails("lt", e) ? "must be less than ".concat(this.optionDisplayValue("lt")) : this.fails("lte", e) ? "must be less than or equal to ".concat(this.optionDisplayValue("lte")) : null;
        }
      }, {
        key: "failure",
        value: function (t) {
          var e = this.failureDescription(t);
          if (e) {
            var r = oo.newFrom(this, t);
            return r.description = this.options.description || e, r;
          }
        }
      }, {
        key: "optionDisplayValue",
        value: function (t) {
          return Do.isQuantity(this.options[t]) ? this.options[t].displayValue : this.options[t];
        }
      }, {
        key: "optionIsSet",
        value: function (t) {
          return void 0 !== this.options[t] && null !== this.options[t];
        }
      }, {
        key: "fails",
        value: function (t, e) {
          if (!this.optionIsSet(t)) return !1;
          if (!e) return !0;
          if (!Do.isQuantity(e)) return !0;
          var r = this.options[t];
          return Do.isQuantity(r) ? !e[t](r) : "gt" === t ? !(e.scalar > r) : "gte" === t ? !(e.scalar >= r) : "lt" === t ? !(e.scalar < r) : "lte" === t ? !(e.scalar <= r) : void 0;
        }
      }]) && zo(e.prototype, r), c;
    }(uo);
    function Io(t) {
      return Io = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Io(t);
    }
    function Vo(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Lo(t, e) {
      return Lo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Lo(t, e);
    }
    function Yo(t) {
      return Yo = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Yo(t);
    }
    var qo = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Lo(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Yo(n);
          if (o) {
            var r = Yo(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Io(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, (r = [{
        key: "failures",
        value: function (t) {
          var e = [],
            r = this.value(t);
          return null != r && r.scalar || e.push(new oo({
            key: this.attribute,
            subFailure: new oo({
              key: "scalar",
              fullMessage: "scalar must not be blank or zero"
            })
          })), null != r && r.units || e.push(new oo({
            key: this.attribute,
            subFailure: new oo({
              key: "units",
              fullMessage: "units must not be blank"
            })
          })), e;
        }
      }]) && Vo(e.prototype, r), c;
    }(uo);
    function $o(t) {
      return $o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, $o(t);
    }
    function Uo(t, e) {
      return Uo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Uo(t, e);
    }
    function Jo(t) {
      return Jo = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Jo(t);
    }
    var Go = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Uo(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            n = Jo(e);
          if (r) {
            var o = Jo(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== $o(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o(t) {
        var e;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), (e = n.call(this, t)).update(t), e;
      }
      return o;
    }(Sr(Ur));
    function Ho(t) {
      return Ho = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ho(t);
    }
    function Qo(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Ko(t, e) {
      return Ko = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Ko(t, e);
    }
    function Wo(t) {
      return Wo = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Wo(t);
    }
    var Zo = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ko(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Wo(n);
          if (o) {
            var r = Wo(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Ho(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "fromModel",
        value: function (t) {
          return new this({
            id: t.id,
            type: t.type,
            name: t.name
          });
        }
      }, {
        key: "fromModelArray",
        value: function (t) {
          var e = this;
          return t.map(function (t) {
            return e.fromModel(t);
          });
        }
      }], null && Qo(e.prototype, null), r && Qo(e, r), c;
    }(_r(Go, dt, _t, Yt, Wr));
    function Xo(t) {
      return Xo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Xo(t);
    }
    function ti(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function ei(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ti(Object(r), !0).forEach(function (e) {
          ri(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ti(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function ri(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function ni(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function oi(t, e, r) {
      return oi = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = ci(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, oi(t, e, r || t);
    }
    function ii(t, e) {
      return ii = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ii(t, e);
    }
    function ci(t) {
      return ci = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, ci(t);
    }
    var ui,
      ai = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && ii(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = ci(n);
            if (o) {
              var r = ci(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Xo(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, r = [{
          key: "getAttributeDefinition",
          value: function () {
            var t = oi(ci(c), "getAttributeDefinition", this).call(this);
            return ei(ei({}, t), {}, {
              type: ei(ei({}, t.type), {}, {
                defaultValue: "IF2::Account"
              }),
              fullName: {
                name: "Full Name",
                key: "fullName",
                type: "string"
              }
            });
          }
        }, {
          key: "fromAccount",
          value: function (t) {
            return new c({
              id: t.id,
              serial: t.serial,
              name: t.name,
              fullName: t.fullName
            });
          }
        }, {
          key: "fromModel",
          value: function (t) {
            return this.fromAccount(t);
          }
        }, {
          key: "isAccountReference",
          value: function (t) {
            return t instanceof c;
          }
        }], null && ni(e.prototype, null), r && ni(e, r), c;
      }(_r(Zo, Tt));
    function li(t) {
      return li = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, li(t);
    }
    function pi(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function fi(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? pi(Object(r), !0).forEach(function (e) {
          si(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : pi(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function si(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function yi(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function bi(t, e, r) {
      return bi = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = mi(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, bi(t, e, r || t);
    }
    function di(t, e) {
      return di = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, di(t, e);
    }
    function mi(t) {
      return mi = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, mi(t);
    }
    var hi,
      gi,
      Oi,
      vi,
      ji,
      wi,
      Pi = (ui = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && di(t, e);
        }(u, t);
        var e,
          r,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = mi(o);
            if (i) {
              var r = mi(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== li(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function u() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u), c.apply(this, arguments);
        }
        return e = u, n = [{
          key: "getAttributeDefinition",
          value: function () {
            return fi(fi({}, bi(mi(u), "getAttributeDefinition", this).call(this)), {}, {
              clientPath: {
                name: "Client Path",
                key: "clientPath",
                type: "modelCollection",
                modelClass: ai
              }
            });
          }
        }, {
          key: "fromAccount",
          value: function (t) {
            return new u({
              id: t.id,
              serial: t.serial,
              name: t.name,
              fullName: t.fullName,
              clientPath: t.clientPath
            });
          }
        }, {
          key: "fromModel",
          value: function (t) {
            return this.fromAccount(t);
          }
        }, {
          key: "isAccountWithPath",
          value: function (t) {
            return t instanceof u;
          }
        }], (r = [{
          key: "clientPathString",
          get: function () {
            for (var t = this.clientPath.concat(this), e = [], r = t.length; r > 0; r -= 1) {
              var n = t.pop();
              if (n.fullName) {
                e.unshift(n.fullName);
                break;
              }
              e.unshift(n.name);
            }
            return e.join(": ");
          }
        }]) && yi(e.prototype, r), n && yi(e, n), u;
      }(ai), hi = ui.prototype, gi = "clientPathString", Oi = [qt.computed], vi = Object.getOwnPropertyDescriptor(ui.prototype, "clientPathString"), ji = ui.prototype, wi = {}, Object.keys(vi).forEach(function (t) {
        wi[t] = vi[t];
      }), wi.enumerable = !!wi.enumerable, wi.configurable = !!wi.configurable, ("value" in wi || wi.initializer) && (wi.writable = !0), wi = Oi.slice().reverse().reduce(function (t, e) {
        return e(hi, gi, t) || t;
      }, wi), ji && void 0 !== wi.initializer && (wi.value = wi.initializer ? wi.initializer.call(ji) : void 0, wi.initializer = void 0), void 0 === wi.initializer && (Object.defineProperty(hi, gi, wi), wi = null), ui);
    function _i(t) {
      return _i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, _i(t);
    }
    function Si(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function ki(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Si(Object(r), !0).forEach(function (e) {
          Ci(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Si(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Ri(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Di(t, e, r) {
      return Di = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Ei(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Di(t, e, r || t);
    }
    function Ai(t, e) {
      return Ai = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Ai(t, e);
    }
    function Ei(t) {
      return Ei = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Ei(t);
    }
    function Ci(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var xi,
      Ti,
      Bi,
      zi = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Ai(t, e);
        }(u, t);
        var e,
          r,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = Ei(o);
            if (i) {
              var r = Ei(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== _i(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function u() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u), c.apply(this, arguments);
        }
        return e = u, n = [{
          key: "getSchemaId",
          value: function () {
            return "https://schemas.miriamtech.com/if2/mode_of_action";
          }
        }, {
          key: "getAttributeDefinition",
          value: function () {
            var t = Di(Ei(u), "getAttributeDefinition", this).call(this);
            return ki(ki({}, t), {}, {
              schema: ki(ki({}, t.schema), {}, {
                defaultValue: this.schema
              }),
              type: ki(ki({}, t.type), {}, {
                defaultValue: this.type
              }),
              action: {
                name: "Action",
                key: "action",
                type: "string"
              },
              groupNumber: {
                name: "Group Number",
                key: "groupNumber",
                type: "string"
              },
              description: {
                name: "Description",
                key: "description",
                type: "string"
              },
              parent: {
                name: "Parent",
                key: "parent",
                type: "object"
              }
            });
          }
        }], (r = [{
          key: "toJS",
          value: function () {
            var t,
              e = Di(Ei(u.prototype), "toJS", this).call(this);
            return e.parent = e.parent || (null === (t = this.parent) || void 0 === t ? void 0 : t.toJS()) || null, e;
          }
        }]) && Ri(e.prototype, r), n && Ri(e, n), u;
      }(_r(Go, dt, Yt, Dn, zn));
    function Mi(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Ni(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Mi(Object(r), !0).forEach(function (e) {
          qi(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Mi(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Fi(t) {
      return Fi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Fi(t);
    }
    function Ii(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Vi(t, e, r) {
      return Vi = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Yi(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Vi(t, e, r || t);
    }
    function Li(t, e) {
      return Li = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Li(t, e);
    }
    function Yi(t) {
      return Yi = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Yi(t);
    }
    function qi(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function $i(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    Ci(zi, "type", "IF2::ModeOfAction"), Ci(zi, "schema", "if2/mode_of_action/v1");
    var Ui = (Bi = Ti = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Li(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Yi(o);
          if (i) {
            var r = Yi(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Fi(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.apply(this, arguments);
      }
      return e = u, n = [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/product/active_ingredient";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          return Ni(Ni({}, Vi(Yi(u), "getAttributeDefinition", this).call(this)), {}, {
            shortName: {
              name: "Short Name",
              key: "shortName",
              type: "string"
            },
            cas: {
              name: "CAS",
              key: "cas",
              type: "string"
            },
            pcCode: {
              name: "PC Code",
              key: "pcCode",
              type: "string"
            },
            percent: {
              name: "Percent",
              key: "percent",
              type: "number"
            },
            liquidConcentration: {
              name: "Liquid Concentration",
              key: "liquidConcentration",
              type: "model",
              modelClass: Do
            },
            modesOfAction: {
              name: "Mode of Action",
              key: "modesOfAction",
              type: "modelCollection",
              modelClass: zi
            },
            toxicityClass: {
              name: "Toxicity Class",
              key: "toxicityClass",
              type: "string"
            },
            toxicityCategory: {
              name: "Toxicity Category",
              key: "toxicityCategory",
              type: "string"
            },
            alternateNames: {
              name: "Alternate Name",
              key: "alternateNames",
              type: "array"
            },
            limitedByEspp: {
              name: "Limited By ESPP",
              key: "limitedByEspp",
              type: "boolean"
            }
          });
        }
      }], (r = [{
        key: "fullText",
        get: function () {
          return [].concat(this.name || []).concat(this.cas || []).concat(this.alternateNames || []).join(" ").toLowerCase();
        }
      }, {
        key: "newPrimaryName",
        value: function (t) {
          var e = this.name;
          this.update({
            alternateNames: pr(this.alternateNames.filter(function (e) {
              return e !== t;
            }).concat(e)).sort(Ar)
          }), this.name = t;
        }
      }, {
        key: "update",
        value: function (t) {
          "object" === Fi(t) && "percent" in t && null !== t.percent && (t.percent = Number(t.percent)), Vi(Yi(u.prototype), "update", this).call(this, t);
        }
      }]) && Ii(e.prototype, r), n && Ii(e, n), u;
    }(_r(Go, dt, _t, zn)), qi(Ti, "type", "IF2::ActiveIngredient"), $i((xi = Bi).prototype, "fullText", [qt.computed], Object.getOwnPropertyDescriptor(xi.prototype, "fullText"), xi.prototype), $i(xi.prototype, "newPrimaryName", [qt.action], Object.getOwnPropertyDescriptor(xi.prototype, "newPrimaryName"), xi.prototype), $i(xi.prototype, "update", [qt.action], Object.getOwnPropertyDescriptor(xi.prototype, "update"), xi.prototype), xi);
    function Ji(t) {
      return Ji = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ji(t);
    }
    function Gi(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Hi(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Gi(Object(r), !0).forEach(function (e) {
          Qi(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Gi(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Qi(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Ki(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Wi(t, e, r) {
      return Wi = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Xi(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Wi(t, e, r || t);
    }
    function Zi(t, e) {
      return Zi = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Zi(t, e);
    }
    function Xi(t) {
      return Xi = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Xi(t);
    }
    var tc = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Zi(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Xi(n);
          if (o) {
            var r = Xi(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Ji(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "from",
        value: function (t) {
          return new this(t);
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          return Hi(Hi({}, Wi(Xi(c), "getAttributeDefinition", this).call(this)), {}, {
            label: {
              name: "Label",
              key: "label",
              type: "string"
            },
            primary: {
              name: "Primary",
              key: "primary",
              type: "boolean"
            }
          });
        }
      }], null && Ki(e.prototype, null), r && Ki(e, r), c;
    }(Go);
    function ec(t) {
      return ec = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ec(t);
    }
    function rc(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function nc(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? rc(Object(r), !0).forEach(function (e) {
          oc(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : rc(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function oc(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function ic(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function cc(t, e, r) {
      return cc = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = ac(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, cc(t, e, r || t);
    }
    function uc(t, e) {
      return uc = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, uc(t, e);
    }
    function ac(t) {
      return ac = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, ac(t);
    }
    var lc = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && uc(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = ac(n);
          if (o) {
            var r = ac(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== ec(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          return nc(nc({}, cc(ac(c), "getAttributeDefinition", this).call(this)), {}, {
            value: {
              name: "Value",
              key: "value",
              type: "string"
            }
          });
        }
      }], null && ic(e.prototype, null), r && ic(e, r), c;
    }(tc);
    function pc(t) {
      return pc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, pc(t);
    }
    function fc(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function sc(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? fc(Object(r), !0).forEach(function (e) {
          yc(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : fc(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function yc(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function bc(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function dc(t, e, r) {
      return dc = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = hc(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, dc(t, e, r || t);
    }
    function mc(t, e) {
      return mc = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, mc(t, e);
    }
    function hc(t) {
      return hc = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, hc(t);
    }
    var gc = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && mc(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = hc(n);
          if (o) {
            var r = hc(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== pc(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          return sc(sc({}, dc(hc(c), "getAttributeDefinition", this).call(this)), {}, {
            address: {
              name: "Address",
              key: "address",
              type: "string"
            }
          });
        }
      }], null && bc(e.prototype, null), r && bc(e, r), c;
    }(tc);
    function Oc(t) {
      return Oc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Oc(t);
    }
    function vc(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function jc(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? vc(Object(r), !0).forEach(function (e) {
          wc(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : vc(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function wc(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Pc(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function _c(t, e, r) {
      return _c = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = kc(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, _c(t, e, r || t);
    }
    function Sc(t, e) {
      return Sc = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Sc(t, e);
    }
    function kc(t) {
      return kc = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, kc(t);
    }
    var Rc = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Sc(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = kc(n);
          if (o) {
            var r = kc(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Oc(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          return jc(jc({}, _c(kc(c), "getAttributeDefinition", this).call(this)), {}, {
            number: {
              name: "Number",
              key: "number",
              type: "string"
            }
          });
        }
      }], null && Pc(e.prototype, null), r && Pc(e, r), c;
    }(tc);
    function Dc(t) {
      return Dc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Dc(t);
    }
    function Ac(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Ec(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ac(Object(r), !0).forEach(function (e) {
          zc(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ac(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Cc(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function xc(t, e, r) {
      return xc = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Bc(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, xc(t, e, r || t);
    }
    function Tc(t, e) {
      return Tc = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Tc(t, e);
    }
    function Bc(t) {
      return Bc = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Bc(t);
    }
    function zc(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var Mc = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Tc(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Bc(n);
          if (o) {
            var r = Bc(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Dc(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = xc(Bc(c), "getAttributeDefinition", this).call(this);
          return Ec(Ec({}, t), {}, {
            type: Ec(Ec({}, t.type), {}, {
              defaultValue: this.type
            }),
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Pi
            },
            licensePlateNumber: {
              name: "License Plate Number",
              key: "licensePlateNumber",
              type: "string"
            },
            tankSize: {
              name: "Tank Size",
              key: "tankSize",
              type: "model",
              modelClass: Do
            },
            notes: {
              name: "Notes",
              key: "notes",
              type: "string"
            }
          });
        }
      }], null && Cc(e.prototype, null), r && Cc(e, r), c;
    }(_r(Go, dt, Tt, _t, Yt));
    function Nc(t) {
      return Nc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Nc(t);
    }
    function Fc(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Ic(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Fc(Object(r), !0).forEach(function (e) {
          $c(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Fc(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Vc(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Lc(t, e, r) {
      return Lc = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = qc(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Lc(t, e, r || t);
    }
    function Yc(t, e) {
      return Yc = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Yc(t, e);
    }
    function qc(t) {
      return qc = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, qc(t);
    }
    function $c(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    zc(Mc, "type", "IF2::Sprayer");
    var Uc = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Yc(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = qc(n);
          if (o) {
            var r = qc(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Nc(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = Lc(qc(c), "getAttributeDefinition", this).call(this);
          return Ic(Ic({}, t), {}, {
            type: Ic(Ic({}, t.type), {}, {
              defaultValue: this.type
            }),
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Pi
            },
            licensePlateNumber: {
              name: "License Plate Number",
              key: "licensePlateNumber",
              type: "string"
            },
            notes: {
              name: "Notes",
              key: "notes",
              type: "string"
            }
          });
        }
      }], null && Vc(e.prototype, null), r && Vc(e, r), c;
    }(_r(Go, dt, Tt, _t, Yt));
    function Jc(t) {
      return Jc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Jc(t);
    }
    function Gc(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Hc(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Gc(Object(r), !0).forEach(function (e) {
          Xc(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Gc(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Qc(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Kc(t, e, r) {
      return Kc = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Zc(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Kc(t, e, r || t);
    }
    function Wc(t, e) {
      return Wc = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Wc(t, e);
    }
    function Zc(t) {
      return Zc = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Zc(t);
    }
    function Xc(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    $c(Uc, "type", "IF2::Spreader");
    var tu,
      eu,
      ru,
      nu = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Wc(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = Zc(n);
            if (o) {
              var r = Zc(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Jc(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, r = [{
          key: "getAttributeDefinition",
          value: function () {
            var t = Kc(Zc(c), "getAttributeDefinition", this).call(this);
            return Hc(Hc({}, t), {}, {
              type: Hc(Hc({}, t.type), {}, {
                defaultValue: this.type
              }),
              account: {
                name: "Account",
                key: "account",
                type: "model",
                modelClass: Pi
              },
              licensePlateNumber: {
                name: "License Plate Number",
                key: "licensePlateNumber",
                type: "string"
              },
              notes: {
                name: "Notes",
                key: "notes",
                type: "string"
              }
            });
          }
        }], null && Qc(e.prototype, null), r && Qc(e, r), c;
      }(_r(Go, dt, Tt, _t, Yt));
    function ou(t) {
      return ou = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ou(t);
    }
    function iu(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function cu(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? iu(Object(r), !0).forEach(function (e) {
          fu(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : iu(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function uu(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function au(t, e, r) {
      return au = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = pu(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, au(t, e, r || t);
    }
    function lu(t, e) {
      return lu = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, lu(t, e);
    }
    function pu(t) {
      return pu = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, pu(t);
    }
    function fu(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function su(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    Xc(nu, "type", "IF2::Tractor");
    var yu,
      bu = (ru = eu = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && lu(t, e);
        }(u, t);
        var e,
          r,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = pu(o);
            if (i) {
              var r = pu(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== ou(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function u() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u), c.apply(this, arguments);
        }
        return e = u, n = [{
          key: "getAttributeDefinition",
          value: function () {
            var t = au(pu(u), "getAttributeDefinition", this).call(this);
            return cu(cu({}, t), {}, {
              type: cu(cu({}, t.type), {}, {
                defaultValue: this.type
              }),
              firstName: {
                name: "First Name",
                key: "firstName",
                type: "string"
              },
              lastName: {
                name: "Last Name",
                key: "lastName",
                type: "string"
              },
              licenseNumber: {
                name: "License Number",
                key: "licenseNumber",
                type: "string"
              },
              addresses: {
                name: "Address",
                key: "addresses",
                type: "modelCollection",
                modelClass: lc,
                searchKey: "value"
              },
              emails: {
                name: "Email",
                key: "emails",
                type: "modelCollection",
                modelClass: gc,
                searchKey: "address"
              },
              phones: {
                name: "Phone",
                key: "phones",
                type: "modelCollection",
                modelClass: Rc,
                searchKey: "number"
              },
              categories: {
                name: "Categories",
                key: "categories",
                type: "array"
              },
              defaultSprayer: {
                name: "Default Sprayer",
                key: "defaultSprayer",
                type: "model",
                modelClass: Mc
              },
              defaultSpreader: {
                name: "Default Spreader",
                key: "defaultSpreader",
                type: "model",
                modelClass: Uc
              },
              defaultTractor: {
                name: "Default Tractor",
                key: "defaultTractor",
                type: "model",
                modelClass: nu
              },
              userId: {
                name: "User ID",
                key: "userId",
                type: "string"
              }
            });
          }
        }], (r = [{
          key: "name",
          get: function () {
            return [].concat(this.firstName || []).concat(this.lastName || []).join(" ");
          }
        }, {
          key: "address",
          get: function () {
            return (this.primaryAddress || {
              value: ""
            }).value;
          }
        }, {
          key: "primaryAddress",
          get: function () {
            return this.addresses.length < 1 ? new lc() : this.addresses.find(function (t) {
              return t.primary;
            }) || this.addresses[0];
          }
        }, {
          key: "email",
          get: function () {
            return (this.primaryEmail || {
              address: ""
            }).address;
          }
        }, {
          key: "primaryEmail",
          get: function () {
            return this.emails.length < 1 ? new gc() : this.emails.find(function (t) {
              return t.primary;
            }) || this.hasEmail && this.emails[0];
          }
        }, {
          key: "phone",
          get: function () {
            return (this.primaryPhone || {
              number: ""
            }).number;
          }
        }, {
          key: "primaryPhone",
          get: function () {
            return this.phones.length < 1 ? new Rc() : this.phones.find(function (t) {
              return t.primary;
            }) || this.phones[0];
          }
        }, {
          key: "fullText",
          get: function () {
            return [this.firstName, this.lastName].concat(this.addresses.map(function (t) {
              return t.value;
            }), this.emails.map(function (t) {
              return t.address;
            }), this.phones.map(function (t) {
              return t.number;
            })).join(" ");
          }
        }, {
          key: "hasEmail",
          get: function () {
            return this.emails.length > 0;
          }
        }, {
          key: "setPhone",
          value: function (t) {
            var e = this.primaryPhone || new Rc({
              number: t,
              primary: !0
            });
            e.number = t, Or(this.phones, Rc.from.bind(Rc), e, {
              searchKey: "number"
            });
          }
        }, {
          key: "setAddress",
          value: function (t) {
            var e = this.primaryAddress || new lc({
              value: t,
              primary: !0
            });
            e.value = t, Or(this.addresses, lc.from.bind(lc), e, {
              searchKey: "value"
            });
          }
        }, {
          key: "setEmail",
          value: function (t) {
            var e = this.primaryEmail || new gc({
              address: t,
              primary: !0
            });
            e.address = t, Or(this.emails, gc.from.bind(gc), e, {
              searchKey: "address"
            });
          }
        }]) && uu(e.prototype, r), n && uu(e, n), u;
      }(_r(Go, dt, Yt, Tt)), fu(eu, "type", "IF2::Contact"), fu(eu, "sortByLastName", function (t, e) {
        return Rr(t.lastName.toLowerCase(), e.lastName.toLowerCase());
      }), su((tu = ru).prototype, "name", [qt.computed], Object.getOwnPropertyDescriptor(tu.prototype, "name"), tu.prototype), su(tu.prototype, "address", [qt.computed], Object.getOwnPropertyDescriptor(tu.prototype, "address"), tu.prototype), su(tu.prototype, "primaryAddress", [qt.computed], Object.getOwnPropertyDescriptor(tu.prototype, "primaryAddress"), tu.prototype), su(tu.prototype, "email", [qt.computed], Object.getOwnPropertyDescriptor(tu.prototype, "email"), tu.prototype), su(tu.prototype, "primaryEmail", [qt.computed], Object.getOwnPropertyDescriptor(tu.prototype, "primaryEmail"), tu.prototype), su(tu.prototype, "phone", [qt.computed], Object.getOwnPropertyDescriptor(tu.prototype, "phone"), tu.prototype), su(tu.prototype, "primaryPhone", [qt.computed], Object.getOwnPropertyDescriptor(tu.prototype, "primaryPhone"), tu.prototype), su(tu.prototype, "fullText", [qt.computed], Object.getOwnPropertyDescriptor(tu.prototype, "fullText"), tu.prototype), su(tu.prototype, "hasEmail", [qt.computed], Object.getOwnPropertyDescriptor(tu.prototype, "hasEmail"), tu.prototype), tu);
    function du(t) {
      return du = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, du(t);
    }
    function mu(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function hu(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? mu(Object(r), !0).forEach(function (e) {
          gu(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : mu(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function gu(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Ou(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function vu(t, e, r) {
      return vu = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = wu(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, vu(t, e, r || t);
    }
    function ju(t, e) {
      return ju = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ju(t, e);
    }
    function wu(t) {
      return wu = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, wu(t);
    }
    function Pu(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var _u = (yu = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ju(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = wu(o);
          if (i) {
            var r = wu(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== du(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.apply(this, arguments);
      }
      return e = u, n = [{
        key: "getAttributeDefinition",
        value: function () {
          return hu(hu({}, vu(wu(u), "getAttributeDefinition", this).call(this)), {}, {
            contact: {
              name: "Contact",
              key: "contact",
              type: "model",
              modelClass: bu,
              defaultValue: new bu()
            },
            tractor: {
              name: "Tractor",
              key: "tractor",
              type: "model",
              modelClass: nu
            },
            sprayer: {
              name: "Sprayer",
              key: "sprayer",
              type: "model",
              modelClass: Mc
            },
            spreader: {
              name: "Spreader",
              key: "spreader",
              type: "model",
              modelClass: Uc
            }
          });
        }
      }], (r = [{
        key: "name",
        get: function () {
          var t;
          return (null === (t = this.contact) || void 0 === t ? void 0 : t.name) || "";
        }
      }, {
        key: "phone",
        get: function () {
          var t;
          return (null === (t = this.contact) || void 0 === t ? void 0 : t.phone) || "";
        }
      }, {
        key: "address",
        get: function () {
          var t;
          return (null === (t = this.contact) || void 0 === t ? void 0 : t.address) || "";
        }
      }, {
        key: "email",
        get: function () {
          var t;
          return (null === (t = this.contact) || void 0 === t ? void 0 : t.email) || "";
        }
      }, {
        key: "licenseNumber",
        get: function () {
          var t;
          return (null === (t = this.contact) || void 0 === t ? void 0 : t.licenseNumber) || "";
        }
      }]) && Ou(e.prototype, r), n && Ou(e, n), u;
    }(_r(Go, dt, Tt, Yt)), Pu(yu.prototype, "name", [qt.computed], Object.getOwnPropertyDescriptor(yu.prototype, "name"), yu.prototype), Pu(yu.prototype, "phone", [qt.computed], Object.getOwnPropertyDescriptor(yu.prototype, "phone"), yu.prototype), Pu(yu.prototype, "address", [qt.computed], Object.getOwnPropertyDescriptor(yu.prototype, "address"), yu.prototype), Pu(yu.prototype, "email", [qt.computed], Object.getOwnPropertyDescriptor(yu.prototype, "email"), yu.prototype), Pu(yu.prototype, "licenseNumber", [qt.computed], Object.getOwnPropertyDescriptor(yu.prototype, "licenseNumber"), yu.prototype), yu);
    function Su(t) {
      return Su = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Su(t);
    }
    function ku(t, e) {
      return ku = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ku(t, e);
    }
    function Ru(t) {
      return Ru = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Ru(t);
    }
    var Du,
      Au = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && ku(t, e);
        }(o, t);
        var e,
          r,
          n = (e = o, r = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              n = Ru(e);
            if (r) {
              var o = Ru(this).constructor;
              t = Reflect.construct(n, arguments, o);
            } else t = n.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Su(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function o() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, o), n.apply(this, arguments);
        }
        return o;
      }(_r(Go, _t));
    function Eu(t) {
      return Eu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Eu(t);
    }
    function Cu(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function xu(t, e) {
      return xu = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, xu(t, e);
    }
    function Tu(t) {
      return Tu = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Tu(t);
    }
    var Bu = (Du = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && xu(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Tu(o);
          if (i) {
            var r = Tu(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Eu(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.apply(this, arguments);
      }
      return e = u, n = [{
        key: "getAttributeDefinition",
        value: function () {
          return {
            type: {
              name: "Type",
              key: "type",
              type: "string"
            }
          };
        }
      }], (r = [{
        key: "jsonString",
        get: function () {
          return JSON.stringify(this);
        }
      }]) && Cu(e.prototype, r), n && Cu(e, n), u;
    }(Sr(Ur)), function (t, e, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null);
    }(Du.prototype, "jsonString", [qt.computed], Object.getOwnPropertyDescriptor(Du.prototype, "jsonString"), Du.prototype), Du);
    function zu(t) {
      return zu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, zu(t);
    }
    function Mu(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Nu(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Mu(Object(r), !0).forEach(function (e) {
          Fu(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Mu(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Fu(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Iu(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Vu(t, e) {
      return Vu = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Vu(t, e);
    }
    function Lu(t) {
      return Lu = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Lu(t);
    }
    var Yu = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Vu(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Lu(n);
          if (o) {
            var r = Lu(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== zu(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c(t) {
        var e;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), (e = i.call(this, t)).update(t), e;
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          return Nu(Nu({}, Bu.getAttributeDefinition()), {}, {
            coordinates: {
              name: "Coordinate",
              key: "coordinates",
              type: "array"
            }
          });
        }
      }], null && Iu(e.prototype, null), r && Iu(e, r), c;
    }(Bu);
    function qu(t) {
      return qu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, qu(t);
    }
    function $u(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Uu(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? $u(Object(r), !0).forEach(function (e) {
          Qu(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : $u(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Ju(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Gu(t, e) {
      return Gu = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Gu(t, e);
    }
    function Hu(t) {
      return Hu = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Hu(t);
    }
    function Qu(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var Ku = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Gu(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Hu(n);
          if (o) {
            var r = Hu(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== qu(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = Yu.getAttributeDefinition();
          return Uu(Uu({}, t), {}, {
            type: Uu(Uu({}, t.type), {}, {
              defaultValue: this.type
            })
          });
        }
      }], null && Ju(e.prototype, null), r && Ju(e, r), c;
    }(Yu);
    function Wu(t) {
      return Wu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Wu(t);
    }
    function Zu(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Xu(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Zu(Object(r), !0).forEach(function (e) {
          na(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Zu(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function ta(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function ea(t, e) {
      return ea = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ea(t, e);
    }
    function ra(t) {
      return ra = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, ra(t);
    }
    function na(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    Qu(Ku, "type", "Polygon");
    var oa = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ea(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = ra(n);
          if (o) {
            var r = ra(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Wu(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = Yu.getAttributeDefinition();
          return Xu(Xu({}, t), {}, {
            type: Xu(Xu({}, t.type), {}, {
              defaultValue: this.type
            })
          });
        }
      }], null && ta(e.prototype, null), r && ta(e, r), c;
    }(Yu);
    function ia(t) {
      return ia = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ia(t);
    }
    function ca(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function ua(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ca(Object(r), !0).forEach(function (e) {
          fa(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ca(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function aa(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function la(t, e) {
      return la = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, la(t, e);
    }
    function pa(t) {
      return pa = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, pa(t);
    }
    function fa(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    na(oa, "type", "MultiPolygon");
    var sa = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && la(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = pa(n);
          if (o) {
            var r = pa(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== ia(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = Yu.getAttributeDefinition();
          return ua(ua({}, t), {}, {
            type: ua(ua({}, t.type), {}, {
              defaultValue: this.type
            })
          });
        }
      }], null && aa(e.prototype, null), r && aa(e, r), c;
    }(Yu);
    function ya(t) {
      return ya = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ya(t);
    }
    function ba(t, e) {
      return ba = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ba(t, e);
    }
    function da(t, e) {
      return !e || "object" !== ya(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }
    function ma(t) {
      return ma = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, ma(t);
    }
    function ha(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    fa(sa, "type", "Point");
    var ga = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ba(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            n = ma(e);
          if (r) {
            var o = ma(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return da(this, t);
        });
      function o(t) {
        var e;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o);
        var r = t || {};
        if (e = n.call(this, r), !r.type) throw new Error("Not valid GeoJSON");
        switch (r.type) {
          case "Point":
            return da(e, new e.constructor.PointGeometryClass(r));
          case "Polygon":
            return da(e, new e.constructor.PolygonGeometryClass(r));
          case "MultiPolygon":
            return da(e, new e.constructor.MultiPolygonGeometryClass(r));
          default:
            throw new D(r.type);
        }
        return e;
      }
      return o;
    }(Yu);
    function Oa(t) {
      return Oa = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Oa(t);
    }
    function va(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function ja(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? va(Object(r), !0).forEach(function (e) {
          Sa(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : va(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function wa(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Pa(t, e) {
      return Pa = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Pa(t, e);
    }
    function _a(t) {
      return _a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, _a(t);
    }
    function Sa(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    ha(ga, "PointGeometryClass", sa), ha(ga, "PolygonGeometryClass", Ku), ha(ga, "MultiPolygonGeometryClass", oa);
    var ka,
      Ra,
      Da,
      Aa = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Pa(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = _a(n);
            if (o) {
              var r = _a(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Oa(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (e = i.call(this, t)).update(t), e;
        }
        return e = c, r = [{
          key: "getAttributeDefinition",
          value: function () {
            var t = Bu.getAttributeDefinition();
            return ja(ja({}, t), {}, {
              type: ja(ja({}, t.type), {}, {
                defaultValue: this.type
              }),
              geometry: {
                name: "Geometry",
                key: "geometry",
                type: "model",
                modelClass: ga
              },
              properties: {
                name: "Properties",
                key: "properties",
                type: "object"
              }
            });
          }
        }], null && wa(e.prototype, null), r && wa(e, r), c;
      }(Bu);
    function Ea(t) {
      return Ea = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ea(t);
    }
    function Ca(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function xa(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ca(Object(r), !0).forEach(function (e) {
          Na(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ca(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Ta(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Ba(t, e, r) {
      return Ba = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Ma(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Ba(t, e, r || t);
    }
    function za(t, e) {
      return za = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, za(t, e);
    }
    function Ma(t) {
      return Ma = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Ma(t);
    }
    function Na(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    Sa(Aa, "type", "Feature");
    var Fa = (Da = Ra = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && za(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Ma(o);
          if (i) {
            var r = Ma(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Ea(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u(t) {
        var e;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), (e = c.call(this, t)).update(t), e;
      }
      return e = u, n = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = Bu.getAttributeDefinition();
          return xa(xa({}, t), {}, {
            type: xa(xa({}, t.type), {}, {
              defaultValue: "FeatureCollection"
            }),
            features: {
              name: "Feature",
              key: "features",
              type: "modelCollection"
            }
          });
        }
      }], (r = [{
        key: "updateCollectionAttributeElement",
        value: function (t, e) {
          return ["FeatureCollection", "Feature"].includes(e.type) ? new ("FeatureCollection" === e.type ? this.constructor.FeatureCollectionClass : this.constructor.FeatureClass)(e) : Ba(Ma(u.prototype), "updateCollectionAttributeElement", this).call(this, t, e);
        }
      }]) && Ta(e.prototype, r), n && Ta(e, n), u;
    }(Bu), Na(Ra, "type", "FeatureCollection"), Na(Ra, "FeatureCollectionClass", Ra), Na(Ra, "FeatureClass", Aa), function (t, e, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null);
    }((ka = Da).prototype, "updateCollectionAttributeElement", [qt.action], Object.getOwnPropertyDescriptor(ka.prototype, "updateCollectionAttributeElement"), ka.prototype), ka);
    function Ia(t) {
      return Ia = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ia(t);
    }
    function Va(t, e) {
      return Va = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Va(t, e);
    }
    function La(t, e) {
      return !e || "object" !== Ia(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }
    function Ya(t) {
      return Ya = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Ya(t);
    }
    function qa(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var $a = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Va(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            n = Ya(e);
          if (r) {
            var o = Ya(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return La(this, t);
        });
      function o(t) {
        var e;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o);
        var r = t || {};
        if (e = n.call(this, r), !r.type) throw new v();
        switch (r.type) {
          case "FeatureCollection":
            return La(e, new e.constructor.FeatureCollectionClass(r));
          case "Feature":
            return La(e, new e.constructor.FeatureClass(r));
          default:
            throw new m();
        }
        return e;
      }
      return o;
    }(Bu);
    function Ua(t) {
      return Ua = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ua(t);
    }
    function Ja(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Ga(t, e) {
      return Ga = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Ga(t, e);
    }
    function Ha(t, e) {
      return !e || "object" !== Ua(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }
    function Qa(t) {
      return Qa = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Qa(t);
    }
    function Ka(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    qa($a, "FeatureCollectionClass", Fa), qa($a, "FeatureClass", Aa);
    var Wa = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ga(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Qa(n);
          if (o) {
            var r = Qa(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return Ha(this, t);
        });
      function c(t) {
        var e;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c);
        var r = t || {
          type: "FeatureCollection",
          features: []
        };
        if ("string" == typeof r && (r = JSON.parse(r)), e = i.call(this, r), !r.type) throw new v();
        return "FeatureCollection" === r.type || "Feature" === r.type ? Ha(e, new e.constructor.FeatureBuilderClass(r)) : Ha(e, new e.constructor.FeatureGeometryClass(r));
      }
      return e = c, r = [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/field/geo_json";
        }
      }], null && Ja(e.prototype, null), r && Ja(e, r), c;
    }(_r(Bu, zn));
    function Za(t) {
      return Za = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Za(t);
    }
    function Xa(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function tl(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Xa(Object(r), !0).forEach(function (e) {
          el(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Xa(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function el(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function rl(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function nl(t, e, r) {
      return nl = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = il(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, nl(t, e, r || t);
    }
    function ol(t, e) {
      return ol = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ol(t, e);
    }
    function il(t) {
      return il = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, il(t);
    }
    Ka(Wa, "FeatureBuilderClass", $a), Ka(Wa, "FeatureGeometryClass", ga);
    var cl = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ol(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = il(n);
          if (o) {
            var r = il(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Za(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          return tl(tl({}, nl(il(c), "getAttributeDefinition", this).call(this)), {}, {
            percent: {
              name: "Percent",
              key: "percent",
              type: "string"
            }
          });
        }
      }], null && rl(e.prototype, null), r && rl(e, r), c;
    }(_r(Go, _t));
    function ul(t) {
      return ul = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ul(t);
    }
    function al(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function ll(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? al(Object(r), !0).forEach(function (e) {
          pl(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : al(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function pl(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function fl(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function sl(t, e, r) {
      return sl = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = bl(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, sl(t, e, r || t);
    }
    function yl(t, e) {
      return yl = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, yl(t, e);
    }
    function bl(t) {
      return bl = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, bl(t);
    }
    var dl = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && yl(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = bl(n);
          if (o) {
            var r = bl(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== ul(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          return ll(ll({}, sl(bl(c), "getAttributeDefinition", this).call(this)), {}, {
            variety: {
              name: "Variety",
              key: "variety",
              type: "string"
            }
          });
        }
      }], null && fl(e.prototype, null), r && fl(e, r), c;
    }(_r(Go, _t));
    function ml(t) {
      return ml = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ml(t);
    }
    function hl(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function gl(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? hl(Object(r), !0).forEach(function (e) {
          Ol(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : hl(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Ol(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function vl(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function jl(t, e, r) {
      return jl = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Pl(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, jl(t, e, r || t);
    }
    function wl(t, e) {
      return wl = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, wl(t, e);
    }
    function Pl(t) {
      return Pl = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Pl(t);
    }
    var _l = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && wl(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Pl(n);
          if (o) {
            var r = Pl(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== ml(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          return gl(gl({}, jl(Pl(c), "getAttributeDefinition", this).call(this)), {}, {
            percent: {
              name: "Percent",
              key: "percent",
              type: "string"
            }
          });
        }
      }], null && vl(e.prototype, null), r && vl(e, r), c;
    }(_r(Go, _t));
    function Sl(t) {
      return Sl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Sl(t);
    }
    function kl(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Rl(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? kl(Object(r), !0).forEach(function (e) {
          xl(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : kl(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Dl(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Al(t, e, r) {
      return Al = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Cl(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Al(t, e, r || t);
    }
    function El(t, e) {
      return El = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, El(t, e);
    }
    function Cl(t) {
      return Cl = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Cl(t);
    }
    function xl(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var Tl,
      Bl = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && El(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = Cl(n);
            if (o) {
              var r = Cl(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Sl(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, r = [{
          key: "getAttributeDefinition",
          value: function () {
            return Rl(Rl({}, Al(Cl(c), "getAttributeDefinition", this).call(this)), {}, {
              varieties: {
                name: "Variety",
                key: "varieties",
                type: "modelCollection",
                searchKey: "name",
                modelClass: cl
              },
              cultivars: {
                name: "Cultivar",
                key: "cultivars",
                type: "modelCollection",
                searchKey: "id",
                modelClass: dl
              },
              rootStocks: {
                name: "Rootstock",
                key: "rootStocks",
                type: "modelCollection",
                searchKey: "id",
                modelClass: _l
              },
              useTypes: {
                name: "Use Type",
                key: "useTypes",
                type: "array"
              }
            });
          }
        }], null && Dl(e.prototype, null), r && Dl(e, r), c;
      }(_r(Go, dt, _t));
    function zl(t) {
      return zl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, zl(t);
    }
    function Ml(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Nl(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ml(Object(r), !0).forEach(function (e) {
          Fl(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ml(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Fl(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Il(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Vl(t, e, r) {
      return Vl = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Yl(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Vl(t, e, r || t);
    }
    function Ll(t, e) {
      return Ll = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Ll(t, e);
    }
    function Yl(t) {
      return Yl = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Yl(t);
    }
    function ql(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    xl(Bl, "type", "IF2::Crop");
    var $l = (Tl = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ll(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Yl(o);
          if (i) {
            var r = Yl(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== zl(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.apply(this, arguments);
      }
      return e = u, n = [{
        key: "getAttributeDefinition",
        value: function () {
          return Nl(Nl({}, Vl(Yl(u), "getAttributeDefinition", this).call(this)), {}, {
            percentage: {
              name: "Percentage",
              key: "percentage",
              type: "number",
              defaultValue: 1
            }
          });
        }
      }], (r = [{
        key: "update",
        value: function (t) {
          var e = t || {};
          "percentage" in e ? e.percentage = null === e.percentage ? null : Number(e.percentage) : "percent" in e && (e.percentage = null === e.percent ? null : Number(e.percent) / 100), Vl(Yl(u.prototype), "update", this).call(this, e);
        }
      }, {
        key: "percent",
        get: function () {
          return "number" != typeof this.percentage ? null : 100 * this.percentage;
        }
      }]) && Il(e.prototype, r), n && Il(e, n), u;
    }(_r(Go, _t)), ql(Tl.prototype, "update", [qt.action], Object.getOwnPropertyDescriptor(Tl.prototype, "update"), Tl.prototype), ql(Tl.prototype, "percent", [qt.computed], Object.getOwnPropertyDescriptor(Tl.prototype, "percent"), Tl.prototype), Tl);
    function Ul(t) {
      return Ul = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ul(t);
    }
    function Jl(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Gl(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Jl(Object(r), !0).forEach(function (e) {
          Hl(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Jl(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Hl(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Ql(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Kl(t, e, r) {
      return Kl = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Zl(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Kl(t, e, r || t);
    }
    function Wl(t, e) {
      return Wl = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Wl(t, e);
    }
    function Zl(t) {
      return Zl = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Zl(t);
    }
    var Xl = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Wl(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Zl(n);
          if (o) {
            var r = Zl(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Ul(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          return Gl(Gl({}, Kl(Zl(c), "getAttributeDefinition", this).call(this)), {}, {
            percentage: {
              key: "percentage",
              type: "number",
              defaultValue: 1
            }
          });
        }
      }], null && Ql(e.prototype, null), r && Ql(e, r), c;
    }(_r(Go, _t));
    function tp(t) {
      return tp = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, tp(t);
    }
    function ep(t, e) {
      return ep = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ep(t, e);
    }
    function rp(t) {
      return rp = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, rp(t);
    }
    var np,
      op,
      ip,
      cp = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && ep(t, e);
        }(o, t);
        var e,
          r,
          n = (e = o, r = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              n = rp(e);
            if (r) {
              var o = rp(this).constructor;
              t = Reflect.construct(n, arguments, o);
            } else t = n.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== tp(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function o() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, o), n.apply(this, arguments);
        }
        return o;
      }(_r(Go, _t));
    function up(t) {
      return up = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, up(t);
    }
    function ap(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function lp(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ap(Object(r), !0).forEach(function (e) {
          bp(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ap(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function pp(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function fp(t, e, r) {
      return fp = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = yp(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, fp(t, e, r || t);
    }
    function sp(t, e) {
      return sp = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, sp(t, e);
    }
    function yp(t) {
      return yp = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, yp(t);
    }
    function bp(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function dp(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var mp,
      hp,
      gp,
      Op = (ip = op = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && sp(t, e);
        }(u, t);
        var e,
          r,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = yp(o);
            if (i) {
              var r = yp(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== up(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function u() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u), c.apply(this, arguments);
        }
        return e = u, n = [{
          key: "getSchemaId",
          value: function () {
            return "https://schemas.miriamtech.com/if2/field";
          }
        }, {
          key: "getAttributeDefinition",
          value: function () {
            var t = fp(yp(u), "getAttributeDefinition", this).call(this);
            return lp(lp({}, t), {}, {
              schema: lp(lp({}, t.schema), {}, {
                defaultValue: this.schema
              }),
              type: lp(lp({}, t.type), {}, {
                defaultValue: this.type
              }),
              account: {
                name: "Account",
                key: "account",
                type: "model",
                modelClass: Pi,
                defaultValue: new Pi()
              },
              crop: {
                name: "Crop",
                key: "crop",
                type: "model",
                modelClass: Bl,
                defaultValue: new Bl()
              },
              fieldVarieties: {
                name: "Variety",
                key: "fieldVarieties",
                jsKey: "varieties",
                type: "modelCollection",
                searchKey: "name",
                modelClass: $l
              },
              county: {
                name: "County",
                key: "county",
                type: "string"
              },
              yearPlanted: {
                name: "Year Planted",
                key: "yearPlanted",
                type: "string"
              },
              area: {
                name: "Area",
                key: "area",
                type: "model",
                modelClass: Do,
                defaultValue: new Do("")
              },
              rowSpacing: {
                name: "Row Spacing",
                key: "rowSpacing",
                type: "model",
                modelClass: Do,
                defaultValue: new Do("")
              },
              plantSpacing: {
                key: "plantSpacing",
                type: "model",
                modelClass: Do,
                defaultValue: new Do("")
              },
              treeDensity: {
                key: "treeDensity",
                type: "model",
                modelClass: Do,
                defaultValue: new Do("")
              },
              irrigationRate: {
                key: "irrigationRate",
                type: "model",
                modelClass: Do,
                defaultValue: new Do("")
              },
              elevation: {
                key: "elevation",
                type: "model",
                modelClass: Do,
                defaultValue: new Do("")
              },
              notes: {
                name: "Notes",
                key: "notes",
                type: "string"
              },
              nearestRegion: {
                key: "nearestRegion",
                type: "string"
              },
              harvestLot: {
                key: "harvestLot",
                type: "string"
              },
              previousCrop: {
                key: "previousCrop",
                type: "string"
              },
              longitude: {
                name: "Longitude",
                key: "longitude",
                type: "string"
              },
              latitude: {
                name: "Latitude",
                key: "latitude",
                type: "string"
              },
              nonBearing: {
                name: "Non Bearing",
                key: "nonBearing",
                type: "boolean"
              },
              geoJson: {
                name: "GeoJSON",
                key: "geoJson",
                type: "model",
                modelClass: Wa
              },
              acidWaterTreatment: {
                key: "acidWaterTreatment",
                type: "boolean"
              },
              organic: {
                name: "Organic",
                key: "organic",
                type: "boolean"
              },
              transitional: {
                key: "transitional",
                type: "boolean"
              },
              transitionalDate: {
                key: "transitionalDate",
                type: "string"
              },
              organicDate: {
                name: "Organic Date",
                key: "organicDate",
                type: "string"
              },
              accountingReference: {
                name: "Accounting Reference",
                key: "accountingReference",
                type: "string"
              },
              inactive: {
                name: "Inactive",
                key: "inactive",
                type: "boolean"
              },
              cultivars: {
                key: "cultivars",
                type: "modelCollection",
                searchKey: "name",
                modelClass: Au
              },
              rootStocks: {
                key: "rootStocks",
                type: "modelCollection",
                searchKey: "name",
                modelClass: Xl
              },
              useTypes: {
                key: "useTypes",
                type: "modelCollection",
                searchKey: "name",
                modelClass: cp
              }
            });
          }
        }], (r = [{
          key: "acreage",
          get: function () {
            return this.area.displayValue;
          }
        }, {
          key: "acres",
          get: function () {
            var t;
            return (null === (t = this.area) || void 0 === t ? void 0 : t.scalar) || 0;
          }
        }, {
          key: "clientPathFieldName",
          get: function () {
            return [].concat(this.account.clientPathString || []).concat(this.name).join(": ");
          }
        }, {
          key: "countyName",
          get: function () {
            return this.county ? this.county.match(/county/i) ? this.county : "".concat(this.county, " County") : null;
          }
        }, {
          key: "cropName",
          get: function () {
            return this.crop.name || "";
          }
        }, {
          key: "fullText",
          get: function () {
            return [this.clientPathFieldName, this.cropName, this.organic ? "organic" : "", this.varieties.filter(function (t) {
              return !!t;
            }).map(function (t) {
              return t.name;
            }).join(" ")].filter(function (t) {
              return !!t;
            }).join(" ");
          }
        }, {
          key: "fullTextLowercase",
          get: function () {
            return this.fullText.toLowerCase();
          }
        }, {
          key: "gps",
          get: function () {
            if (!this.latitude && !this.longitude) return "";
            var t = parseFloat(this.latitude).toFixed(4),
              e = parseFloat(this.longitude).toFixed(4);
            return "".concat(t, ",").concat(e);
          }
        }, {
          key: "textIndex",
          get: function () {
            return [this.clientPathFieldName, this.cropName, this.organic ? "organic" : "", this.varieties.filter(function (t) {
              return !!t;
            }).map(function (t) {
              return t.name;
            }).join(" ")].filter(function (t) {
              return !!t;
            }).join(" ").toLowerCase();
          }
        }, {
          key: "varieties",
          get: function () {
            var t;
            return null !== (t = this.fieldVarieties) && void 0 !== t && t.length ? this.fieldVarieties : this.crop.varieties;
          }
        }, {
          key: "varietyNames",
          get: function () {
            return this.varieties.slice().sort(function (t, e) {
              return t.percent === e.percent ? Dr(t, e) : parseFloat(e.percent) - parseFloat(t.percent);
            }).map(function (t) {
              return t.name;
            }).join(", ");
          }
        }]) && pp(e.prototype, r), n && pp(e, n), u;
      }(_r(Go, dt, _t, Xe, Tt, ar, Dn, zn, Yt, Kt)), bp(op, "type", "IF2::Field"), bp(op, "schema", "if2/field/v1"), dp((np = ip).prototype, "acreage", [qt.computed], Object.getOwnPropertyDescriptor(np.prototype, "acreage"), np.prototype), dp(np.prototype, "acres", [qt.computed], Object.getOwnPropertyDescriptor(np.prototype, "acres"), np.prototype), dp(np.prototype, "clientPathFieldName", [qt.computed], Object.getOwnPropertyDescriptor(np.prototype, "clientPathFieldName"), np.prototype), dp(np.prototype, "countyName", [qt.computed], Object.getOwnPropertyDescriptor(np.prototype, "countyName"), np.prototype), dp(np.prototype, "cropName", [qt.computed], Object.getOwnPropertyDescriptor(np.prototype, "cropName"), np.prototype), dp(np.prototype, "fullText", [qt.computed], Object.getOwnPropertyDescriptor(np.prototype, "fullText"), np.prototype), dp(np.prototype, "fullTextLowercase", [qt.computed], Object.getOwnPropertyDescriptor(np.prototype, "fullTextLowercase"), np.prototype), dp(np.prototype, "gps", [qt.computed], Object.getOwnPropertyDescriptor(np.prototype, "gps"), np.prototype), dp(np.prototype, "textIndex", [qt.computed], Object.getOwnPropertyDescriptor(np.prototype, "textIndex"), np.prototype), dp(np.prototype, "varieties", [qt.computed], Object.getOwnPropertyDescriptor(np.prototype, "varieties"), np.prototype), dp(np.prototype, "varietyNames", [qt.computed], Object.getOwnPropertyDescriptor(np.prototype, "varietyNames"), np.prototype), np);
    function vp(t) {
      return vp = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, vp(t);
    }
    function jp(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function wp(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? jp(Object(r), !0).forEach(function (e) {
          Rp(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : jp(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Pp(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function _p(t, e, r) {
      return _p = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = kp(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, _p(t, e, r || t);
    }
    function Sp(t, e) {
      return Sp = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Sp(t, e);
    }
    function kp(t) {
      return kp = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, kp(t);
    }
    function Rp(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var Dp = (gp = hp = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Sp(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = kp(o);
          if (i) {
            var r = kp(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== vp(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.apply(this, arguments);
      }
      return e = u, n = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = _p(kp(u), "getAttributeDefinition", this).call(this);
          return wp(wp({}, t), {}, {
            type: wp(wp({}, t.type), {}, {
              defaultValue: this.type
            }),
            applicationId: {
              name: "Application ID",
              key: "applicationId",
              type: "number"
            },
            field: {
              name: "Field",
              key: "field",
              type: "model",
              modelClass: Op,
              defaultValue: new Op()
            },
            acres: {
              name: "Acres",
              key: "acres",
              type: "number"
            },
            percentage: {
              name: "Percentage",
              key: "percentage",
              type: "number"
            },
            coveragePercentage: {
              name: "Coverage Percentage",
              key: "coveragePercentage",
              type: "number"
            }
          });
        }
      }], (r = [{
        key: "treatedAcres",
        get: function () {
          return parseFloat(this.acres || 0) * parseFloat(this.coveragePercentage || 0) / 100;
        }
      }]) && Pp(e.prototype, r), n && Pp(e, n), u;
    }(_r(Go, dt, Tt, Yt)), Rp(hp, "type", "IF2::SprayRecord::FieldCompletion"), function (t, e, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null);
    }((mp = gp).prototype, "treatedAcres", [qt.computed], Object.getOwnPropertyDescriptor(mp.prototype, "treatedAcres"), mp.prototype), mp);
    function Ap(t) {
      return Ap = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ap(t);
    }
    function Ep(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Cp(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ep(Object(r), !0).forEach(function (e) {
          xp(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ep(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function xp(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Tp(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Bp(t, e, r) {
      return Bp = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Mp(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Bp(t, e, r || t);
    }
    function zp(t, e) {
      return zp = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, zp(t, e);
    }
    function Mp(t) {
      return Mp = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Mp(t);
    }
    var Np = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && zp(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Mp(n);
          if (o) {
            var r = Mp(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Ap(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = Bp(Mp(c), "getAttributeDefinition", this).call(this);
          return Cp(Cp({}, t), {}, {
            type: Cp(Cp({}, t.type), {}, {
              defaultValue: "IF2::Field"
            }),
            crop: {
              name: "Crop",
              key: "crop",
              type: "model",
              modelClass: Zo,
              defaultValue: new Zo()
            }
          });
        }
      }], null && Tp(e.prototype, null), r && Tp(e, r), c;
    }(Zo);
    function Fp(t) {
      return Fp = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Fp(t);
    }
    function Ip(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Vp(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ip(Object(r), !0).forEach(function (e) {
          Lp(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ip(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Lp(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Yp(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function qp(t, e, r) {
      return qp = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Up(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, qp(t, e, r || t);
    }
    function $p(t, e) {
      return $p = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, $p(t, e);
    }
    function Up(t) {
      return Up = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Up(t);
    }
    var Jp = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && $p(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Up(n);
          if (o) {
            var r = Up(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Fp(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          return Vp(Vp({}, qp(Up(c), "getAttributeDefinition", this).call(this)), {}, {
            description: {
              name: "Description",
              key: "description",
              type: "string"
            },
            baseUnit: {
              name: "Base Unit",
              key: "baseUnit",
              type: "string"
            }
          });
        }
      }], null && Yp(e.prototype, null), r && Yp(e, r), c;
    }(_r(Go, Yt));
    function Gp(t) {
      return Gp = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Gp(t);
    }
    var Hp,
      Qp = ["n", "p", "k", "humicAcid"];
    function Kp(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Wp(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Kp(Object(r), !0).forEach(function (e) {
          Zp(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Kp(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Zp(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Xp(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function tf(t, e, r) {
      return tf = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = rf(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, tf(t, e, r || t);
    }
    function ef(t, e) {
      return ef = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ef(t, e);
    }
    function rf(t) {
      return rf = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, rf(t);
    }
    function nf(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var of,
      cf,
      uf,
      af = (Hp = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && ef(t, e);
        }(u, t);
        var e,
          r,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = rf(o);
            if (i) {
              var r = rf(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Gp(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function u() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u), c.apply(this, arguments);
        }
        return e = u, n = [{
          key: "getSchemaId",
          value: function () {
            return "https://schemas.miriamtech.com/if2/product/nutrient_analysis";
          }
        }, {
          key: "getAttributeDefinition",
          value: function () {
            return Wp(Wp({}, tf(rf(u), "getAttributeDefinition", this).call(this)), {}, {
              n: {
                name: "N",
                key: "n",
                type: "string"
              },
              p: {
                name: "P",
                key: "p",
                type: "string"
              },
              k: {
                name: "K",
                key: "k",
                type: "string"
              },
              s: {
                name: "S",
                key: "s",
                type: "string"
              },
              ca: {
                name: "Ca",
                key: "ca",
                type: "string"
              },
              mg: {
                name: "Mg",
                key: "mg",
                type: "string"
              },
              al: {
                name: "Al",
                key: "al",
                type: "string"
              },
              b: {
                name: "B",
                key: "b",
                type: "string"
              },
              cu: {
                name: "Cu",
                key: "cu",
                type: "string"
              },
              fe: {
                name: "Fe",
                key: "fe",
                type: "string"
              },
              mn: {
                name: "Mn",
                key: "mn",
                type: "string"
              },
              mo: {
                name: "Mo",
                key: "mo",
                type: "string"
              },
              si: {
                name: "Si",
                key: "si",
                type: "string"
              },
              zn: {
                name: "Zn",
                key: "zn",
                type: "string"
              },
              humicAcid: {
                name: "Humic Acid",
                key: "humicAcid",
                jsKey: "humicAcid",
                type: "string"
              }
            });
          }
        }, {
          key: "nutrientLabelComponent",
          value: function (t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Fr,
              n = Number(t);
            return e && 0 === n ? "" : "".concat(r(t) || "0").concat(e);
          }
        }], (r = [{
          key: "npkLabel",
          value: function (t) {
            var e = this.constructor.attributeDefinition,
              r = e.n,
              n = e.p,
              o = e.k;
            return [u.nutrientLabelComponent(this[r.key], "", t), u.nutrientLabelComponent(this[n.key], "", t), u.nutrientLabelComponent(this[o.key], "", t)];
          }
        }, {
          key: "metalsLabel",
          value: function () {
            var t = this,
              e = this.constructor.attributeDefinition,
              r = (e.n, e.p, e.k, e.humicAcid, function (t, e) {
                if (null == t) return {};
                var r,
                  n,
                  o = function (t, e) {
                    if (null == t) return {};
                    var r,
                      n,
                      o = {},
                      i = Object.keys(t);
                    for (n = 0; n < i.length; n++) r = i[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
                    return o;
                  }(t, e);
                if (Object.getOwnPropertySymbols) {
                  var i = Object.getOwnPropertySymbols(t);
                  for (n = 0; n < i.length; n++) r = i[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
                }
                return o;
              }(e, Qp));
            return Object.keys(r).map(function (e) {
              return u.nutrientLabelComponent(t[e], zr(e));
            });
          }
        }, {
          key: "humicAcidLabel",
          value: function () {
            var t = this.constructor.attributeDefinition.humicAcid;
            return u.nutrientLabelComponent(this[t.key], "HA");
          }
        }, {
          key: "label",
          get: function () {
            return "".concat(this.npkLabel(Math.floor).concat(this.metalsLabel()).concat(this.humicAcidLabel()).filter(Boolean).join("-"));
          }
        }, {
          key: "appliedNutrientKeys",
          get: function () {
            var t = this;
            return Object.keys(this).filter(function (e) {
              return Number(t[e]);
            });
          }
        }]) && Xp(e.prototype, r), n && Xp(e, n), u;
      }(_r(Go, zn)), nf(Hp.prototype, "label", [qt.computed], Object.getOwnPropertyDescriptor(Hp.prototype, "label"), Hp.prototype), nf(Hp.prototype, "appliedNutrientKeys", [qt.computed], Object.getOwnPropertyDescriptor(Hp.prototype, "appliedNutrientKeys"), Hp.prototype), Hp),
      lf = l(416),
      pf = l.n(lf);
    function ff(t) {
      return ff = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ff(t);
    }
    function sf(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function yf(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? sf(Object(r), !0).forEach(function (e) {
          gf(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : sf(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function bf(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function df(t, e, r) {
      return df = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = hf(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, df(t, e, r || t);
    }
    function mf(t, e) {
      return mf = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, mf(t, e);
    }
    function hf(t) {
      return hf = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, hf(t);
    }
    function gf(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Of(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var vf = (uf = cf = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && mf(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = hf(o);
          if (i) {
            var r = hf(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== ff(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.apply(this, arguments);
      }
      return e = u, n = [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/product/organic_listing";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = df(hf(u), "getAttributeDefinition", this).call(this);
          return yf(yf({}, t), {}, {
            schema: yf(yf({}, t.schema), {}, {
              defaultValue: this.schema
            }),
            type: yf(yf({}, t.type), {}, {
              defaultValue: this.type
            }),
            reference: {
              name: "Reference",
              key: "reference",
              type: "string"
            },
            agency: {
              name: "Agency",
              key: "agency",
              type: "string"
            },
            number: {
              name: "Number",
              key: "number",
              type: "string"
            },
            expires: {
              name: "Expires",
              key: "expires",
              type: "string"
            }
          });
        }
      }], (r = [{
        key: "isExpired",
        get: function () {
          return !!this.expires && new Date() > new Date(this.expires);
        }
      }, {
        key: "displayExpireDate",
        get: function () {
          return this.expires ? pf()(this.momentFriendlyDate, "YYYY-MM-DD").format("MMMM DD, YYYY") : "";
        }
      }, {
        key: "momentFriendlyDate",
        get: function () {
          return new Date(this.expires).toISOString();
        }
      }, {
        key: "update",
        value: function (t) {
          df(hf(u.prototype), "update", this).call(this, yf(yf({}, t), {}, {
            type: u.type
          }));
        }
      }]) && bf(e.prototype, r), n && bf(e, n), u;
    }(_r(Go, Tt, ar, Yt, Dn, zn)), gf(cf, "type", "IF2::Product::OrganicListing"), gf(cf, "schema", "if2/product/organic_listing/v1"), Of((of = uf).prototype, "isExpired", [qt.computed], Object.getOwnPropertyDescriptor(of.prototype, "isExpired"), of.prototype), Of(of.prototype, "displayExpireDate", [qt.computed], Object.getOwnPropertyDescriptor(of.prototype, "displayExpireDate"), of.prototype), Of(of.prototype, "momentFriendlyDate", [qt.computed], Object.getOwnPropertyDescriptor(of.prototype, "momentFriendlyDate"), of.prototype), Of(of.prototype, "update", [qt.action], Object.getOwnPropertyDescriptor(of.prototype, "update"), of.prototype), of);
    function jf(t) {
      return jf = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, jf(t);
    }
    function wf(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Pf(t, e) {
      return Pf = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Pf(t, e);
    }
    function _f(t) {
      return _f = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, _f(t);
    }
    var Sf,
      kf,
      Rf,
      Df = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Pf(t, e);
        }(u, t);
        var e,
          r,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = _f(o);
            if (i) {
              var r = _f(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== jf(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function u() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u), c.apply(this, arguments);
        }
        return e = u, n = [{
          key: "failureMessage",
          value: function (t, e) {
            var r;
            if (null != t && t.organic && (null === (r = e.product) || void 0 === r || !r.isOrganic)) return "".concat(e.product.name, " cannot be used on an organic recommendation");
          }
        }], (r = [{
          key: "failures",
          value: function (t) {
            var e = this,
              r = [];
            return t.productApplications.forEach(function (n) {
              var o = e.constructor.failureMessage(t, n);
              o && r.push(new oo({
                key: e.attribute,
                value: n,
                fullMessage: o
              }));
            }), r;
          }
        }]) && wf(e.prototype, r), n && wf(e, n), u;
      }(uo);
    function Af(t) {
      return Af = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Af(t);
    }
    function Ef(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Cf(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Ef(Object(r), !0).forEach(function (e) {
          Mf(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ef(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function xf(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Tf(t, e, r) {
      return Tf = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = zf(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Tf(t, e, r || t);
    }
    function Bf(t, e) {
      return Bf = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Bf(t, e);
    }
    function zf(t) {
      return zf = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, zf(t);
    }
    function Mf(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Nf(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var Ff = (Rf = kf = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Bf(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = zf(o);
          if (i) {
            var r = zf(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Af(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.apply(this, arguments);
      }
      return e = u, n = [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/product/crop_label";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = Tf(zf(u), "getAttributeDefinition", this).call(this);
          return Cf(Cf({}, t), {}, {
            schema: Cf(Cf({}, t.schema), {}, {
              defaultValue: this.schema
            }),
            type: Cf(Cf({}, t.type), {}, {
              defaultValue: this.type
            }),
            crop: {
              name: "Crop",
              key: "crop",
              type: "string"
            },
            applicationMethods: {
              name: "Application Method",
              key: "applicationMethods",
              type: "array"
            },
            phi: {
              name: "PHI",
              key: "phi",
              type: "model",
              modelClass: Do,
              defaultValue: new Do("")
            },
            rei: {
              name: "REI",
              key: "rei",
              type: "model",
              modelClass: Do,
              defaultValue: new Do("")
            },
            minSprayRate: {
              name: "Min. Spray Rate",
              key: "minSprayRate",
              type: "model",
              modelClass: Do,
              defaultValue: new Do("")
            },
            maxSprayRate: {
              name: "Max. Spray Rate",
              key: "maxSprayRate",
              type: "model",
              modelClass: Do,
              defaultValue: new Do("")
            },
            minTreatmentInterval: {
              name: "Min Treatment Interval",
              key: "minTreatmentInterval",
              type: "model",
              modelClass: Do,
              defaultValue: new Do("")
            },
            maxApplicationsPerYear: {
              name: "Max Applications Per Year",
              key: "maxApplicationsPerYear",
              type: "number"
            },
            maxPerApplication: {
              name: "Max Per Application",
              key: "maxPerApplication",
              type: "model",
              modelClass: Do,
              defaultValue: new Do("")
            },
            maxPerYear: {
              name: "Max Per Year",
              key: "maxPerYear",
              type: "model",
              modelClass: Do,
              defaultValue: new Do("")
            },
            productId: {
              name: "Product ID",
              key: "productId",
              type: "number"
            },
            specialConditions: {
              name: "Special Conditions",
              key: "specialConditions",
              type: "object"
            }
          });
        }
      }], (r = [{
        key: "hasMaxPerApplicationConstraint",
        get: function () {
          return Do.isQuantityTruthy(this.maxPerApplication);
        }
      }, {
        key: "satisfiesMaxPerApplicationConstraint",
        value: function (t) {
          return !this.hasMaxPerApplicationConstraint || !Do.isQuantityTruthy(t.rate) || (this.maxPerApplication.isCompatible(t.rate) ? t.rate.lte(this.maxPerApplication) : this.maxPerApplication.isCompatible(t.productPerAcre) ? !t.gallonsPerAcre || t.productPerAcre.lte(this.maxPerApplication) : !this.maxPerApplication.isCompatible(t.productPerVolume) || !t.gallonsPerAcre || t.productPerVolume.lte(this.maxPerApplication));
        }
      }, {
        key: "update",
        value: function (t) {
          Tf(zf(u.prototype), "update", this).call(this, Cf(Cf({}, t), {}, {
            type: u.type
          }));
        }
      }]) && xf(e.prototype, r), n && xf(e, n), u;
    }(_r(Go, dt, Tt, ar, Yt, Dn, zn)), Mf(kf, "type", "IF2::Product::CropLabel"), Mf(kf, "schema", "if2/product/crop_label/v1"), Nf((Sf = Rf).prototype, "hasMaxPerApplicationConstraint", [qt.computed], Object.getOwnPropertyDescriptor(Sf.prototype, "hasMaxPerApplicationConstraint"), Sf.prototype), Nf(Sf.prototype, "update", [qt.action], Object.getOwnPropertyDescriptor(Sf.prototype, "update"), Sf.prototype), Sf);
    function If(t) {
      return If = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, If(t);
    }
    function Vf(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Lf(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Vf(Object(r), !0).forEach(function (e) {
          Jf(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Vf(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Yf(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function qf(t, e, r) {
      return qf = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Uf(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, qf(t, e, r || t);
    }
    function $f(t, e) {
      return $f = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, $f(t, e);
    }
    function Uf(t) {
      return Uf = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Uf(t);
    }
    function Jf(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var Gf,
      Hf,
      Qf,
      Kf = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && $f(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = Uf(n);
            if (o) {
              var r = Uf(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== If(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, r = [{
          key: "getSchemaId",
          value: function () {
            return "https://schemas.miriamtech.com/if2/product/attachment";
          }
        }, {
          key: "getAttributeDefinition",
          value: function () {
            var t = qf(Uf(c), "getAttributeDefinition", this).call(this);
            return Lf(Lf({}, t), {}, {
              schema: Lf(Lf({}, t.schema), {}, {
                defaultValue: this.schema
              }),
              type: Lf(Lf({}, t.type), {}, {
                defaultValue: this.type
              }),
              productId: {
                name: "Product ID",
                key: "productId",
                type: "string"
              },
              title: {
                name: "Title",
                key: "title",
                type: "string"
              },
              url: {
                name: "Url",
                key: "url",
                type: "string"
              },
              filename: {
                name: "Filename",
                key: "filename",
                type: "string"
              }
            });
          }
        }], null && Yf(e.prototype, null), r && Yf(e, r), c;
      }(_r(Go, Tt, Yt, Dn, zn, ar));
    function Wf(t) {
      return Wf = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Wf(t);
    }
    function Zf(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Xf(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Zf(Object(r), !0).forEach(function (e) {
          is(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Zf(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function ts(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    function es(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function rs(t, e, r) {
      return rs = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = os(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, rs(t, e, r || t);
    }
    function ns(t, e) {
      return ns = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ns(t, e);
    }
    function os(t) {
      return os = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, os(t);
    }
    function is(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function cs(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    Jf(Kf, "type", "IF2::Product::Attachment"), Jf(Kf, "schema", "if2/product/attachment/v1");
    var us = (Qf = Hf = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ns(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = os(o);
          if (i) {
            var r = os(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Wf(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.apply(this, arguments);
      }
      return e = u, r = [{
        key: "baseUnit",
        get: function () {
          return this.formulation && this.formulation.baseUnit;
        }
      }, {
        key: "baseUnitPerArea",
        get: function () {
          return "".concat(this.baseUnit, "/m^2");
        }
      }, {
        key: "baseUnitPerVolume",
        get: function () {
          return "".concat(this.baseUnit, "/L");
        }
      }, {
        key: "epaExempt",
        get: function () {
          return "Exempt" === this.epaNumber;
        }
      }, {
        key: "hasNutrientAnalysis",
        get: function () {
          return !!this.nutrientAnalysis;
        }
      }, {
        key: "nutrientAnalysisLabel",
        get: function () {
          return this.hasNutrientAnalysis ? this.nutrientAnalysis.label : "";
        }
      }, {
        key: "isActive",
        get: function () {
          return !this.inactive;
        }
      }, {
        key: "isRestricted",
        get: function () {
          return "restricted" === this.use;
        }
      }, {
        key: "rateUnitChoices",
        get: function () {
          var t = [],
            e = this.baseUnit || "",
            r = !e;
          if (t.push({
            group: "Standard",
            value: "".concat(e, "/acre")
          }), t.push({
            group: "Standard",
            value: "".concat(e, "/hgal"),
            displayName: "".concat(e, "/100 gal")
          }), !r) {
            var n = new Do(e),
              o = [];
            n.isCompatible(new Do("kg")) ? o = [{
              system: "US",
              numerators: ["oz", "lbs", "tn"],
              denominators: ["acre", "hgal"]
            }, {
              system: "Metric (SI)",
              numerators: ["grams", "kg"],
              denominators: ["hectare", "l"]
            }, {
              system: "Hybrid (US/Metric)",
              numerators: ["grams", "kg"],
              denominators: ["acre", "hgal"]
            }] : n.isCompatible(new Do("L")) && (o = [{
              system: "US",
              numerators: ["floz", "pt", "qt", "gal"],
              denominators: ["acre", "hgal"]
            }, {
              system: "Metric (SI)",
              numerators: ["ml", "l"],
              denominators: ["hectare"]
            }, {
              system: "Metric (SI)",
              numerators: ["ml"],
              denominators: ["l"]
            }, {
              system: "Hybrid (US/Metric)",
              numerators: ["ml", "l"],
              denominators: ["acre"]
            }, {
              system: "Hybrid (US/Metric)",
              numerators: ["ml"],
              denominators: ["gal", "hgal"]
            }]), o.forEach(function (r) {
              var n = r.system,
                o = r.numerators;
              r.denominators.forEach(function (r) {
                o.filter(function (t) {
                  return t !== e;
                }).forEach(function (e) {
                  var o = "".concat(e, "/").concat(r);
                  t.push({
                    group: n,
                    value: o,
                    displayName: Do.formatUnits(o)
                  });
                });
              });
            });
          }
          return t;
        }
      }, {
        key: "displayStateRegistration",
        get: function () {
          var t = this,
            e = "";
          return this.epaExempt && this.stateRegistration && Object.keys(this.stateRegistration).length > 0 && (e = Object.keys(this.stateRegistration).sort().map(function (e) {
            return "".concat(e.toUpperCase(), " ").concat(t.stateRegistration[e]);
          }).join(", ")), e;
        }
      }, {
        key: "searchText",
        get: function () {
          var t, e;
          return [].concat(this.name || []).concat(this.manufacturer || []).concat((null === (t = this.activeIngredients) || void 0 === t ? void 0 : t.map(function (t) {
            return t.name;
          })) || []).concat(this.alternateNames || []).concat(this.productType || []).concat((null === (e = this.formulation) || void 0 === e ? void 0 : e.description) || []).concat(this.epaNumber || []).concat(this.nutrientAnalysisLabel || []).join(" ").toLowerCase();
        }
      }, {
        key: "isOrganic",
        get: function () {
          return !!(this.organicListings && this.organicListings.length > 0);
        }
      }, {
        key: "limitedByEspp",
        get: function () {
          return this.activeIngredients.some(function (t) {
            return t.limitedByEspp;
          });
        }
      }, {
        key: "getPrimaryOrganicListing",
        value: function () {
          var t,
            e,
            r = this,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
              WSDA: 3,
              OMRI: 2,
              NOP: 1
            };
          if (this.isOrganic) {
            var o = (t = this.organicListings, e = 1, function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
              if (null != r) {
                var n,
                  o,
                  i = [],
                  c = !0,
                  u = !1;
                try {
                  for (r = r.call(t); !(c = (n = r.next()).done) && (i.push(n.value), !e || i.length !== e); c = !0);
                } catch (t) {
                  u = !0, o = t;
                } finally {
                  try {
                    c || null == r.return || r.return();
                  } finally {
                    if (u) throw o;
                  }
                }
                return i;
              }
            }(t, e) || function (t, e) {
              if (t) {
                if ("string" == typeof t) return ts(t, e);
                var r = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ts(t, e) : void 0;
              }
            }(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }())[0];
            return this.organicListings.forEach(function (t) {
              r.constructor.getAgencyPriority(n, t.agency) > r.constructor.getAgencyPriority(n, o.agency) && (o = t);
            }), o;
          }
        }
      }, {
        key: "labelsForUseOn",
        value: function (t) {
          return this.constructor.labelsForUseOn(t, this.cropLabels);
        }
      }, {
        key: "isLabeledForUseOn",
        value: function (t) {
          return this.constructor.isLabeledForUseOn(t, this.cropLabels);
        }
      }, {
        key: "isForUseOn",
        value: function (t) {
          return this.constructor.isForUseOn(t, this.cropLabels, this.organic);
        }
      }, {
        key: "isLabeledFor",
        value: function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.constructor.isLabeledFor(this.cropLabels, t);
        }
      }, {
        key: "labelsMatching",
        value: function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.constructor.labelsMatching(this.cropLabels, t);
        }
      }, {
        key: "toJS",
        value: function () {
          var t,
            e = rs(os(u.prototype), "toJS", this).call(this);
          return e.mass_per_volume = e.mass_per_volume || (null === (t = this.massPerVolume) || void 0 === t ? void 0 : t.toJS()) || null, e;
        }
      }], n = [{
        key: "getSchemaId",
        value: function () {
          return "https://schemas.miriamtech.com/if2/product";
        }
      }, {
        key: "getAttributeDefinition",
        value: function () {
          var t = rs(os(u), "getAttributeDefinition", this).call(this);
          return Xf(Xf({}, t), {}, {
            schema: Xf(Xf({}, t.schema), {}, {
              defaultValue: this.schema
            }),
            type: Xf(Xf({}, t.type), {}, {
              defaultValue: this.type
            }),
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Pi,
              defaultValue: new Pi()
            },
            manufacturer: {
              name: "Manufacturer",
              key: "manufacturer",
              type: "string"
            },
            epaNumber: {
              name: "EPA Number",
              key: "epaNumber",
              type: "string"
            },
            signalWord: {
              name: "Signal Word",
              key: "signalWord",
              type: "string"
            },
            productType: {
              name: "Product Type",
              key: "productType",
              type: "string"
            },
            use: {
              name: "Use",
              key: "use",
              type: "string"
            },
            formulation: {
              name: "Formulation",
              key: "formulation",
              type: "model",
              modelClass: Jp,
              defaultValue: new Jp()
            },
            alternateNames: {
              name: "Alternate Name",
              key: "alternateNames",
              type: "array"
            },
            activeIngredients: {
              name: "Active Ingredient",
              key: "activeIngredients",
              type: "modelCollection",
              modelClass: Ui
            },
            nutrientAnalysis: {
              name: "Nutrient Analysis",
              key: "nutrientAnalysis",
              type: "model",
              modelClass: af
            },
            stateRegistration: {
              name: "State Registration",
              key: "stateRegistration",
              type: "object"
            },
            labelUrl: {
              name: "Label URL",
              key: "labelUrl",
              type: "string"
            },
            sdsUrl: {
              name: "SDS URL",
              key: "sdsUrl",
              type: "string"
            },
            beeHazard: {
              name: "Bee Hazard",
              key: "beeHazard",
              type: "string"
            },
            organic: {
              name: "Organic",
              key: "organic",
              type: "boolean"
            },
            organicListings: {
              name: "Organic Listing",
              key: "organicListings",
              type: "modelCollection",
              searchKey: "serial",
              modelClass: vf
            },
            notes: {
              name: "Notes",
              key: "notes",
              type: "string"
            },
            reviewedAt: {
              name: "Reviewed At",
              key: "reviewedAt",
              type: "string"
            },
            inactive: {
              name: "Inactive",
              key: "inactive",
              type: "boolean"
            },
            cropLabels: {
              name: "Crop Labels",
              key: "cropLabels",
              type: "modelCollection",
              modelClass: Ff
            },
            acheInhibitor: {
              name: "Ache Inhibitor",
              key: "acheInhibitor",
              type: "boolean"
            },
            targetRatesRequired: {
              name: "Target Rates Required",
              key: "targetRatesRequired",
              type: "boolean"
            },
            registrationNumber: {
              name: "Registration Number",
              key: "registrationNumber",
              type: "string"
            },
            massPerVolume: {
              name: "Weight Per Volume",
              key: "massPerVolume",
              type: "model",
              modelClass: Do
            },
            attachments: {
              name: "Attachments",
              key: "attachments",
              type: "modelCollection",
              modelClass: Kf
            }
          });
        }
      }, {
        key: "getAgencyPriority",
        value: function (t, e) {
          return t[e] || 0;
        }
      }, {
        key: "labelsMatching",
        value: function (t, e) {
          return t.filter(function (t) {
            return !(e.crop && t.crop !== e.crop || e.applicationMethod && t.applicationMethods && !t.applicationMethods.includes(e.applicationMethod));
          });
        }
      }, {
        key: "isLabeledFor",
        value: function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return !(0, De.isEmpty)(this.labelsMatching(t, e));
        }
      }, {
        key: "labelsForUseOn",
        value: function (t, e) {
          var r = this;
          return (0, De.isEmpty)(t.cropNames) ? this.labelsMatching(e, {
            applicationMethod: t.applicationMethod
          }) : (0, De.reduce)(function (n, o) {
            return n.concat(r.labelsMatching(e, {
              crop: o,
              applicationMethod: t.applicationMethod
            }));
          }, [], t.cropNames);
        }
      }, {
        key: "isLabeledForUseOn",
        value: function (t, e) {
          var r = this;
          return (0, De.isEmpty)(t.cropNames) ? !t.applicationMethod || this.isLabeledFor(e, {
            applicationMethod: t.applicationMethod
          }) : (0, De.all)(function (n) {
            return r.isLabeledFor(e, {
              crop: n,
              applicationMethod: t.applicationMethod
            });
          }, t.cropNames);
        }
      }, {
        key: "isForUseOn",
        value: function (t, e, r) {
          return !(t.organic && !r) && this.isLabeledForUseOn(t, e);
        }
      }], r && es(e.prototype, r), n && es(e, n), u;
    }(_r(Go, dt, _t, Tt, ar, Yt, Dn, zn)), is(Hf, "type", "IF2::Product"), is(Hf, "schema", "if2/product/v1"), is(Hf, "sortByName", function (t, e) {
      return Rr(t.name.toLowerCase(), e.name.toLowerCase());
    }), cs((Gf = Qf).prototype, "baseUnit", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "baseUnit"), Gf.prototype), cs(Gf.prototype, "baseUnitPerArea", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "baseUnitPerArea"), Gf.prototype), cs(Gf.prototype, "baseUnitPerVolume", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "baseUnitPerVolume"), Gf.prototype), cs(Gf.prototype, "epaExempt", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "epaExempt"), Gf.prototype), cs(Gf.prototype, "hasNutrientAnalysis", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "hasNutrientAnalysis"), Gf.prototype), cs(Gf.prototype, "nutrientAnalysisLabel", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "nutrientAnalysisLabel"), Gf.prototype), cs(Gf.prototype, "isActive", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "isActive"), Gf.prototype), cs(Gf.prototype, "isRestricted", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "isRestricted"), Gf.prototype), cs(Gf.prototype, "rateUnitChoices", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "rateUnitChoices"), Gf.prototype), cs(Gf.prototype, "displayStateRegistration", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "displayStateRegistration"), Gf.prototype), cs(Gf.prototype, "searchText", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "searchText"), Gf.prototype), cs(Gf.prototype, "isOrganic", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "isOrganic"), Gf.prototype), cs(Gf.prototype, "limitedByEspp", [qt.computed], Object.getOwnPropertyDescriptor(Gf.prototype, "limitedByEspp"), Gf.prototype), Gf);
    function as(t) {
      return as = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, as(t);
    }
    function ls(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function ps(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ls(Object(r), !0).forEach(function (e) {
          fs(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ls(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function fs(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function ss(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function ys(t, e, r) {
      return ys = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = ds(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, ys(t, e, r || t);
    }
    function bs(t, e) {
      return bs = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, bs(t, e);
    }
    function ds(t) {
      return ds = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, ds(t);
    }
    var ms,
      hs,
      gs,
      Os = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && bs(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = ds(n);
            if (o) {
              var r = ds(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== as(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, r = [{
          key: "getAttributeDefinition",
          value: function () {
            var t = ys(ds(c), "getAttributeDefinition", this).call(this);
            return ps(ps({}, t), {}, {
              type: ps(ps({}, t.type), {}, {
                defaultValue: "IF2::Product"
              })
            });
          }
        }, {
          key: "fromProduct",
          value: function (t) {
            return new c({
              id: t.id,
              serial: t.serial,
              name: t.name,
              type: t.type
            });
          }
        }, {
          key: "fromModel",
          value: function (t) {
            return this.fromProduct(t);
          }
        }], null && ss(e.prototype, null), r && ss(e, r), c;
      }(_r(Zo, Tt));
    function vs(t) {
      return vs = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, vs(t);
    }
    function js(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function ws(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? js(Object(r), !0).forEach(function (e) {
          Rs(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : js(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Ps(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function _s(t, e, r) {
      return _s = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = ks(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, _s(t, e, r || t);
    }
    function Ss(t, e) {
      return Ss = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Ss(t, e);
    }
    function ks(t) {
      return ks = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, ks(t);
    }
    function Rs(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Ds(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var As,
      Es,
      Cs,
      xs = (gs = hs = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Ss(t, e);
        }(u, t);
        var e,
          r,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = ks(o);
            if (i) {
              var r = ks(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== vs(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function u() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u), c.apply(this, arguments);
        }
        return e = u, n = [{
          key: "getAttributeDefinition",
          value: function () {
            var t = _s(ks(u), "getAttributeDefinition", this).call(this);
            return ws(ws({}, t), {}, {
              id: ws(ws({}, t.id), {}, {
                defaultValue: (0, Ae.v4)()
              }),
              type: ws(ws({}, t.type), {}, {
                defaultValue: this.type
              }),
              product: {
                name: "Product",
                key: "product",
                type: "model",
                modelClass: us,
                defaultValue: new us()
              },
              rate: {
                name: "Rate",
                key: "rate",
                type: "model",
                modelClass: Do
              },
              target: {
                name: "Target",
                key: "target",
                type: "string"
              },
              position: {
                name: "Position",
                key: "position",
                type: "number"
              }
            });
          }
        }, {
          key: "from",
          value: function (t) {
            return new this(t);
          }
        }], (r = [{
          key: "isPerArea",
          get: function () {
            var t;
            return null === (t = this.rate) || void 0 === t ? void 0 : t.isCompatible(Do.toQty(this.product.baseUnitPerArea));
          }
        }, {
          key: "isPerVolume",
          get: function () {
            var t;
            return null === (t = this.rate) || void 0 === t ? void 0 : t.isCompatible(Do.toQty(this.product.baseUnitPerVolume));
          }
        }, {
          key: "isLiquid",
          get: function () {
            return new Do(this.product.baseUnit).isCompatible("L");
          }
        }, {
          key: "isDry",
          get: function () {
            return new Do(this.product.baseUnit).isCompatible("lbs");
          }
        }, {
          key: "productPerAcre",
          value: function (t) {
            if (this.isPerVolume) {
              if (!Do.isQuantityTruthy(new Do(t))) throw new ct(this.product, this.rate);
              return this.rate.mul(t);
            }
            return this.rate;
          }
        }, {
          key: "poundsPerAcre",
          value: function (t) {
            if (this.isLiquid) {
              var e;
              if (!Do.isQuantityTruthy(new Do(null === (e = this.product) || void 0 === e ? void 0 : e.massPerVolume))) throw new X(this.product);
              return this.productPerAcre(t).mul(this.product.massPerVolume).to("lbs/acre");
            }
            if (this.isDry) return this.productPerAcre(t).to("lbs/acre");
            throw new J(this.product, '"lbs" or "L"');
          }
        }]) && Ps(e.prototype, r), n && Ps(e, n), u;
      }(_r(Go, dt, Tt, Yt)), Rs(hs, "type", "IF2::ProductApplicationBase"), Ds((ms = gs).prototype, "isPerArea", [qt.computed], Object.getOwnPropertyDescriptor(ms.prototype, "isPerArea"), ms.prototype), Ds(ms.prototype, "isPerVolume", [qt.computed], Object.getOwnPropertyDescriptor(ms.prototype, "isPerVolume"), ms.prototype), Ds(ms.prototype, "isLiquid", [qt.computed], Object.getOwnPropertyDescriptor(ms.prototype, "isLiquid"), ms.prototype), Ds(ms.prototype, "isDry", [qt.computed], Object.getOwnPropertyDescriptor(ms.prototype, "isDry"), ms.prototype), ms);
    function Ts(t) {
      return Ts = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ts(t);
    }
    function Bs(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function zs(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Bs(Object(r), !0).forEach(function (e) {
          Ls(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Bs(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Ms(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Ns(t, e, r) {
      return Ns = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Vs(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Ns(t, e, r || t);
    }
    function Fs(t, e) {
      return Fs = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Fs(t, e);
    }
    function Is(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function Vs(t) {
      return Vs = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Vs(t);
    }
    function Ls(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Ys(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var qs,
      $s,
      Us,
      Js = (Cs = Es = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Fs(t, e);
        }(u, t);
        var e,
          r,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = Vs(o);
            if (i) {
              var r = Vs(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Ts(e) && "function" != typeof e ? Is(t) : e;
            }(this, t);
          });
        function u() {
          var t;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u);
          for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
          return Ls(Is(t = c.call.apply(c, [this].concat(r))), "validations", [new To("product"), new Fo("rate", {
            gt: 0
          })]), t;
        }
        return e = u, r = [{
          key: "name",
          get: function () {
            var t;
            return (null === (t = this.product) || void 0 === t ? void 0 : t.name) || "";
          }
        }, {
          key: "cropLabels",
          get: function () {
            var t = this,
              e = this.product.cropLabels.filter(function (e) {
                return t.cropNames.includes(e.crop);
              });
            return this.applicationMethod ? e.filter(function (e) {
              return e.applicationMethods.length < 1 || e.applicationMethods.includes(t.applicationMethod);
            }) : e;
          }
        }, {
          key: "phi",
          get: function () {
            return this.cropLabels.reduce(function (t, e) {
              return !e.phi || !e.phi.toJS() || t && t.toJS() && t.gte(e.phi) ? t : e.phi;
            }, new Do(""));
          }
        }, {
          key: "rei",
          get: function () {
            return this.cropLabels.reduce(function (t, e) {
              return !e.rei || !e.rei.toJS() || t && t.toJS() && t.gte(e.rei) ? t : e.rei;
            }, new Do(""));
          }
        }, {
          key: "setProduct",
          value: function (t) {
            var e,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            this.update({
              product: t.toJS()
            }), t && (null !== (e = this.rate) && void 0 !== e && e.units && !Do.isCompatible(this.rate.units.split("/")[0], t.baseUnit) && (this.rate.units = ""), r && (this.notes = r.text));
          }
        }, {
          key: "isOrganic",
          get: function () {
            var t;
            return null === (t = this.product) || void 0 === t ? void 0 : t.isOrganic;
          }
        }], n = [{
          key: "getSchemaId",
          value: function () {
            return "https://schemas.miriamtech.com/if2/recommendation/product_application";
          }
        }, {
          key: "getAttributeDefinition",
          value: function () {
            var t = Ns(Vs(u), "getAttributeDefinition", this).call(this);
            return zs(zs({}, t), {}, {
              schema: zs(zs({}, t.schema), {}, {
                defaultValue: this.schema
              }),
              type: zs(zs({}, t.type), {}, {
                defaultValue: this.type
              }),
              applicationMethod: {
                name: "Application Method",
                key: "applicationMethod",
                type: "string"
              },
              cropNames: {
                name: "Crop Names",
                key: "cropNames",
                type: "array"
              },
              notes: {
                name: "Notes",
                key: "notes",
                type: "string"
              }
            });
          }
        }], r && Ms(e.prototype, r), n && Ms(e, n), u;
      }(_r(xs, ar, Dn, zn, Wr)), Ls(Es, "type", "IF2::Recommendation::ProductApplication"), Ls(Es, "schema", "if2/recommendation/product_application/v1"), Ys((As = Cs).prototype, "name", [qt.computed], Object.getOwnPropertyDescriptor(As.prototype, "name"), As.prototype), Ys(As.prototype, "cropLabels", [qt.computed], Object.getOwnPropertyDescriptor(As.prototype, "cropLabels"), As.prototype), Ys(As.prototype, "phi", [qt.computed], Object.getOwnPropertyDescriptor(As.prototype, "phi"), As.prototype), Ys(As.prototype, "rei", [qt.computed], Object.getOwnPropertyDescriptor(As.prototype, "rei"), As.prototype), Ys(As.prototype, "setProduct", [qt.action], Object.getOwnPropertyDescriptor(As.prototype, "setProduct"), As.prototype), Ys(As.prototype, "isOrganic", [qt.computed], Object.getOwnPropertyDescriptor(As.prototype, "isOrganic"), As.prototype), As);
    function Gs(t) {
      return Gs = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Gs(t);
    }
    function Hs(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Qs(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Hs(Object(r), !0).forEach(function (e) {
          ey(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Hs(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Ks(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Ws(t, e, r) {
      return Ws = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = ty(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Ws(t, e, r || t);
    }
    function Zs(t, e) {
      return Zs = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Zs(t, e);
    }
    function Xs(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function ty(t) {
      return ty = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, ty(t);
    }
    function ey(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function ry(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var ny = (Us = $s = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Zs(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = ty(o);
          if (i) {
            var r = ty(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Gs(e) && "function" != typeof e ? Xs(t) : e;
          }(this, t);
        });
      function u() {
        var t;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u);
        for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
        return ey(Xs(t = c.call.apply(c, [this].concat(r))), "unitLimit", .75), ey(Xs(t), "isMetric", function (t) {
          return ["mL", "L", "grams", "g", "kg"].includes(t);
        }), ey(Xs(t), "toLargeUnit", function (e) {
          var r = t.isMetric(e.units),
            n = e.isCompatible("lbs");
          return r && n ? e.to("kg") : r && !n ? e.to("L") : !r && n ? e.to("lbs") : r || n || !e.isCompatible("gal") ? e : e.to("gal");
        }), ey(Xs(t), "toSmallUnit", function (t) {
          var e;
          switch (t.units) {
            case "kg":
              e = "grams";
              break;
            case "L":
              e = "mL";
              break;
            case "lbs":
              e = "oz";
              break;
            case "gal":
              e = "floz";
              break;
            default:
              e = t.units;
          }
          return t.to(e);
        }), t;
      }
      return e = u, n = [{
        key: "getAttributeDefinition",
        value: function () {
          return Qs(Qs({}, Ws(ty(u), "getAttributeDefinition", this).call(this)), {}, {
            totalAcresScalar: {
              name: "Total Acres",
              key: "totalAcresScalar",
              type: "number"
            },
            gallonsPerAcre: {
              name: "Gallons Per Acre",
              key: "gallonsPerAcre",
              type: "string"
            },
            tankSize: {
              name: "Tank Size",
              key: "tankSize",
              type: "model",
              modelClass: Do,
              defaultValue: new Do("")
            },
            coverage: {
              name: "Coverage",
              key: "coverage",
              type: "number",
              defaultValue: 1
            }
          });
        }
      }], (r = [{
        key: "totalAcres",
        get: function () {
          return 0 === this.totalAcresScalar || this.totalAcresScalar ? new Do("".concat(this.totalAcresScalar, " acre")) : new Do("");
        }
      }, {
        key: "productTotalQuantity",
        get: function () {
          var t, e, r, n, o, i, c;
          return (0 === (null === (t = this.rate) || void 0 === t ? void 0 : t.scalar) || null !== (e = this.rate) && void 0 !== e && e.scalar) && (0 === (null === (r = this.totalAcres) || void 0 === r ? void 0 : r.scalar) || null !== (n = this.totalAcres) && void 0 !== n && n.scalar) ? (this.isPerArea && (o = null === (i = this.rate) || void 0 === i ? void 0 : i.mul(this.totalAcres)), this.isPerVolume && (o = null === (c = this.rate) || void 0 === c ? void 0 : c.mul(this.gallonsPerAcre).mul(this.totalAcres)), o ? (0 !== o.scalar && o.units && (o = this.toLargeUnit(o)).scalar < this.unitLimit && (o = this.toSmallUnit(o)), o.updateScalar(o.scalar * this.coverage), o) : new Do("")) : new Do("");
        }
      }, {
        key: "productPerAcre",
        get: function () {
          return this.isPerVolume ? this.rate.mul(this.gallonsPerAcre) : this.rate;
        }
      }, {
        key: "productPerVolume",
        get: function () {
          var t = new Do(this.gallonsPerAcre);
          return Do.isQuantityTruthy(t) ? this.isPerArea ? this.rate.div(t) : this.rate : new Do();
        }
      }, {
        key: "productTankAmount",
        get: function () {
          var t, e, r, n, o, i, c, u;
          if (0 !== (null === (t = this.rate) || void 0 === t ? void 0 : t.scalar) && (null === (e = this.rate) || void 0 === e || !e.scalar) || 0 !== (null === (r = this.tankSize) || void 0 === r ? void 0 : r.scalar) && (null === (n = this.tankSize) || void 0 === n || !n.scalar) || "1/acre" === (null === (o = this.rate) || void 0 === o ? void 0 : o.units) || "1/hgal" === (null === (i = this.rate) || void 0 === i ? void 0 : i.units)) return new Do("");
          if (this.isPerArea) {
            var a, l;
            if (Do.isZero(this.gallonsPerAcre)) return new Do("");
            u = null === (a = this.rate) || void 0 === a || null === (l = a.div(this.gallonsPerAcre)) || void 0 === l ? void 0 : l.mul(this.tankSize);
          }
          return this.isPerVolume && (u = this.rate.mul(this.tankSize)), u ? (u.isCompatible(null === (c = this.rate) || void 0 === c ? void 0 : c.numeratorUnits) && (u = u.to(this.rate.numeratorUnits)), u) : new Do("");
        }
      }, {
        key: "isPerArea",
        get: function () {
          var t, e;
          return null === (t = this.rate) || void 0 === t ? void 0 : t.isCompatible(Do.toQty(null === (e = this.product) || void 0 === e ? void 0 : e.baseUnitPerArea));
        }
      }, {
        key: "isPerVolume",
        get: function () {
          var t, e;
          return null === (t = this.rate) || void 0 === t ? void 0 : t.isCompatible(Do.toQty(null === (e = this.product) || void 0 === e ? void 0 : e.baseUnitPerVolume));
        }
      }]) && Ks(e.prototype, r), n && Ks(e, n), u;
    }(Js), ey($s, "type", "IF2::Recommendation::ProductApplicationCalculation"), ry((qs = Us).prototype, "totalAcres", [qt.computed], Object.getOwnPropertyDescriptor(qs.prototype, "totalAcres"), qs.prototype), ry(qs.prototype, "productTotalQuantity", [qt.computed], Object.getOwnPropertyDescriptor(qs.prototype, "productTotalQuantity"), qs.prototype), ry(qs.prototype, "productPerAcre", [qt.computed], Object.getOwnPropertyDescriptor(qs.prototype, "productPerAcre"), qs.prototype), ry(qs.prototype, "productPerVolume", [qt.computed], Object.getOwnPropertyDescriptor(qs.prototype, "productPerVolume"), qs.prototype), ry(qs.prototype, "productTankAmount", [qt.computed], Object.getOwnPropertyDescriptor(qs.prototype, "productTankAmount"), qs.prototype), ry(qs.prototype, "isPerArea", [qt.computed], Object.getOwnPropertyDescriptor(qs.prototype, "isPerArea"), qs.prototype), ry(qs.prototype, "isPerVolume", [qt.computed], Object.getOwnPropertyDescriptor(qs.prototype, "isPerVolume"), qs.prototype), qs);
    function oy(t) {
      return oy = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, oy(t);
    }
    function iy(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function cy(t, e) {
      return cy = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, cy(t, e);
    }
    function uy(t) {
      return uy = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, uy(t);
    }
    var ay = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && cy(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = uy(o);
          if (i) {
            var r = uy(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== oy(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.apply(this, arguments);
      }
      return e = u, n = [{
        key: "maxPerApplicationFailure",
        value: function (t, e) {
          var r = t.newCalculationFor(e);
          if (e.product && "function" == typeof e.product.labelsForUseOn) {
            var n = e.product.labelsForUseOn(t);
            if (e.rate.scalar && e.rate.units) {
              var o = n.filter(function (t) {
                return !t.satisfiesMaxPerApplicationConstraint(r);
              });
              return (0, De.isEmpty)(o) ? void 0 : "".concat(r.rate.displayValue, " exceeds the labeled max application rate for ").concat(e.product.name, ": ").concat(Tr(o.map(function (t) {
                return [t.crop, t.maxPerApplication.displayValue].join(" -> ");
              })));
            }
          }
        }
      }, {
        key: "cropAndMethodFailure",
        value: function (t, e) {
          if (e.product && "function" == typeof e.product.isLabeledForUseOn && !e.product.isLabeledForUseOn(t)) return "".concat(e.product.name, " is not labeled for the given crops and application method");
        }
      }, {
        key: "minSprayRateFailure",
        value: function (t, e) {
          var r,
            n = (null === (r = e.product) || void 0 === r ? void 0 : r.labelsForUseOn(t)) || [];
          if (Do.isQuantityTruthy(t.targetRate) && n.some(function (e) {
            return Do.isQuantityTruthy(e.minSprayRate) && t.targetRate.lt(e.minSprayRate);
          })) return "".concat(t.targetRate.displayValue, " is less than the minimimum required spray rate for ").concat(e.product.name);
        }
      }, {
        key: "maxSprayRateFailure",
        value: function (t, e) {
          var r,
            n = (null === (r = e.product) || void 0 === r ? void 0 : r.labelsForUseOn(t)) || [];
          if (Do.isQuantityTruthy(t.targetRate) && n.some(function (e) {
            return Do.isQuantityTruthy(e.maxSprayRate) && t.targetRate.gt(e.maxSprayRate);
          })) return "".concat(t.targetRate.displayValue, " is greater than the maximum required spray rate for ").concat(e.product.name);
        }
      }], (r = [{
        key: "failures",
        value: function (t) {
          var e = [];
          return e = (e = (e = (e = e.concat(this.cropAndMethodFailures(t))).concat(this.maxPerApplicationFailures(t))).concat(this.minSprayRateFailures(t))).concat(this.maxSprayRateFailures(t));
        }
      }, {
        key: "cropAndMethodFailures",
        value: function (t) {
          var e = this,
            r = [];
          return t.productApplications.forEach(function (n) {
            var o = e.constructor.cropAndMethodFailure(t, n);
            o && r.push(new oo({
              key: e.attribute,
              value: n,
              fullMessage: o
            }));
          }), r;
        }
      }, {
        key: "maxPerApplicationFailures",
        value: function (t) {
          var e = this,
            r = [];
          return t.productApplications.forEach(function (n) {
            var o = e.constructor.maxPerApplicationFailure(t, n);
            o && r.push(new oo({
              key: e.attribute,
              value: n,
              fullMessage: o
            }));
          }), r;
        }
      }, {
        key: "minSprayRateFailures",
        value: function (t) {
          var e = this,
            r = [];
          return t.productApplications.forEach(function (n) {
            var o = e.constructor.minSprayRateFailure(t, n);
            o && r.push(new oo({
              key: e.attribute,
              value: n,
              fullMessage: o
            }));
          }), r;
        }
      }, {
        key: "maxSprayRateFailures",
        value: function (t) {
          var e = this,
            r = [];
          return t.productApplications.forEach(function (n) {
            var o = e.constructor.maxSprayRateFailure(t, n);
            o && r.push(new oo({
              key: e.attribute,
              value: n,
              fullMessage: o
            }));
          }), r;
        }
      }]) && iy(e.prototype, r), n && iy(e, n), u;
    }(uo);
    function ly(t) {
      return ly = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ly(t);
    }
    function py(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function fy(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? py(Object(r), !0).forEach(function (e) {
          sy(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : py(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function sy(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function yy(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function by(t, e, r) {
      return by = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = my(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, by(t, e, r || t);
    }
    function dy(t, e) {
      return dy = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, dy(t, e);
    }
    function my(t) {
      return my = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, my(t);
    }
    var hy = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && dy(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = my(n);
          if (o) {
            var r = my(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== ly(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = by(my(c), "getAttributeDefinition", this).call(this);
          return fy(fy({}, t), {}, {
            type: fy(fy({}, t.type), {}, {
              defaultValue: "IF2::User"
            })
          });
        }
      }, {
        key: "fromUser",
        value: function (t) {
          return new c({
            id: t.id,
            serial: t.serial,
            type: t.type,
            name: t.name
          });
        }
      }, {
        key: "fromModel",
        value: function (t) {
          return this.fromUser(t);
        }
      }], null && yy(e.prototype, null), r && yy(e, r), c;
    }(_r(Zo, Tt));
    function gy(t) {
      return gy = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, gy(t);
    }
    function Oy(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function vy(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Oy(Object(r), !0).forEach(function (e) {
          jy(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Oy(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function jy(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function wy(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Py(t, e, r) {
      return Py = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Sy(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Py(t, e, r || t);
    }
    function _y(t, e) {
      return _y = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, _y(t, e);
    }
    function Sy(t) {
      return Sy = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Sy(t);
    }
    var ky = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && _y(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Sy(n);
          if (o) {
            var r = Sy(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== gy(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          return vy(vy({}, Py(Sy(c), "getAttributeDefinition", this).call(this)), {}, {
            licenses: {
              key: "licenses",
              type: "array"
            }
          });
        }
      }, {
        key: "fromUser",
        value: function (t) {
          return new c({
            id: t.id,
            serial: t.serial,
            type: t.type,
            name: t.name,
            licenses: t.licenses
          });
        }
      }, {
        key: "fromModel",
        value: function (t) {
          return this.fromUser(t);
        }
      }], null && wy(e.prototype, null), r && wy(e, r), c;
    }(hy);
    function Ry(t) {
      return Ry = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ry(t);
    }
    function Dy(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Ay(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Dy(Object(r), !0).forEach(function (e) {
          By(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Dy(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Ey(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Cy(t, e, r) {
      return Cy = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Ty(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Cy(t, e, r || t);
    }
    function xy(t, e) {
      return xy = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, xy(t, e);
    }
    function Ty(t) {
      return Ty = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Ty(t);
    }
    function By(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var zy = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && xy(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Ty(n);
          if (o) {
            var r = Ty(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Ry(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = Cy(Ty(c), "getAttributeDefinition", this).call(this);
          return Ay(Ay({}, t), {}, {
            type: Ay(Ay({}, t.type), {}, {
              defaultValue: this.type
            }),
            product: {
              name: "Product",
              key: "product",
              type: "model",
              modelClass: Os,
              defaultValue: new Os()
            },
            text: {
              name: "Text",
              key: "text",
              type: "string"
            },
            title: {
              name: "Title",
              key: "title",
              type: "string"
            },
            user: {
              name: "User",
              key: "user",
              type: "model",
              modelClass: ky,
              defaultValue: new ky()
            }
          });
        }
      }], null && Ey(e.prototype, null), r && Ey(e, r), c;
    }(_r(Go, dt, Yt, fe));
    By(zy, "type", "IF2::Product::RecommendationNote");
    var My = l(619),
      Ny = l.n(My);
    function Fy(t) {
      return Fy = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Fy(t);
    }
    function Iy(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Vy(t, e) {
      return Vy = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Vy(t, e);
    }
    function Ly(t) {
      return Ly = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Ly(t);
    }
    var Yy = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Vy(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Ly(o);
          if (i) {
            var r = Ly(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Fy(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.apply(this, arguments);
      }
      return e = u, n = [{
        key: "failureMessage",
        value: function (t, e) {
          return !t.organic && e.organic ? "".concat(e.name, " is an organic field and cannot be included on a non-organic recommendation") : !t.organic && e.transitional ? "".concat(e.name, " is a transitional field and cannot be included on a non-organic recommendation") : void 0;
        }
      }], (r = [{
        key: "failures",
        value: function (t) {
          var e = this,
            r = [];
          return t.fields.forEach(function (n) {
            var o = e.constructor.failureMessage(t, n);
            o && r.push(new oo({
              key: e.attribute,
              value: n,
              fullMessage: o
            }));
          }), r;
        }
      }]) && Iy(e.prototype, r), n && Iy(e, n), u;
    }(uo);
    function qy(t) {
      return qy = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, qy(t);
    }
    function $y(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Uy(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? $y(Object(r), !0).forEach(function (e) {
          Jy(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : $y(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Jy(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Gy(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Hy(t, e, r) {
      return Hy = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Ky(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Hy(t, e, r || t);
    }
    function Qy(t, e) {
      return Qy = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Qy(t, e);
    }
    function Ky(t) {
      return Ky = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Ky(t);
    }
    var Wy = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Qy(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Ky(n);
          if (o) {
            var r = Ky(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== qy(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = Hy(Ky(c), "getAttributeDefinition", this).call(this);
          return Uy(Uy({}, t), {}, {
            type: Uy(Uy({}, t.type), {}, {
              defaultValue: "IF2::Recommendation"
            }),
            date: {
              name: "Date",
              key: "date",
              type: "string"
            },
            accountId: {
              name: "Account Id",
              key: "accountId",
              type: "string"
            },
            status: {
              name: "Status",
              key: "status",
              type: "string"
            },
            accounts: {
              key: "accounts",
              type: "modelCollection",
              modelClass: ai
            },
            writtenById: {
              name: "Written By Id",
              key: "writtenById",
              type: "string"
            }
          });
        }
      }, {
        key: "isRecommendationReference",
        value: function (t) {
          return t instanceof c;
        }
      }, {
        key: "fromRecommendation",
        value: function (t) {
          return new this({
            id: t.id,
            serial: t.serial,
            type: t.type,
            name: t.title,
            date: t.date,
            account_id: t.account.id,
            status: t.status,
            accounts: t.accounts,
            written_by_id: t.writtenBy.id
          });
        }
      }, {
        key: "fromModel",
        value: function (t) {
          return this.fromRecommendation(t);
        }
      }], null && Gy(e.prototype, null), r && Gy(e, r), c;
    }(_r(Zo, Tt));
    function Zy(t) {
      return Zy = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Zy(t);
    }
    function Xy(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function tb(t, e) {
      return tb = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, tb(t, e);
    }
    function eb(t) {
      return eb = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, eb(t);
    }
    var rb = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && tb(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = eb(n);
          if (o) {
            var r = eb(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Zy(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, (r = [{
        key: "failureDescription",
        value: function (t) {
          var e = this.value(t);
          return this.options.optional && !e ? null : this.fails("gt", e) ? "must be greater than ".concat(this.options.gt) : this.fails("gte", e) ? "must be greater than or equal to ".concat(this.options.gte) : this.fails("lt", e) ? "must be less than ".concat(this.options.lt) : this.fails("lte", e) ? "must be less than or equal to ".concat(this.options.lte) : null;
        }
      }, {
        key: "failure",
        value: function (t) {
          var e = this.failureDescription(t);
          if (e) {
            var r = oo.newFrom(this, t);
            return r.description = this.options.description || e, r;
          }
        }
      }, {
        key: "fails",
        value: function (t, e) {
          if (!e) return !0;
          var r = this.options[t];
          return null != r && ("gt" === t ? !(e > r) : "gte" === t ? !(e >= r) : "lt" === t ? !(e < r) : "lte" === t ? !(e <= r) : void 0);
        }
      }]) && Xy(e.prototype, r), c;
    }(uo);
    function nb(t) {
      return nb = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, nb(t);
    }
    function ob(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function ib(t, e) {
      return ib = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ib(t, e);
    }
    function cb(t) {
      return cb = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, cb(t);
    }
    var ub = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ib(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = cb(n);
          if (o) {
            var r = cb(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== nb(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, (r = [{
        key: "failures",
        value: function (t) {
          var e = this,
            r = this.value(t);
          return Array.isArray(r) ? r.reduce(function (t, r) {
            return e.constructor.isValidatable(r) ? t.concat(r.failures().map(function (t) {
              return e.adopt(t);
            })) : t;
          }, []) : [];
        }
      }]) && ob(e.prototype, r), c;
    }(uo);
    function ab(t) {
      return ab = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ab(t);
    }
    function lb(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function pb(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? lb(Object(r), !0).forEach(function (e) {
          fb(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : lb(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function fb(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function sb(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function yb(t, e, r) {
      return yb = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = db(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, yb(t, e, r || t);
    }
    function bb(t, e) {
      return bb = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, bb(t, e);
    }
    function db(t) {
      return db = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, db(t);
    }
    var mb = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && bb(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = db(n);
          if (o) {
            var r = db(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== ab(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          return pb(pb({}, yb(db(c), "getAttributeDefinition", this).call(this)), {}, {
            by: {
              name: "By",
              key: "by",
              type: "model",
              modelClass: ky,
              defaultValue: new ky()
            },
            reason: {
              name: "Reason",
              key: "reason",
              type: "string"
            },
            at: {
              name: "At",
              key: "at",
              type: "string"
            }
          });
        }
      }, {
        key: "isReject",
        value: function (t) {
          return t instanceof c;
        }
      }], null && sb(e.prototype, null), r && sb(e, r), c;
    }(Go);
    function hb(t) {
      return hb = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, hb(t);
    }
    function gb(t) {
      var e = "function" == typeof Map ? new Map() : void 0;
      return gb = function (t) {
        if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
        var r;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== e) {
          if (e.has(t)) return e.get(t);
          e.set(t, n);
        }
        function n() {
          return Ob(t, arguments, wb(this).constructor);
        }
        return n.prototype = Object.create(t.prototype, {
          constructor: {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), jb(n, t);
      }, gb(t);
    }
    function Ob(t, e, r) {
      return Ob = vb() ? Reflect.construct : function (t, e, r) {
        var n = [null];
        n.push.apply(n, e);
        var o = new (Function.bind.apply(t, n))();
        return r && jb(o, r.prototype), o;
      }, Ob.apply(null, arguments);
    }
    function vb() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function jb(t, e) {
      return jb = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, jb(t, e);
    }
    function wb(t) {
      return wb = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, wb(t);
    }
    var Pb = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && jb(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = vb(), function () {
          var t,
            n = wb(e);
          if (r) {
            var o = wb(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== hb(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o(t) {
        var e;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), (e = n.call(this, "Missing weight per volume on ".concat(null == t ? void 0 : t.name))).product = t, e;
      }
      return o;
    }(gb(Error));
    function _b(t) {
      return _b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, _b(t);
    }
    function Sb(t) {
      var e = "function" == typeof Map ? new Map() : void 0;
      return Sb = function (t) {
        if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
        var r;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== e) {
          if (e.has(t)) return e.get(t);
          e.set(t, n);
        }
        function n() {
          return kb(t, arguments, Ab(this).constructor);
        }
        return n.prototype = Object.create(t.prototype, {
          constructor: {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), Db(n, t);
      }, Sb(t);
    }
    function kb(t, e, r) {
      return kb = Rb() ? Reflect.construct : function (t, e, r) {
        var n = [null];
        n.push.apply(n, e);
        var o = new (Function.bind.apply(t, n))();
        return r && Db(o, r.prototype), o;
      }, kb.apply(null, arguments);
    }
    function Rb() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function Db(t, e) {
      return Db = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Db(t, e);
    }
    function Ab(t) {
      return Ab = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Ab(t);
    }
    var Eb = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Db(t, e);
      }(o, t);
      var e,
        r,
        n = (e = o, r = Rb(), function () {
          var t,
            n = Ab(e);
          if (r) {
            var o = Ab(this).constructor;
            t = Reflect.construct(n, arguments, o);
          } else t = n.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== _b(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function o(t, e) {
        var r;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, o), (r = n.call(this, "Unknown unit '".concat(e, "' for ").concat(null == t ? void 0 : t.name))).product = t, r;
      }
      return o;
    }(Sb(Error));
    function Cb(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    var xb = function () {
      function t(e, r) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.productApplicationCalculation = e, this.map = r;
      }
      var e, r;
      return e = t, (r = [{
        key: "product",
        get: function () {
          return this.productApplicationCalculation.product;
        }
      }, {
        key: "rate",
        get: function () {
          return this.productApplicationCalculation.rate;
        }
      }, {
        key: "productPerAcre",
        get: function () {
          return this.productApplicationCalculation.productPerAcre;
        }
      }, {
        key: "isPerArea",
        get: function () {
          return this.productApplicationCalculation.isPerArea;
        }
      }, {
        key: "isPerVolume",
        get: function () {
          return this.productApplicationCalculation.isPerVolume;
        }
      }, {
        key: "isLiquid",
        get: function () {
          return new Do(this.product.baseUnit).isCompatible("L");
        }
      }, {
        key: "isDry",
        get: function () {
          return new Do(this.product.baseUnit).isCompatible("lbs");
        }
      }, {
        key: "isIncalculable",
        get: function () {
          return !this.product || !this.product.hasNutrientAnalysis || !Do.isQuantityTruthy(this.productPerAcre);
        }
      }, {
        key: "appliedNutrientKeys",
        get: function () {
          return this.product.nutrientAnalysis.appliedNutrientKeys;
        }
      }, {
        key: "checkForNutrientError",
        value: function () {
          var t = !1;
          return this.product.baseUnit || (this.addNutrientError(new I(this.product)), t = !0), this.isLiquid && !Do.isQuantityTruthy(this.product.massPerVolume) && (this.addNutrientError(new Pb(this.product)), t = !0), (this.isPerVolume || this.isPerArea) && (this.isLiquid || this.isDry) || (this.addNutrientError(new Eb(this.product, this.rate.units)), t = !0), t;
        }
      }, {
        key: "addNutrientError",
        value: function (t) {
          return this.map.has("incompleteAnalysis") ? this.map.get("incompleteAnalysis").push(t) : this.map.set("incompleteAnalysis", [t]), this.map;
        }
      }, {
        key: "addNutrient",
        value: function (t, e) {
          this.map.has(t) ? this.map.set(t, this.map.get(t).add(e)) : this.map.set(t, e);
        }
      }, {
        key: "addDryProductNutrients",
        value: function (t) {
          var e = this.productPerAcre.mul(Number(this.product.nutrientAnalysis[t]) / 100).to("lbs/acre");
          this.addNutrient(t, e);
        }
      }, {
        key: "addLiquidProductNutrients",
        value: function (t) {
          var e = this.productPerAcre.mul(this.product.massPerVolume).mul(Number(this.product.nutrientAnalysis[t]) / 100).to("lbs/acre");
          this.addNutrient(t, e);
        }
      }]) && Cb(e.prototype, r), t;
    }();
    function Tb(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    var Bb = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.productApplicationCalculations = e, this.totals = this.constructor.getTotals(this.productApplicationCalculations);
      }
      var e, r;
      return e = t, r = [{
        key: "getTotals",
        value: function (t) {
          return t.reduce(function (t, e) {
            var r = new xb(e, t);
            return r.isIncalculable || r.checkForNutrientError() || r.appliedNutrientKeys.forEach(function (t) {
              r.isLiquid && r.addLiquidProductNutrients(t), r.isDry && r.addDryProductNutrients(t);
            }), t;
          }, new Map().set("n", new Do("0 lbs/acre")).set("p", new Do("0 lbs/acre")).set("k", new Do("0 lbs/acre")));
        }
      }], null && Tb(e.prototype, null), r && Tb(e, r), t;
    }();
    function zb(t) {
      return zb = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, zb(t);
    }
    function Mb(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Nb(t, e) {
      return Nb = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Nb(t, e);
    }
    function Fb(t) {
      return Fb = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Fb(t);
    }
    var Ib = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Nb(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Fb(o);
          if (i) {
            var r = Fb(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== zb(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.apply(this, arguments);
      }
      return e = u, n = [{
        key: "failureMessage",
        value: function (t, e, r) {
          var n;
          if ((null === (n = e.product) || void 0 === n || !n.isOrganic) && r.transitional) return "".concat(e.product.name, ' cannot be used on transitional field "').concat(r.name, '"');
        }
      }], (r = [{
        key: "failures",
        value: function (t) {
          var e = this,
            r = [];
          return t.productApplications.forEach(function (n) {
            t.fields.forEach(function (o) {
              var i = e.constructor.failureMessage(t, n, o);
              i && r.push(new oo({
                key: e.attribute,
                value: n,
                fullMessage: i
              }));
            });
          }), r;
        }
      }]) && Mb(e.prototype, r), n && Mb(e, n), u;
    }(uo);
    function Vb(t) {
      return Vb = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Vb(t);
    }
    function Lb(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Yb(t, e) {
      return Yb = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Yb(t, e);
    }
    function qb(t) {
      return qb = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, qb(t);
    }
    var $b,
      Ub,
      Jb,
      Gb,
      Hb,
      Qb,
      Kb,
      Wb,
      Zb,
      Xb = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Yb(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = qb(n);
            if (o) {
              var r = qb(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Vb(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, (r = [{
          key: "failure",
          value: function (t) {
            var e = this.value(t);
            if (!this.options.onlyIf || this.options.onlyIf()) {
              var r = new Do(e);
              if (!Do.isQuantityTruthy(r)) return;
              if (!r.isCompatible(this.options.isCompatibleWith)) return this.options.description = "".concat(r.units, " is not compatible with ").concat(this.options.isCompatibleWith, "."), oo.newFrom(this, t);
            }
          }
        }]) && Lb(e.prototype, r), c;
      }(uo);
    function td(t) {
      return td = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, td(t);
    }
    function ed(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function rd(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ed(Object(r), !0).forEach(function (e) {
          sd(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ed(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function nd(t) {
      return function (t) {
        if (Array.isArray(t)) return id(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }(t) || od(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function od(t, e) {
      if (t) {
        if ("string" == typeof t) return id(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? id(t, e) : void 0;
      }
    }
    function id(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    function cd(t, e, r, n) {
      r && Object.defineProperty(t, e, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function ud(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function ad(t, e, r) {
      return ad = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = fd(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, ad(t, e, r || t);
    }
    function ld(t, e) {
      return ld = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ld(t, e);
    }
    function pd(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function fd(t) {
      return fd = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, fd(t);
    }
    function sd(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function yd(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var bd,
      dd,
      md,
      hd = (Zb = Wb = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && ld(t, e);
        }(u, t);
        var e,
          r,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = fd(o);
            if (i) {
              var r = fd(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== td(e) && "function" != typeof e ? pd(t) : e;
            }(this, t);
          });
        function u() {
          var t;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u);
          for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
          return sd(pd(t = c.call.apply(c, [this].concat(r))), "validations", [new To("documentNumber", {
            attributeLabel: "Document Number",
            fullMessage: "Document number has not yet been assigned. The recommendation must have synced with the server before a number can be assigned"
          }), new To("date"), new To("applicationMethod"), new To("targetRate", {
            onlyIf: function () {
              return t.constructor.requiresRate(t.applicationMethod);
            }
          }), new Df("productApplications"), new Ib("productApplications"), new ay("productApplications"), new rb("coverage", {
            gt: 0,
            lte: 1,
            description: "must be > 0 and <= 100"
          }), new ub("productApplications"), new Yy("fields"), new Xb("tankSize", {
            onlyIf: function () {
              return t.constructor.requiresTankSize(t.applicationMethod);
            },
            isCompatibleWith: "L"
          }), new Xb("targetRate", {
            onlyIf: function () {
              return t.constructor.requiresRate(t.applicationMethod);
            },
            isCompatibleWith: "L/acre"
          })]), cd(pd(t), "void", Ub, pd(t)), sd(pd(t), "findProductApplication", function (e) {
            return t.productApplications.find(function (t) {
              return t.id === e;
            });
          }), cd(pd(t), "pushProductApplication", Jb, pd(t)), cd(pd(t), "removeProductApplication", Gb, pd(t)), cd(pd(t), "moveProductApplication", Hb, pd(t)), cd(pd(t), "addField", Qb, pd(t)), cd(pd(t), "removeField", Kb, pd(t)), t;
        }
        return e = u, n = [{
          key: "getAttributeDefinition",
          value: function () {
            var t = ad(fd(u), "getAttributeDefinition", this).call(this);
            return rd(rd({}, t), {}, {
              type: rd(rd({}, t.type), {}, {
                defaultValue: this.type
              }),
              rev: {
                key: "rev",
                jsKey: "_rev",
                type: "string"
              },
              date: {
                name: "Date",
                key: "date",
                type: "string"
              },
              timing: {
                name: "Timing",
                key: "timing",
                type: "string"
              },
              writtenBy: {
                name: "Written By",
                key: "writtenBy",
                type: "model",
                modelClass: ky,
                defaultValue: new ky()
              },
              account: {
                name: "Account",
                key: "account",
                type: "model",
                modelClass: Pi,
                defaultValue: new Pi()
              },
              accounts: {
                name: "Accounts",
                key: "accounts",
                type: "modelCollection",
                modelClass: Pi
              },
              documentNumber: {
                name: "Document Number",
                key: "documentNumber",
                type: "string"
              },
              replaces: {
                name: "Replaces",
                key: "replaces",
                type: "model",
                modelClass: Wy
              },
              cropNames: {
                name: "Crop Names",
                key: "cropNames",
                type: "array"
              },
              organic: {
                name: "Organic",
                key: "organic",
                type: "boolean"
              },
              notes: {
                name: "Notes",
                key: "notes",
                type: "string"
              },
              targetRate: {
                name: "Target GPA",
                key: "targetRate",
                type: "model",
                modelClass: Do,
                defaultValue: new Do("")
              },
              targetGallonsPerAcre: {
                name: "Target GPA",
                key: "targetGallonsPerAcre",
                type: "model",
                modelClass: Do,
                defaultValue: new Do("")
              },
              productApplications: {
                name: "Product Application",
                key: "productApplications",
                type: "modelCollection",
                modelClass: Js
              },
              fields: {
                name: "Field",
                key: "fields",
                type: "modelCollection",
                modelClass: Op
              },
              status: {
                name: "Status",
                key: "status",
                type: "string",
                defaultValue: "draft"
              },
              tankSize: {
                name: "Tank Size",
                key: "tankSize",
                type: "model",
                modelClass: Do,
                defaultValue: new Do("")
              },
              optimumTemperature: {
                name: "Optimum Temperature",
                key: "optimumTemperature",
                type: "string"
              },
              areasToTreat: {
                name: "Areas To Treat",
                key: "areasToTreat",
                type: "string",
                defaultValue: this.areasToTreatOptions[0]
              },
              rejected: {
                name: "Rejected",
                key: "rejected",
                type: "model",
                modelClass: mb
              },
              coverage: {
                name: "Coverage",
                key: "coverage",
                type: "number",
                defaultValue: 1
              },
              showMapWhenPrinting: {
                key: "showMapWhenPrinting",
                type: "boolean"
              },
              showProductTotals: {
                name: "Show Product Totals",
                key: "showProductTotals",
                type: "boolean",
                defaultValue: !0
              },
              showNutrientTotals: {
                name: "Show Nutrient Totals",
                key: "showNutrientTotals",
                type: "boolean",
                defaultValue: !0
              },
              usePerAppliedAcreVerbiage: {
                name: "Use Per Applied Acre Verbiage",
                key: "usePerAppliedAcreVerbiage",
                type: "boolean"
              }
            });
          }
        }, {
          key: "isRecommendation",
          value: function (t) {
            return t instanceof u;
          }
        }, {
          key: "groupRecommendationsByAccount",
          value: function (t) {
            return (0, De.groupBy)(function (t) {
              var e;
              return null === (e = t.account) || void 0 === e ? void 0 : e.name;
            })(t);
          }
        }], (r = [{
          key: "associatedAccountIds",
          get: function () {
            var t;
            return pr([].concat((null === (t = this.account) || void 0 === t ? void 0 : t.id) || []).concat((this.accounts || []).map(function (t) {
              return t.id;
            })));
          }
        }, {
          key: "totalAcres",
          get: function () {
            return this.fields.reduce(function (t, e) {
              var r, n;
              return null != e && e.area.isCompatible("acre") && (n = null == e ? void 0 : e.area.to("acre")), t + ((null === (r = n) || void 0 === r ? void 0 : r.scalar) || 0);
            }, 0);
          }
        }, {
          key: "title",
          get: function () {
            return this.name || this.dateTitle;
          }
        }, {
          key: "dateTitle",
          get: function () {
            return pf()(this.date, ["M/D/YYYY", "YYYY-MM-DD"]).format("M/D/YYYY") || "";
          }
        }, {
          key: "updatedAtTitle",
          get: function () {
            return pf()(this.updatedAt, ["M/D/YYYY", "YYYY-MM-DD"]).format("M/D/YYYY") || "";
          }
        }, {
          key: "fieldAccounts",
          get: function () {
            return fr("id", this.fields.map(function (t) {
              return t.account;
            }));
          }
        }, {
          key: "maxPhi",
          get: function () {
            return Do.max.apply(Do, nd(this.productApplications.map(function (t) {
              return t.phi;
            })));
          }
        }, {
          key: "maxRei",
          get: function () {
            return Do.max.apply(Do, nd(this.productApplications.map(function (t) {
              return t.rei;
            })));
          }
        }, {
          key: "isComplete",
          get: function () {
            return "complete" === this.status;
          }
        }, {
          key: "isDraft",
          get: function () {
            return !this.status || "draft" === this.status;
          }
        }, {
          key: "isProvisional",
          get: function () {
            return !this.documentNumber;
          }
        }, {
          key: "isVoid",
          get: function () {
            return "void" === this.status || "replaced" === this.status;
          }
        }, {
          key: "isReplaced",
          get: function () {
            return "replaced" === this.status;
          }
        }, {
          key: "isRejected",
          get: function () {
            return mb.isReject(this.rejected);
          }
        }, {
          key: "isPendingApproval",
          get: function () {
            return "pending-approval" === this.status;
          }
        }, {
          key: "defaultFilename",
          get: function () {
            var t = "".concat(this.defaultFilenameBase, ".pdf");
            return Ny()(t, {
              replacement: "_"
            });
          }
        }, {
          key: "defaultFilenameBase",
          get: function () {
            var t;
            return [].concat(this.formatDate("YYYY-MM-DD") || []).concat((null === (t = this.account) || void 0 === t ? void 0 : t.name) || []).concat(this.name ? "- ".concat(this.name) : []).concat(this.isDraft ? "[Draft]" : []).concat("(".concat(this.documentNumber || "provisional", ")")).join(" ");
          }
        }, {
          key: "defaultFilenamePendingApproval",
          get: function () {
            var t = "".concat(this.defaultFilenameBase, " (pending approval).pdf");
            return Ny()(t, {
              replacement: "_"
            });
          }
        }, {
          key: "hasProductNotes",
          get: function () {
            return this.productApplications.filter(function (t) {
              return t.notes.trim().length > 0;
            }).length > 0;
          }
        }, {
          key: "productNotes",
          get: function () {
            return this.productApplications.map(function (t) {
              return t.notes;
            }).join("\n");
          }
        }, {
          key: "productApplicationCalculations",
          get: function () {
            var t = this;
            return (this.productApplications || []).map(function (e) {
              return t.newCalculationFor(e);
            });
          }
        }, {
          key: "currentCropNamesFromFields",
          get: function () {
            return pr((this.fields || []).map(function (t) {
              return t.cropName;
            }));
          }
        }, {
          key: "coveragePercentString",
          get: function () {
            return Br(this.coverage);
          }
        }, {
          key: "hasErrors",
          get: function () {
            return this.failures().length > 0;
          }
        }, {
          key: "nutrientTotals",
          get: function () {
            return Bb.getTotals(this.productApplicationCalculations);
          }
        }, {
          key: "hasNutrients",
          get: function () {
            return this.productApplications.some(function (t) {
              return t.product.hasNutrientAnalysis;
            });
          }
        }, {
          key: "newCalculationFor",
          value: function (t) {
            var e, r;
            return new ny(rd(rd({}, t.toJS()), {}, {
              tankSize: (null === (e = this.tankSize) || void 0 === e ? void 0 : e.toJS()) || "",
              totalAcresScalar: this.totalAcres,
              gallonsPerAcre: (null === (r = this.targetRate) || void 0 === r ? void 0 : r.displayValue) || "",
              coverage: this.coverage
            }));
          }
        }, {
          key: "fieldsForAccount",
          value: function (t) {
            return this.fields.filter(function (e) {
              return e.account.id === t.id;
            });
          }
        }, {
          key: "formatDate",
          value: function (t) {
            return pf()(this.date, ["M/D/YYYY", "YYYY-MM-DD"]).format(t);
          }
        }]) && ud(e.prototype, r), n && ud(e, n), u;
      }(_r(Go, dt, Tt, _t, Yt, ar, hn, Kt, Wr)), sd(Wb, "type", "IF2::Recommendation"), sd(Wb, "findAppOptionByText", function (t) {
        return Wb.applicationMethods.find(function (e) {
          return e.text === t;
        });
      }), sd(Wb, "areasToTreatOptions", ["See Block List"]), sd(Wb, "timingOptions", ["Today", "Next 7 Days", "Next 14 Days"]), sd(Wb, "optimumTemperatureOptions", ["35º - 85ºF", "40º - 75ºF", "40º - 80ºF", "45º - 75ºF", "45º - 80ºF"]), sd(Wb, "targetRateOptions", ["25", "50", "80", "100", "200", "400"]), sd(Wb, "tankSizeOptions", ["100", "150", "200", "300", "400", "500"]), sd(Wb, "draftFilter", function (t) {
        return (0, De.compose)((0, De.anyPass)([(0, De.equals)("draft"), De.isNil, De.isEmpty]), t("status"));
      }), sd(Wb, "rejectedFilter", function (t) {
        return (0, De.compose)((0, De.anyPass)([(0, De.is)(Object), (0, De.is)(String)]), t("rejected"));
      }), sd(Wb, "statusFilter", (0, De.curry)(function (t, e) {
        return (0, De.compose)((0, De.equals)(t), e("status"));
      })), sd(Wb, "voidFilter", function (t) {
        return (0, De.compose)((0, De.anyPass)([(0, De.equals)("void"), (0, De.equals)("replaced")]), t("status"));
      }), Ub = yd(($b = Zb).prototype, "void", [qt.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), yd($b.prototype, "associatedAccountIds", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "associatedAccountIds"), $b.prototype), yd($b.prototype, "totalAcres", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "totalAcres"), $b.prototype), yd($b.prototype, "title", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "title"), $b.prototype), yd($b.prototype, "dateTitle", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "dateTitle"), $b.prototype), yd($b.prototype, "updatedAtTitle", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "updatedAtTitle"), $b.prototype), yd($b.prototype, "fieldAccounts", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "fieldAccounts"), $b.prototype), yd($b.prototype, "maxPhi", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "maxPhi"), $b.prototype), yd($b.prototype, "maxRei", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "maxRei"), $b.prototype), yd($b.prototype, "isComplete", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "isComplete"), $b.prototype), yd($b.prototype, "isDraft", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "isDraft"), $b.prototype), yd($b.prototype, "isProvisional", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "isProvisional"), $b.prototype), yd($b.prototype, "isVoid", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "isVoid"), $b.prototype), yd($b.prototype, "isReplaced", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "isReplaced"), $b.prototype), yd($b.prototype, "isRejected", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "isRejected"), $b.prototype), yd($b.prototype, "isPendingApproval", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "isPendingApproval"), $b.prototype), yd($b.prototype, "defaultFilename", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "defaultFilename"), $b.prototype), yd($b.prototype, "defaultFilenameBase", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "defaultFilenameBase"), $b.prototype), yd($b.prototype, "defaultFilenamePendingApproval", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "defaultFilenamePendingApproval"), $b.prototype), yd($b.prototype, "hasProductNotes", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "hasProductNotes"), $b.prototype), yd($b.prototype, "productNotes", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "productNotes"), $b.prototype), yd($b.prototype, "productApplicationCalculations", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "productApplicationCalculations"), $b.prototype), yd($b.prototype, "currentCropNamesFromFields", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "currentCropNamesFromFields"), $b.prototype), yd($b.prototype, "coveragePercentString", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "coveragePercentString"), $b.prototype), yd($b.prototype, "hasErrors", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "hasErrors"), $b.prototype), yd($b.prototype, "nutrientTotals", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "nutrientTotals"), $b.prototype), yd($b.prototype, "hasNutrients", [qt.computed], Object.getOwnPropertyDescriptor($b.prototype, "hasNutrients"), $b.prototype), Jb = yd($b.prototype, "pushProductApplication", [qt.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var t = this;
          return function (e) {
            var r = t.productApplications.find(function (t) {
              return t.id === e.id;
            });
            r ? r.update(e.toJS()) : t.productApplications.push(e);
          };
        }
      }), Gb = yd($b.prototype, "removeProductApplication", [qt.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var t = this;
          return function (e) {
            var r = t.productApplications.findIndex(function (t) {
              return t.id === e.id;
            });
            r < 0 || t.productApplications.splice(r, 1);
          };
        }
      }), Hb = yd($b.prototype, "moveProductApplication", [qt.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var t = this;
          return function (e, r) {
            var n,
              o,
              i = t.productApplications.findIndex(function (t) {
                return t.id === e.id;
              });
            if (!(i < 0 || r < 0 || i === r)) {
              var c = (n = t.productApplications.splice(i, 1), o = 1, function (t) {
                if (Array.isArray(t)) return t;
              }(n) || function (t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                  var n,
                    o,
                    i = [],
                    c = !0,
                    u = !1;
                  try {
                    for (r = r.call(t); !(c = (n = r.next()).done) && (i.push(n.value), !e || i.length !== e); c = !0);
                  } catch (t) {
                    u = !0, o = t;
                  } finally {
                    try {
                      c || null == r.return || r.return();
                    } finally {
                      if (u) throw o;
                    }
                  }
                  return i;
                }
              }(n, o) || od(n, o) || function () {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }())[0];
              if (c) {
                t.productApplications.splice(r, 0, c);
                var u = [];
                return t.productApplications.forEach(function (t, e) {
                  t.position !== e && (t.update({
                    position: e
                  }), u.push(t));
                }), u;
              }
            }
          };
        }
      }), Qb = yd($b.prototype, "addField", [qt.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var t = this;
          return function (e) {
            return t.fields.push(e);
          };
        }
      }), Kb = yd($b.prototype, "removeField", [qt.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var t = this;
          return function (e) {
            var r = t.fields.findIndex(function (t) {
              return t.id === e.id;
            });
            r < 0 || t.fields.splice(r, 1);
          };
        }
      }), $b);
    function gd(t) {
      return gd = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, gd(t);
    }
    function Od(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function vd(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Od(Object(r), !0).forEach(function (e) {
          Sd(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Od(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function jd(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function wd(t, e, r) {
      return wd = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = _d(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, wd(t, e, r || t);
    }
    function Pd(t, e) {
      return Pd = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Pd(t, e);
    }
    function _d(t) {
      return _d = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, _d(t);
    }
    function Sd(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var kd,
      Rd,
      Dd,
      Ad = (md = dd = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Pd(t, e);
        }(u, t);
        var e,
          r,
          n,
          o,
          i,
          c = (o = u, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = _d(o);
            if (i) {
              var r = _d(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== gd(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function u() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, u), c.apply(this, arguments);
        }
        return e = u, n = [{
          key: "getAttributeDefinition",
          value: function () {
            var t = wd(_d(u), "getAttributeDefinition", this).call(this);
            return vd(vd({}, t), {}, {
              type: vd(vd({}, t.type), {}, {
                defaultValue: this.type
              }),
              applicationId: {
                name: "Application ID",
                key: "applicationId",
                type: "number"
              },
              gallonsApplied: {
                name: "Gallons Applied",
                key: "gallonsApplied",
                type: "number"
              },
              sprayRate: {
                name: "Spray Rate",
                key: "sprayRate",
                type: "model",
                modelClass: Do
              },
              tanksCompleted: {
                name: "Tanks Completed",
                key: "tanksCompleted",
                type: "number"
              },
              tankCleaned: {
                name: "Tank Cleaned",
                key: "tankCleaned",
                type: "boolean"
              }
            });
          }
        }, {
          key: "gallonsPerAcreScalar",
          value: function (t) {
            return Do.isCompatible(t, "gal/acre") && new Do(t).to("gal/acre").scalar || null;
          }
        }, {
          key: "predictedAcresTreated",
          value: function (t, e) {
            var r = Do.isQuantityTruthy(new Do(t.sprayRate)) && this.gallonsPerAcreScalar(t.sprayRate) || parseFloat(e);
            return r && t.computedGallonsApplied ? t.computedGallonsApplied / r : 0;
          }
        }], (r = [{
          key: "computedGallonsApplied",
          get: function () {
            var t;
            if (this.gallonsApplied) return this.gallonsApplied;
            var e = new Do(this.tanksCompleted),
              r = new Do(null === (t = this.sprayer) || void 0 === t ? void 0 : t.tankSize);
            return Do.isQuantityTruthy(e) && this.tanksCompleted && Do.isQuantityTruthy(r) && r.isCompatible("gal") ? r.mul(e).to("gal").scalar : 0;
          }
        }, {
          key: "matchesTargetGallonsPerAcre",
          value: function (t) {
            return this.constructor.gallonsPerAcreScalar(this.sprayRate) === parseFloat(t);
          }
        }, {
          key: "warningTranslationKeysGiven",
          value: function (t) {
            var e,
              r = [];
            return this.sprayer && this.spreader && this.sprayer.id && this.spreader.id && r.push("this_applicator_has_both_sprayer_and_spreader"), this.sprayer && this.sprayer.id && ["Broadcast Spread"].includes(t) && r.push("applicator_has_a_sprayer_for_a_spreader_only_application_method"), this.spreader && this.spreader.id && ["Aerial", "Airblast", "Broadcast Spray", "Banded Spray"].includes(t) && r.push("applicator_has_a_spreader_for_a_sprayer_only_application_method"), null !== (e = this.tractor) && void 0 !== e && e.id || !["Airblast", "Broadcast Spray", "Banded Spray", "Subsurface Shank"].includes(t) || r.push("applicator_requires_a_tractor_for_this_application_method"), r;
          }
        }]) && jd(e.prototype, r), n && jd(e, n), u;
      }(_u), Sd(dd, "type", "IF2::SprayRecord::Applicator"), function (t, e, r, n, o) {
        var i = {};
        Object.keys(n).forEach(function (t) {
          i[t] = n[t];
        }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
          return n(t, e, r) || r;
        }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null);
      }((bd = md).prototype, "computedGallonsApplied", [qt.computed], Object.getOwnPropertyDescriptor(bd.prototype, "computedGallonsApplied"), bd.prototype), bd);
    function Ed(t) {
      return Ed = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ed(t);
    }
    function Cd(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function xd(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Cd(Object(r), !0).forEach(function (e) {
          Fd(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Cd(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Td(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    function Bd(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function zd(t, e, r) {
      return zd = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Nd(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, zd(t, e, r || t);
    }
    function Md(t, e) {
      return Md = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Md(t, e);
    }
    function Nd(t) {
      return Nd = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Nd(t);
    }
    function Fd(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function Id(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var Vd = (Dd = Rd = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Md(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Nd(o);
          if (i) {
            var r = Nd(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Ed(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function u() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.apply(this, arguments);
      }
      return e = u, n = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = zd(Nd(u), "getAttributeDefinition", this).call(this);
          return xd(xd({}, t), {}, {
            date: {
              name: "Date",
              key: "date",
              type: "string"
            },
            type: xd(xd({}, t.type), {}, {
              defaultValue: this.type
            }),
            sprayRecordId: {
              name: "Spray Record ID",
              key: "sprayRecordId",
              type: "number"
            },
            startTime: {
              name: "Start Time",
              key: "startTime",
              type: "string"
            },
            stopTime: {
              name: "Stop Time",
              key: "stopTime",
              type: "string"
            },
            windDirection: {
              name: "Wind Direction",
              key: "windDirection",
              type: "string"
            },
            temperatureUnits: {
              name: "Temperature Units",
              key: "temperatureUnits",
              type: "string",
              defaultValue: "F"
            },
            temperatureLow: {
              name: "Temperature Low",
              key: "temperatureLow",
              type: "string"
            },
            temperatureHigh: {
              name: "Temperature High",
              key: "temperatureHigh",
              type: "string"
            },
            lowWindSpeed: {
              name: "Low Wind Speed",
              key: "lowWindSpeed",
              type: "model",
              modelClass: Do
            },
            highWindSpeed: {
              name: "High Wind Speed",
              key: "highWindSpeed",
              type: "model",
              modelClass: Do
            },
            applicators: {
              name: "Applicator",
              key: "applicators",
              type: "modelCollection",
              modelClass: Ad
            },
            fieldCompletions: {
              name: "Field Completion",
              key: "fieldCompletions",
              type: "modelCollection",
              modelClass: Dp
            },
            gallonsAppliedOverride: {
              name: "Gallons Applied Override",
              key: "gallonsAppliedOverride",
              type: "string"
            }
          });
        }
      }, {
        key: "from",
        value: function (t) {
          return new this(t);
        }
      }, {
        key: "parseTime",
        value: function (t) {
          return pf()(t, ["h:mm a", "H:mm", "k:mm"]).format("HH:mm");
        }
      }, {
        key: "commonGallonsPerAcre",
        value: function (t) {
          var e, r, n;
          if (null === (e = t.applicators) || void 0 === e || !e.length) return null;
          var o = Ad.gallonsPerAcreScalar(null === (r = t.applicators[0]) || void 0 === r ? void 0 : r.sprayRate);
          return 1 === (null === (n = t.applicators) || void 0 === n ? void 0 : n.length) ? o : t.applicators.reduce(function (t, e) {
            var r = Ad.gallonsPerAcreScalar(null == e ? void 0 : e.sprayRate);
            return t && t === r && r || null;
          }, o);
        }
      }, {
        key: "predictedAcresRate",
        value: function (t, e) {
          return this.commonGallonsPerAcre(t) || e || 0;
        }
      }, {
        key: "predictedAcresTreated",
        value: function (t, e) {
          if (t.gallonsAppliedOverride) {
            var r = this.predictedAcresRate(t, e);
            return r ? t.totalGallonsApplied / r : 0;
          }
          return (0, De.compose)(De.sum, (0, De.map)(function (t) {
            return Ad.predictedAcresTreated(t, e);
          }))(t.applicators || []);
        }
      }, {
        key: "percentVarianceAcresTreated",
        value: function (t, e) {
          var r = this.predictedAcresTreated(t, e);
          return (t.totalTreatedAcres - r) / r * 100;
        }
      }], (r = [{
        key: "isOvernight",
        get: function () {
          var t = this.constructor.parseTime(this.startTime),
            e = this.constructor.parseTime(this.stopTime);
          return t && t > e;
        }
      }, {
        key: "windDirectionAndSpeed",
        get: function () {
          var t,
            e = Do.displayValue(this.lowWindSpeed),
            r = Do.displayValue(this.highWindSpeed);
          return e && r && e !== r ? t = "".concat(this.lowWindSpeed.scalar, "-").concat(this.highWindSpeed.scalar, " ").concat(this.highWindSpeed.units) : e ? t = e : r && (t = r), t ? this.windDirection && "0 mph" !== t ? "".concat(this.windDirection, " ").concat(t) : t : "";
        }
      }, {
        key: "totalGallonsApplied",
        get: function () {
          var t;
          return this.gallonsAppliedOverride ? parseFloat(this.gallonsAppliedOverride) : (null === (t = this.applicators.reduce(function (t, e) {
            return new Do(t).add("".concat(e.computedGallonsApplied, " gal")).to("gal");
          }, "0 gal")) || void 0 === t ? void 0 : t.scalar) || 0;
        }
      }, {
        key: "totalAcresCompleted",
        get: function () {
          return this.fieldCompletions.length < 1 ? 0 : this.fieldCompletions.reduce(function (t, e) {
            return t + parseFloat((null == e ? void 0 : e.acres) || 0);
          }, 0);
        }
      }, {
        key: "totalTreatedAcres",
        get: function () {
          return (0, De.compose)(De.sum, (0, De.map)((0, De.prop)("treatedAcres")))(this.fieldCompletions);
        }
      }, {
        key: "sprayRateOutliers",
        get: function () {
          var t;
          if (null === (t = this.applicators) || void 0 === t || !t.length) return [];
          var e = {};
          this.applicators.forEach(function (t) {
            var r = new Do(t.sprayRate),
              n = r.isBlank ? "empty" : r.displayValue;
            e[n] ? e[n] += 1 : e[n] = 1;
          });
          var r = Object.entries(e).reduce(function (t, e) {
            var r,
              n,
              o = (n = 2, function (t) {
                if (Array.isArray(t)) return t;
              }(r = e) || function (t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                  var n,
                    o,
                    i = [],
                    c = !0,
                    u = !1;
                  try {
                    for (r = r.call(t); !(c = (n = r.next()).done) && (i.push(n.value), !e || i.length !== e); c = !0);
                  } catch (t) {
                    u = !0, o = t;
                  } finally {
                    try {
                      c || null == r.return || r.return();
                    } finally {
                      if (u) throw o;
                    }
                  }
                  return i;
                }
              }(r, n) || function (t, e) {
                if (t) {
                  if ("string" == typeof t) return Td(t, e);
                  var r = Object.prototype.toString.call(t).slice(8, -1);
                  return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Td(t, e) : void 0;
                }
              }(r, n) || function () {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }()),
              i = o[0],
              c = o[1];
            return c > t.count && (t.rate = i, t.count = c), t;
          }, {
            rate: "",
            count: 0
          });
          return this.applicators.reduce(function (t, e) {
            var n = new Do(e.sprayRate);
            return n.isBlank ? (t.push("empty"), t) : (n.eq(new Do(r.rate)) || t.push(e.sprayRate.displayValue), t);
          }, []);
        }
      }]) && Bd(e.prototype, r), n && Bd(e, n), u;
    }(_r(Go, dt, Tt, Yt)), Fd(Rd, "type", "IF2::SprayRecord::Application"), Id((kd = Dd).prototype, "isOvernight", [qt.computed], Object.getOwnPropertyDescriptor(kd.prototype, "isOvernight"), kd.prototype), Id(kd.prototype, "windDirectionAndSpeed", [qt.computed], Object.getOwnPropertyDescriptor(kd.prototype, "windDirectionAndSpeed"), kd.prototype), Id(kd.prototype, "totalGallonsApplied", [qt.computed], Object.getOwnPropertyDescriptor(kd.prototype, "totalGallonsApplied"), kd.prototype), Id(kd.prototype, "totalAcresCompleted", [qt.computed], Object.getOwnPropertyDescriptor(kd.prototype, "totalAcresCompleted"), kd.prototype), Id(kd.prototype, "totalTreatedAcres", [qt.computed], Object.getOwnPropertyDescriptor(kd.prototype, "totalTreatedAcres"), kd.prototype), Id(kd.prototype, "sprayRateOutliers", [qt.computed], Object.getOwnPropertyDescriptor(kd.prototype, "sprayRateOutliers"), kd.prototype), kd);
    function Ld(t) {
      return Ld = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Ld(t);
    }
    function Yd(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function qd(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Yd(Object(r), !0).forEach(function (e) {
          Hd(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Yd(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function $d(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Ud(t, e, r) {
      return Ud = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Gd(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Ud(t, e, r || t);
    }
    function Jd(t, e) {
      return Jd = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Jd(t, e);
    }
    function Gd(t) {
      return Gd = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Gd(t);
    }
    function Hd(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var Qd = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Jd(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Gd(n);
          if (o) {
            var r = Gd(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Ld(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = Ud(Gd(c), "getAttributeDefinition", this).call(this);
          return qd(qd({}, t), {}, {
            type: qd(qd({}, t.type), {}, {
              defaultValue: this.type
            }),
            sprayRecordId: {
              name: "Spray Record ID",
              key: "sprayRecordId",
              type: "number"
            },
            phi: {
              name: "PHI",
              key: "phi",
              type: "model",
              modelClass: Do
            },
            rei: {
              name: "REI",
              key: "rei",
              type: "model",
              modelClass: Do
            },
            phiOverride: {
              name: "PHI Override",
              key: "phiOverride",
              type: "model",
              modelClass: Do
            },
            phiOverrideBy: {
              name: "PHI Overridden By",
              key: "phiOverrideBy",
              type: "string"
            },
            phiOverrideReason: {
              name: "PHI Override Reason",
              key: "phiOverrideReason",
              type: "string"
            },
            reiOverride: {
              name: "REI Override",
              key: "reiOverride",
              type: "model",
              modelClass: Do
            },
            reiOverrideBy: {
              name: "REI Overridden By",
              key: "reiOverrideBy",
              type: "string"
            },
            reiOverrideReason: {
              name: "REI Override Reason",
              key: "reiOverrideReason",
              type: "string"
            },
            total: {
              name: "Total",
              key: "total",
              type: "model",
              modelClass: Do
            }
          });
        }
      }], null && $d(e.prototype, null), r && $d(e, r), c;
    }(xs);
    function Kd(t) {
      return Kd = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Kd(t);
    }
    function Wd(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Zd(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Wd(Object(r), !0).forEach(function (e) {
          Xd(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Wd(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Xd(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function tm(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function em(t, e, r) {
      return em = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = nm(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, em(t, e, r || t);
    }
    function rm(t, e) {
      return rm = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, rm(t, e);
    }
    function nm(t) {
      return nm = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, nm(t);
    }
    Hd(Qd, "type", "IF2::SprayRecord::ProductApplication");
    var om,
      im,
      cm,
      um = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && rm(t, e);
        }(c, t);
        var e,
          r,
          n,
          o,
          i = (n = c, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = nm(n);
            if (o) {
              var r = nm(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return function (t, e) {
              return !e || "object" !== Kd(e) && "function" != typeof e ? function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              }(t) : e;
            }(this, t);
          });
        function c() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, c), i.apply(this, arguments);
        }
        return e = c, r = [{
          key: "getAttributeDefinition",
          value: function () {
            return Zd(Zd({}, em(nm(c), "getAttributeDefinition", this).call(this)), {}, {
              documentNumber: {
                name: "Document Number",
                key: "documentNumber",
                type: "string"
              },
              date: {
                name: "Date",
                key: "date",
                type: "string"
              },
              writtenBy: {
                name: "Written By",
                key: "writtenBy",
                type: "model",
                modelClass: ky,
                defaultValue: new ky()
              }
            });
          }
        }], null && tm(e.prototype, null), r && tm(e, r), c;
      }(_r(Go, dt, _t));
    function am(t) {
      return am = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, am(t);
    }
    function lm(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function pm(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? lm(Object(r), !0).forEach(function (e) {
          mm(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : lm(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function fm(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function sm(t, e, r) {
      return sm = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = dm(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, sm(t, e, r || t);
    }
    function ym(t, e) {
      return ym = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, ym(t, e);
    }
    function bm(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function dm(t) {
      return dm = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, dm(t);
    }
    function mm(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function hm(t, e, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (t) {
        i[t] = n[t];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(t, e, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(t, e, i), i = null), i;
    }
    var gm = (cm = im = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ym(t, e);
      }(u, t);
      var e,
        r,
        n,
        o,
        i,
        c = (o = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = dm(o);
          if (i) {
            var r = dm(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== am(e) && "function" != typeof e ? bm(t) : e;
          }(this, t);
        });
      function u() {
        var t;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, u);
        for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
        return mm(bm(t = c.call.apply(c, [this].concat(r))), "parseTime", function (t) {
          return pf()(t, ["h:mm a", "H:mm", "k:mm"]).format("HH:mm");
        }), t;
      }
      return e = u, n = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = sm(dm(u), "getAttributeDefinition", this).call(this);
          return pm(pm({}, t), {}, {
            type: pm(pm({}, t.type), {}, {
              defaultValue: this.type
            }),
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Pi
            },
            cropNames: {
              name: "Crop Names",
              key: "cropNames",
              type: "array"
            },
            organic: {
              name: "Organic",
              key: "organic",
              type: "boolean"
            },
            notes: {
              name: "Notes",
              key: "notes",
              type: "string"
            },
            targetGallonsPerAcre: {
              name: "Target GPA",
              key: "targetGallonsPerAcre",
              type: "number"
            },
            licensedApplicator: {
              name: "Licensed Applicator",
              key: "licensedApplicator",
              type: "model",
              modelClass: bu
            },
            fields: {
              name: "Field",
              key: "fields",
              type: "modelCollection",
              modelClass: Op
            },
            recommendation: {
              name: "Recommendation",
              key: "recommendation",
              type: "model",
              modelClass: um
            },
            complete: {
              name: "Complete",
              key: "complete",
              type: "boolean"
            },
            showFieldMap: {
              name: "Show Field Map",
              key: "showFieldMap",
              type: "boolean"
            },
            applications: {
              name: "Application",
              key: "applications",
              type: "modelCollection",
              modelClass: Vd
            },
            maxPhi: {
              name: "Max PHI",
              key: "maxPhi",
              type: "model",
              modelClass: Do
            },
            maxRei: {
              name: "Max REI",
              key: "maxRei",
              type: "model",
              modelClass: Do
            },
            productApplications: {
              name: "Product Application",
              key: "productApplications",
              type: "modelCollection",
              modelClass: Qd
            },
            targetCoveragePercentage: {
              name: "Target Coverage (%)",
              key: "targetCoveragePercentage",
              type: "number"
            },
            date: {
              name: "Date",
              key: "date",
              type: "string"
            }
          });
        }
      }, {
        key: "isSprayRecord",
        value: function (t) {
          return t instanceof u;
        }
      }], (r = [{
        key: "abbreviatedDateTitle",
        get: function () {
          var t = pf()().format("YYYY");
          if (this.dates.length <= 0) {
            if (!this.dateTitle) return "";
            var e = pf()(this.dateTitle, "M/D/YYYY");
            return e.format("YYYY") === t ? e.format("M/D") : e.format("M/D/YYYY");
          }
          var r = this.dates[0],
            n = r.format("YYYY"),
            o = n === t ? r.format("M/D") : r.format("M/D/YYYY"),
            i = this.dates[this.dates.length - 1],
            c = i.format("YYYY") === t ? i.format("M/D") : i.format("M/D/YYYY");
          return 1 === this.dates.length || o === c ? o : n === i.format("YYYY") ? "".concat(r.format("M/D"), " - ").concat(i.format("M/D")).concat(n !== t ? ", ".concat(n) : "") : "".concat(r.format("M/D/YYYY"), " - ").concat(i.format("M/D/YYYY"));
        }
      }, {
        key: "dates",
        get: function () {
          return this.sortedApplications.filter(function (t) {
            return t.date;
          }).map(function (t) {
            return pf()(t.date);
          });
        }
      }, {
        key: "dateTitle",
        get: function () {
          if (this.dates.length <= 0) return this.recommendation && this.recommendation.date && pf()(this.recommendation.date).format("M/D/YYYY") || "";
          var t = this.dates[0].format("M/D/YYYY"),
            e = this.dates[this.dates.length - 1].format("M/D/YYYY");
          return 1 === this.dates.length || t === e ? t : "".concat(t, " - ").concat(e);
        }
      }, {
        key: "fieldCompletionPercents",
        get: function () {
          var t = {};
          return this.fields.forEach(function (e) {
            t[e.id] = 0;
          }), this.applications.forEach(function (e) {
            e.fieldCompletions.forEach(function (e) {
              t[e.field.id] += Number(e.percentage);
            });
          }), t;
        }
      }, {
        key: "sortedApplications",
        get: function () {
          var t = this;
          return (this.applications || []).slice().sort(function (e, r) {
            var n = Rr(pf()(e.date).format("YYYYMMDD"), pf()(r.date).format("YYYYMMDD"));
            return 0 === n ? t.sortByStartTime(e, r) : n;
          });
        }
      }, {
        key: "title",
        get: function () {
          return this.name || this.abbreviatedDateTitle || (this.applicationMethod ? "".concat(this.applicationMethod, " Application") : "");
        }
      }, {
        key: "updatedAtDate",
        get: function () {
          return pf()(this.updatedAt, ["M/D/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD") || "";
        }
      }, {
        key: "updatedAtTitle",
        get: function () {
          return pf()(this.updatedAt, ["M/D/YYYY", "YYYY-MM-DD"]).format("M/D/YYYY") || "";
        }
      }, {
        key: "updatedTime",
        get: function () {
          return this.updatedAt && pf()(this.updatedAt).format("YYYY/MM/DD HH:mm:ss");
        }
      }, {
        key: "sortByStartTime",
        value: function (t, e) {
          var r = Rr(this.parseTime(t.startTime), this.parseTime(e.startTime));
          return 0 === r ? Rr(this.parseTime(t.stopTime), this.parseTime(e.stopTime)) : r;
        }
      }, {
        key: "findApplication",
        value: function (t) {
          return this.applications.find(function (e) {
            return e.serial === t;
          });
        }
      }, {
        key: "findProductApplication",
        value: function (t) {
          return this.productApplications.find(function (e) {
            return e.serial === t;
          });
        }
      }, {
        key: "moveProductApplication",
        value: function (t, e, r) {
          var n = this.findProductApplication(t);
          if (n) {
            var o = this.productApplications.findIndex(function (t) {
                return t.position === e;
              }),
              i = this.productApplications.findIndex(function (t) {
                return t.position === r;
              });
            this.productApplications.splice(o, 1), this.productApplications.splice(i, 0, n), this.updateProductApplicationPositions();
          }
        }
      }, {
        key: "removeApplication",
        value: function (t) {
          var e = this.applications.findIndex(function (e) {
            return e.serial === t;
          });
          e < 0 || this.applications.splice(e, 1);
        }
      }, {
        key: "removeProductApplication",
        value: function (t) {
          var e = this.productApplications.findIndex(function (e) {
            return e.serial === t;
          });
          e < 0 || (this.productApplications.splice(e, 1), this.updateProductApplicationPositions());
        }
      }, {
        key: "pushApplication",
        value: function (t) {
          return Or(this.applications, Vd.from.bind(Vd), t, {
            searchKey: "serial"
          });
        }
      }, {
        key: "updateProductApplicationPositions",
        value: function () {
          this.productApplications.forEach(function (t, e) {
            t.position !== e && t.update({
              position: e
            });
          });
        }
      }, {
        key: "updateProductApplication",
        value: function (t) {
          return Or(this.productApplications, Qd.from.bind(Qd), t, {
            searchKey: "serial"
          }), this.updateProductApplicationPositions(), this.productApplications;
        }
      }]) && fm(e.prototype, r), n && fm(e, n), u;
    }(_r(Go, dt, Tt, _t, Yt, ar, hn, Kt)), mm(im, "type", "IF2::SprayRecord"), hm((om = cm).prototype, "abbreviatedDateTitle", [qt.computed], Object.getOwnPropertyDescriptor(om.prototype, "abbreviatedDateTitle"), om.prototype), hm(om.prototype, "dates", [qt.computed], Object.getOwnPropertyDescriptor(om.prototype, "dates"), om.prototype), hm(om.prototype, "dateTitle", [qt.computed], Object.getOwnPropertyDescriptor(om.prototype, "dateTitle"), om.prototype), hm(om.prototype, "fieldCompletionPercents", [qt.computed], Object.getOwnPropertyDescriptor(om.prototype, "fieldCompletionPercents"), om.prototype), hm(om.prototype, "sortedApplications", [qt.computed], Object.getOwnPropertyDescriptor(om.prototype, "sortedApplications"), om.prototype), hm(om.prototype, "title", [qt.computed], Object.getOwnPropertyDescriptor(om.prototype, "title"), om.prototype), hm(om.prototype, "updatedAtDate", [qt.computed], Object.getOwnPropertyDescriptor(om.prototype, "updatedAtDate"), om.prototype), hm(om.prototype, "updatedAtTitle", [qt.computed], Object.getOwnPropertyDescriptor(om.prototype, "updatedAtTitle"), om.prototype), hm(om.prototype, "updatedTime", [qt.computed], Object.getOwnPropertyDescriptor(om.prototype, "updatedTime"), om.prototype), hm(om.prototype, "moveProductApplication", [qt.action], Object.getOwnPropertyDescriptor(om.prototype, "moveProductApplication"), om.prototype), hm(om.prototype, "removeApplication", [qt.action], Object.getOwnPropertyDescriptor(om.prototype, "removeApplication"), om.prototype), hm(om.prototype, "removeProductApplication", [qt.action], Object.getOwnPropertyDescriptor(om.prototype, "removeProductApplication"), om.prototype), hm(om.prototype, "pushApplication", [qt.action], Object.getOwnPropertyDescriptor(om.prototype, "pushApplication"), om.prototype), hm(om.prototype, "updateProductApplicationPositions", [qt.action], Object.getOwnPropertyDescriptor(om.prototype, "updateProductApplicationPositions"), om.prototype), hm(om.prototype, "updateProductApplication", [qt.action], Object.getOwnPropertyDescriptor(om.prototype, "updateProductApplication"), om.prototype), om);
    function Om(t) {
      return Om = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Om(t);
    }
    function vm(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function jm(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? vm(Object(r), !0).forEach(function (e) {
          km(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : vm(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function wm(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function Pm(t, e, r) {
      return Pm = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Sm(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, Pm(t, e, r || t);
    }
    function _m(t, e) {
      return _m = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, _m(t, e);
    }
    function Sm(t) {
      return Sm = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Sm(t);
    }
    function km(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    var Rm = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && _m(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Sm(n);
          if (o) {
            var r = Sm(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Om(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = Pm(Sm(c), "getAttributeDefinition", this).call(this);
          return jm(jm({}, t), {}, {
            type: jm(jm({}, t.type), {}, {
              defaultValue: this.type
            })
          });
        }
      }], null && wm(e.prototype, null), r && wm(e, r), c;
    }(_u);
    function Dm(t) {
      return Dm = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Dm(t);
    }
    function Am(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Em(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Am(Object(r), !0).forEach(function (e) {
          zm(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Am(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function Cm(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function xm(t, e, r) {
      return xm = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Bm(t)););
          return t;
        }(t, e);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, xm(t, e, r || t);
    }
    function Tm(t, e) {
      return Tm = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, Tm(t, e);
    }
    function Bm(t) {
      return Bm = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, Bm(t);
    }
    function zm(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    km(Rm, "type", "IF2::TeamApplicator");
    var Mm = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Tm(t, e);
      }(c, t);
      var e,
        r,
        n,
        o,
        i = (n = c, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
            e = Bm(n);
          if (o) {
            var r = Bm(this).constructor;
            t = Reflect.construct(e, arguments, r);
          } else t = e.apply(this, arguments);
          return function (t, e) {
            return !e || "object" !== Dm(e) && "function" != typeof e ? function (t) {
              if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return t;
            }(t) : e;
          }(this, t);
        });
      function c() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), i.apply(this, arguments);
      }
      return e = c, r = [{
        key: "getAttributeDefinition",
        value: function () {
          var t = xm(Bm(c), "getAttributeDefinition", this).call(this);
          return Em(Em({}, t), {}, {
            type: Em(Em({}, t.type), {}, {
              defaultValue: this.type
            }),
            account: {
              name: "Account",
              key: "account",
              type: "model",
              modelClass: Pi,
              defaultValue: new Pi()
            },
            applicators: {
              name: "Applicator",
              key: "applicators",
              type: "modelCollection",
              modelClass: Rm
            }
          });
        }
      }], null && Cm(e.prototype, null), r && Cm(e, r), c;
    }(_r(Go, dt, Tt, _t, Yt));
    zm(Mm, "type", "IF2::Team");
  })(), p;
})());